webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _app = __webpack_require__(66);
	
	_app.app.$mount('#app');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_ROOT = exports.API_ROOT = 'http://services.mnc.takemedia.pt/';
	var COACH_IMG_PATH = exports.COACH_IMG_PATH = API_ROOT + 'media/coach/';
	var COACH_SAVER_PATH = exports.COACH_SAVER_PATH = API_ROOT + 'media/screensaver/';
	var SLIDE_IMG_PATH = exports.SLIDE_IMG_PATH = API_ROOT + 'media/slide/';
	var BACKGROUND_IMG_PATH = exports.BACKGROUND_IMG_PATH = API_ROOT + 'media/background/';
	var EXTERIOR_IMG_PATH = exports.EXTERIOR_IMG_PATH = API_ROOT + 'media/exterior/';
	
	var CookieDomain = exports.CookieDomain =  true ? 'mnc.takemedia.pt' : '';
	
	var categories = {};
	categories.enqhistorico = 2;
	categories.cartecnica = 3;
	categories.ambepoca = 4;
	categories.eraumavez = 5;
	categories.panorama = 1;
	
	var MENUS = exports.MENUS = categories;
	
	var CONTENT_STATES = exports.CONTENT_STATES = [{ id: 1, name: 'Rascunho' }, { id: 2, name: 'Pendente' }, { id: 3, name: 'Publicado' }];
	
	var LANGUAGE_LIST = exports.LANGUAGE_LIST = [{ slug: 'pt', name: 'PT' }, { slug: 'en', name: 'EN' }, { slug: 'es', name: 'ES' }, { slug: 'fr', name: 'FR' }];
	
	var WHITE_COLOR = exports.WHITE_COLOR = {
	  hex: '#FFFFFF',
	  hsl: {
	    h: 0,
	    s: 0,
	    l: 1,
	    a: 1
	  },
	  hsv: {
	    h: 0,
	    s: 0,
	    v: 1,
	    a: 1
	  },
	  rgba: {
	    r: 255,
	    g: 255,
	    b: 255,
	    a: 1
	  },
	  a: 1
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(136),
	  /* template */
	  __webpack_require__(334),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_MOBILE = exports.SET_MOBILE = 'SET_MOBILE';
	var SET_NAVBAR = exports.SET_NAVBAR = 'SET_NAVBAR';
	
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	var USERINFO_SUCCESS = exports.USERINFO_SUCCESS = 'USERINFO_SUCCESS';
	var USERINFO_FAILURE = exports.USERINFO_FAILURE = 'USERINFO_FAILURE';
	var LOGOUT_USER = exports.LOGOUT_USER = 'LOGOUT_USER';
	var UPDATE_USER_SUCCESS = exports.UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
	
	var SHOW_NOTIFICATION = exports.SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
	var UNLOCK_NOTIFICATION = exports.UNLOCK_NOTIFICATION = 'UNLOCK_NOTIFICATION';
	var ADD_LOADING_BTN = exports.ADD_LOADING_BTN = 'ADD_LOADING_BTN';
	var REMOVE_LOADING_BTN = exports.REMOVE_LOADING_BTN = 'REMOVE_LOADING_BTN';
	
	var ADD_EVENT = exports.ADD_EVENT = 'ADD_EVENT';
	var UNLOCK_EVENT = exports.UNLOCK_EVENT = 'UNLOCK_EVENT';
	
	var COACH_LIST = exports.COACH_LIST = 'COACH_LIST';
	var GET_COACH_DATA = exports.GET_COACH_DATA = 'GET_COACH_DATA';
	var MENU_LIST = exports.MENU_LIST = 'MENU_LIST';
	
	var SLIDE_LIST = exports.SLIDE_LIST = 'SLIDE_LIST';
	
	var USER_LIST = exports.USER_LIST = 'USER_LIST';
	
	var GET_PANORAMA_DATA = exports.GET_PANORAMA_DATA = 'GET_PANORAMA_DATA';
	var GET_EXTERIOR_DATA = exports.GET_EXTERIOR_DATA = 'GET_EXTERIOR_DATA';
	
	var ACTIVATE_SCROLL = exports.ACTIVATE_SCROLL = 'ACTIVATE_SCROLL';
	var DEACTIVATE_SCROLL = exports.DEACTIVATE_SCROLL = 'DEACTIVATE_SCROLL';

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(213)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(137),
	  /* template */
	  __webpack_require__(323),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(239)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(141),
	  /* template */
	  __webpack_require__(349),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveCookie = saveCookie;
	exports.getCookie = getCookie;
	exports.removeCookie = removeCookie;
	exports.signIn = signIn;
	exports.signOut = signOut;
	exports.isLoggedIn = isLoggedIn;
	
	var _reactCookie = __webpack_require__(251);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookieConfig = {};
	if (_config.CookieDomain !== '') {
	  cookieConfig = { domain: _config.CookieDomain, path: '/' };
	} else {
	  cookieConfig = { domain: '', path: '/' };
	}
	
	function saveCookie(name, value) {
	  _reactCookie2.default.save(name, value, cookieConfig);
	}
	
	function getCookie(name) {
	  return _reactCookie2.default.load(name);
	}
	
	function removeCookie(name) {
	  _reactCookie2.default.remove(name, cookieConfig);
	}
	
	function signIn(token, username) {
	  _reactCookie2.default.remove('token', cookieConfig);
	  _reactCookie2.default.remove('username', cookieConfig);
	  _reactCookie2.default.save('token', token, cookieConfig);
	  _reactCookie2.default.save('username', username, cookieConfig);
	}
	
	function signOut() {
	  _reactCookie2.default.save('token', '', cookieConfig);
	  _reactCookie2.default.save('username', '', cookieConfig);
	}
	
	function isLoggedIn() {
	  return !!_reactCookie2.default.load('token');
	}

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(203)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(135),
	  /* template */
	  __webpack_require__(313),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(194)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(140),
	  /* template */
	  __webpack_require__(305),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(195)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(100),
	  /* template */
	  __webpack_require__(306),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(215)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(101),
	  /* template */
	  __webpack_require__(325),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(232)
	__webpack_require__(233)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(109),
	  /* template */
	  __webpack_require__(343),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(201)
	__webpack_require__(202)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(122),
	  /* template */
	  __webpack_require__(312),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(198)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(123),
	  /* template */
	  __webpack_require__(309),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(209)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(125),
	  /* template */
	  __webpack_require__(319),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(222)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(131),
	  /* template */
	  __webpack_require__(332),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(229)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(138),
	  /* template */
	  __webpack_require__(340),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(219)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(87),
	  /* template */
	  __webpack_require__(329),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resources = __webpack_require__(65);
	
	var resource = _interopRequireWildcard(_resources);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  localLogin: function localLogin(data) {
	    return resource.Authenticate(data);
	  },
	
	  getCoachList: function getCoachList() {
	    return resource.CoachResource.get(null);
	  },
	
	  saveCoach: function saveCoach(data) {
	    return resource.CoachResource.save(null, data);
	  },
	
	  getCoach: function getCoach(id) {
	    return resource.CoachResource.query({ id: id });
	  },
	
	  updateCoach: function updateCoach(id, data) {
	    return resource.CoachResource.update({ id: id }, data);
	  },
	
	  deleteCoach: function deleteCoach(id) {
	    return resource.CoachResource.delete({ id: id });
	  },
	
	  updateCoachScreensaver: function updateCoachScreensaver(data) {
	    return resource.CoachScreensaver(data);
	  },
	
	  updateCoachState: function updateCoachState(data) {
	    return resource.CoachState(data);
	  },
	
	  getCategoryList: function getCategoryList(id) {
	    return resource.ListCoachCategory(id);
	  },
	
	  categoryCoach: function categoryCoach(data) {
	    return resource.CoachCategory(data);
	  },
	
	  updateCategoryCoachState: function updateCategoryCoachState(data) {
	    return resource.updateCategoryCoachState(data);
	  },
	
	  categoryCoachRemove: function categoryCoachRemove(data) {
	    return resource.CoachCategoryRemove(data);
	  },
	
	  getSlideList: function getSlideList(data) {
	    return resource.SlideResource.get(data);
	  },
	
	  saveSlide: function saveSlide(data) {
	    return resource.SlideResource.save(null, data);
	  },
	
	  reorderSlides: function reorderSlides(data) {
	    return resource.reorderSlides(data);
	  },
	
	  updateSlide: function updateSlide(id, data) {
	    return resource.SlideResource.update({ id: id }, data);
	  },
	
	  deleteSlide: function deleteSlide(id) {
	    return resource.SlideResource.delete({ id: id });
	  },
	
	  updateSlideState: function updateSlideState(data) {
	    return resource.SlideState(data);
	  },
	
	  setSubSlideCategory: function setSubSlideCategory(data) {
	    return resource.setSubSlideCategory(data);
	  },
	  deleteSubSlideCategory: function deleteSubSlideCategory(data) {
	    return resource.deleteSubSlideCategory(data);
	  },
	  updateSubSlideCategory: function updateSubSlideCategory(data) {
	    return resource.updateSubSlideCategory(data);
	  },
	
	  getPanorama: function getPanorama(id) {
	    return resource.PanoramaResource.query({ id: id });
	  },
	
	  updatePanorama: function updatePanorama(id, data) {
	    return resource.PanoramaResource.update({ id: id }, data);
	  },
	
	  savePanoramaPoint: function savePanoramaPoint(data) {
	    return resource.PanoramaPointResource.save(null, data);
	  },
	
	  updatePanoramaPoint: function updatePanoramaPoint(id, data) {
	    return resource.PanoramaPointResource.update({ id: id }, data);
	  },
	
	  deletePanoramaPoint: function deletePanoramaPoint(id) {
	    return resource.PanoramaPointResource.delete({ id: id });
	  },
	
	  deletePanoramaCube: function deletePanoramaCube(id, position) {
	    return resource.PanoramaCubeResource.delete({ id: id, position: position });
	  },
	
	  getExteriorsList: function getExteriorsList(id, data) {
	    return resource.ExteriorResource.query({ id: id }, data);
	  },
	
	  saveExterior: function saveExterior(data) {
	    return resource.ExteriorResource.save(null, data);
	  },
	
	  getExterior: function getExterior(id) {
	    return resource.ExteriorResource.query({ id: id });
	  },
	
	  updateExterior: function updateExterior(id, data) {
	    return resource.ExteriorResource.update({ id: id }, data);
	  },
	
	  deleteExterior: function deleteExterior(id) {
	    return resource.ExteriorResource.delete({ id: id });
	  },
	
	  reorderExteriors: function reorderExteriors(data) {
	    return resource.reorderExteriors(data);
	  },
	
	  updateExteriorState: function updateExteriorState(data) {
	    return resource.ExteriorState(data);
	  },
	
	  getUserList: function getUserList() {
	    return resource.UserResource.get(null);
	  },
	
	  updateUser: function updateUser(id, data) {
	    return resource.UserResource.update({ id: id }, data);
	  },
	
	  saveUser: function saveUser(data) {
	    return resource.UserResource.save(null, data);
	  },
	
	  deleteUser: function deleteUser(id) {
	    return resource.UserResource.delete({ id: id });
	  }
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExteriorState = exports.reorderExteriors = exports.updateSubSlideCategory = exports.deleteSubSlideCategory = exports.setSubSlideCategory = exports.SlideState = exports.reorderSlides = exports.CoachCategoryRemove = exports.updateCategoryCoachState = exports.CoachCategory = exports.ListCoachCategory = exports.CoachState = exports.CoachScreensaver = exports.ExteriorResource = exports.PanoramaResource = exports.PanoramaCubeResource = exports.PanoramaPointResource = exports.SlideResource = exports.UserResource = exports.CoachResource = exports.AuthResource = exports.Authenticate = undefined;
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(63);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _config = __webpack_require__(3);
	
	var _cookies = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.options.crossOrigin = true;
	
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  request.headers = request.headers || {};
	  if ((0, _cookies.getCookie)('token')) {
	    request.url = request.url + '?token=' + (0, _cookies.getCookie)('token');
	  }
	  next(function (response) {
	    if ((response.status === 401 || response.status === 400) && response.data.error !== 'invalid_credentials') {
	      (0, _cookies.signOut)();
	
	      var redirect = window.store.state.route.fullPath;
	      if (redirect.includes('redirect=')) {
	        redirect = window.store.state.route.query.redirect;
	      }
	      window.router.push({
	        path: '/login',
	        query: { redirect: redirect }
	      });
	    }
	  });
	});
	
	var Authenticate = exports.Authenticate = function Authenticate(user) {
	  return _vue2.default.http.post(_config.API_ROOT + 'authenticate', user);
	};
	
	var AuthResource = exports.AuthResource = _vue2.default.resource(_config.API_ROOT + 'resource/authenticate');
	var CoachResource = exports.CoachResource = _vue2.default.resource(_config.API_ROOT + 'resource/coach{/id}');
	var UserResource = exports.UserResource = _vue2.default.resource(_config.API_ROOT + 'resource/users{/id}');
	var SlideResource = exports.SlideResource = _vue2.default.resource(_config.API_ROOT + 'resource/slide{/id}');
	var PanoramaPointResource = exports.PanoramaPointResource = _vue2.default.resource(_config.API_ROOT + 'resource/point{/id}');
	var PanoramaCubeResource = exports.PanoramaCubeResource = _vue2.default.resource(_config.API_ROOT + 'resource/panorama/cube{/id}');
	var PanoramaResource = exports.PanoramaResource = _vue2.default.resource(_config.API_ROOT + 'resource/panorama{/id}');
	var ExteriorResource = exports.ExteriorResource = _vue2.default.resource(_config.API_ROOT + 'resource/exterior{/id}');
	
	var CoachScreensaver = exports.CoachScreensaver = function CoachScreensaver(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/coach/' + data.id + '/screensaver', data.data);
	};
	var CoachState = exports.CoachState = function CoachState(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/coach/' + data.id + '/state', data.data);
	};
	var ListCoachCategory = exports.ListCoachCategory = function ListCoachCategory(id) {
	  return _vue2.default.http.get(_config.API_ROOT + 'resource/coach/' + id + '/category');
	};
	var CoachCategory = exports.CoachCategory = function CoachCategory(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/coach/' + data.coach_id + '/category', data);
	};
	var updateCategoryCoachState = exports.updateCategoryCoachState = function updateCategoryCoachState(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/coach/' + data.data.coach + '/category/state', data.data);
	};
	var CoachCategoryRemove = exports.CoachCategoryRemove = function CoachCategoryRemove(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/coach/' + data.coach_id + '/category/remove', data);
	};
	
	var reorderSlides = exports.reorderSlides = function reorderSlides(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/slide/reorder', data);
	};
	var SlideState = exports.SlideState = function SlideState(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/slide/' + data.id + '/state', data.data);
	};
	
	var setSubSlideCategory = exports.setSubSlideCategory = function setSubSlideCategory(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/subslide/category', data);
	};
	var deleteSubSlideCategory = exports.deleteSubSlideCategory = function deleteSubSlideCategory(data) {
	  return _vue2.default.http.delete(_config.API_ROOT + 'resource/subslide/category/' + data);
	};
	var updateSubSlideCategory = exports.updateSubSlideCategory = function updateSubSlideCategory(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/subslide/category/' + data.menu, data);
	};
	
	var reorderExteriors = exports.reorderExteriors = function reorderExteriors(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/exterior/reorder', data);
	};
	var ExteriorState = exports.ExteriorState = function ExteriorState(data) {
	  return _vue2.default.http.post(_config.API_ROOT + 'resource/exterior/' + data.id + '/state', data.data);
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = exports.router = exports.app = undefined;
	
	var _keys = __webpack_require__(42);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(63);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuexRouterSync = __webpack_require__(359);
	
	var _router = __webpack_require__(73);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(75);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _filters = __webpack_require__(70);
	
	var filters = _interopRequireWildcard(_filters);
	
	var _App = __webpack_require__(257);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueNprogress = __webpack_require__(357);
	
	var _vueNprogress2 = _interopRequireDefault(_vueNprogress);
	
	var _cookies = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueNprogress2.default);
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	var nprogress = new _vueNprogress2.default({ parent: '.nprogress-container' });
	
	_router2.default.beforeEach(function (to, from, next) {
	  if (to.meta.requiresAuth && !(0, _cookies.isLoggedIn)()) {
	    next({
	      path: '/login',
	      query: { redirect: to.fullPath }
	    });
	  } else {
	    next();
	  }
	});
	
	(0, _keys2.default)(filters).forEach(function (key) {
	  _vue2.default.filter(key, filters[key]);
	});
	
	var app = new _vue2.default({
	  router: _router2.default,
	  store: _store2.default,
	  nprogress: nprogress,
	
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	window.router = _router2.default;
	window.store = _store2.default;
	exports.app = app;
	exports.router = _router2.default;
	exports.store = _store2.default;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  props: {
	    card: Boolean,
	    visible: Boolean,
	    closable: Boolean,
	    transition: {
	      type: String,
	      default: 'fade'
	    }
	  },
	
	  data: function data() {
	    return {
	      show: this.visible
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      document.body.appendChild(_this.$el);
	    });
	  },
	  destroyed: function destroyed() {
	    this.$el.remove();
	  },
	
	
	  methods: {
	    afterLeave: function afterLeave() {
	      this.$destroy();
	    },
	    active: function active() {
	      this.show = true;
	    },
	    deactive: function deactive() {
	      this.show = false;
	    },
	    close: function close() {
	      this.deactive();
	    },
	    open: function open() {
	      this.active();
	    }
	  },
	
	  computed: {
	    enterClass: function enterClass() {
	      return this.transition + 'In';
	    },
	    leaveClass: function leaveClass() {
	      return this.transition + 'Out';
	    }
	  }
	
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinycolor = __webpack_require__(28);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _colorChange(data, oldHue) {
	  var alpha = data && data.a;
	  var color;
	
	  if (data && data.hsl) {
	    color = (0, _tinycolor2.default)(data.hsl);
	  } else if (data && data.hex && data.hex.length > 0) {
	    color = (0, _tinycolor2.default)(data.hex);
	  } else {
	    color = (0, _tinycolor2.default)(data);
	  }
	
	  if (color && (color._a === undefined || color._a === null)) {
	    color.setAlpha(alpha || 1);
	  }
	
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	
	  if (hsl.s === 0) {
	    hsl.h = data.h || oldHue || 0;
	    hsv.h = data.h || oldHue || 0;
	  }
	
	  return {
	    hsl: hsl,
	    hex: color.toHexString().toUpperCase(),
	    rgba: color.toRgb(),
	    hsv: hsv,
	    oldHue: data.h || oldHue || hsl.h,
	    source: data.source,
	    a: data.a || color.getAlpha()
	  };
	}
	
	exports.default = {
	  props: ['value'],
	  data: function data() {
	    return {
	      val: _colorChange(this.value)
	    };
	  },
	
	  computed: {
	    colors: {
	      get: function get() {
	        return this.val;
	      },
	      set: function set(newVal) {
	        this.val = newVal;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  watch: {
	    value: function value(newVal) {
	      this.val = _colorChange(newVal);
	    }
	  },
	  methods: {
	    colorChange: function colorChange(data, oldHue) {
	      this.oldHue = this.colors.hsl.h;
	      this.colors = _colorChange(data, oldHue || this.oldHue);
	    },
	    isValidHex: function isValidHex(hex) {
	      return (0, _tinycolor2.default)(hex).isValid();
	    },
	    simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	      var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
	      var checked = 0;
	      var passed = 0;
	
	      for (var i = 0; i < keysToCheck.length; i++) {
	        var letter = keysToCheck[i];
	        if (data[letter]) {
	          checked++;
	          if (!isNaN(data[letter])) {
	            passed++;
	          }
	        }
	      }
	
	      if (checked === passed) {
	        return data;
	      }
	    }
	  }
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(150);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'tooltip',
	  abstract: true,
	
	  props: {
	    type: String,
	    size: String,
	    always: Boolean,
	    noAnimate: Boolean,
	    rounded: Boolean,
	    label: {
	      type: String,
	      default: ''
	    },
	    placement: {
	      type: String,
	      default: 'bottom'
	    }
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return;
	    }
	
	    children = children.filter(function (c) {
	      return c.tag;
	    });
	
	    if (!children.length) {
	      return;
	    }
	
	    var rawChild = children[0];
	
	    rawChild.data.attrs = {
	      'aria-label': this.label
	    };
	
	    rawChild.data.class = (0, _classnames2.default)('tooltip', 'tooltip--' + this.placement, (_classNames = {}, (0, _defineProperty3.default)(_classNames, 'tooltip--' + this.type, this.type), (0, _defineProperty3.default)(_classNames, 'tooltip--' + this.size, this.size), (0, _defineProperty3.default)(_classNames, 'tooltip--rounded', this.rounded), (0, _defineProperty3.default)(_classNames, 'tooltip--always', this.always), (0, _defineProperty3.default)(_classNames, 'tooltip--no-animate', this.noAnimate), _classNames));
	
	    return rawChild;
	  },
	
	
	  watch: {
	    label: function label(val) {
	      this.$el.setAttribute('aria-label', val);
	    }
	  }
	
	};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createLogger;
	
	var _util = __webpack_require__(85);
	
	function createLogger() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$collapsed = _ref.collapsed,
	      collapsed = _ref$collapsed === undefined ? true : _ref$collapsed,
	      _ref$transformer = _ref.transformer,
	      transformer = _ref$transformer === undefined ? function (state) {
	    return state;
	  } : _ref$transformer,
	      _ref$mutationTransfor = _ref.mutationTransformer,
	      mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
	    return mut;
	  } : _ref$mutationTransfor;
	
	  return function (store) {
	    var prevState = (0, _util.deepCopy)(store.state);
	
	    store.subscribe(function (mutation, state) {
	      if (typeof console === 'undefined') {
	        return;
	      }
	      var nextState = (0, _util.deepCopy)(state);
	      var time = new Date();
	      var formattedTime = ' @ ' + pad(time.getHours(), 2) + ':' + pad(time.getMinutes(), 2) + ':' + pad(time.getSeconds(), 2) + '.' + pad(time.getMilliseconds(), 3);
	      var formattedMutation = mutationTransformer(mutation);
	      var message = 'mutation ' + mutation.type + formattedTime;
	      var startMessage = collapsed ? console.groupCollapsed : console.group;
	
	      try {
	        startMessage.call(console, message);
	      } catch (e) {
	        console.log(message);
	      }
	
	      console.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
	      console.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
	      console.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
	
	      try {
	        console.groupEnd();
	      } catch (e) {
	        console.log('—— log end ——');
	      }
	
	      prevState = nextState;
	    });
	  };
	}
	
	function repeat(str, times) {
	  return new Array(times + 1).join(str);
	}
	
	function pad(num, maxLength) {
	  return repeat('0', maxLength - num.toString().length) + num;
	}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function PanoramaCoaches(container, options) {
		this.cubeImages = ["blank.jpg", "blank.jpg", "blank.jpg", "blank.jpg", "blank.jpg", "blank.jpg"];
		this.hotspots = [];
		this.basePath = "";
		if (typeof options.basePath !== "undefined") this.basePath = options.basePath;
		this.titleSize = 3384;
	
		this.pano = null;
	
		this.pano2vrSkin = function (player, cocheObj, base) {
			var me = this;
			var flag = false;
			var nodeMarker = new Array();
			var activeNodeMarker = new Array();
			this.player = player;
			this.player.skinObj = this;
			this.divSkin = player.divSkin;
			var basePath = "";
			if (base == '?') {
				var scripts = document.getElementsByTagName('script');
				for (var i = 0; i < scripts.length; i++) {
					var src = scripts[i].src;
					if (src.indexOf('skin.js') >= 0) {
						var p = src.lastIndexOf('/');
						if (p >= 0) {
							basePath = src.substr(0, p + 1);
						}
					}
				}
			} else if (base) {
				basePath = base;
			}
			this.elementMouseDown = new Array();
			this.elementMouseOver = new Array();
			var cssPrefix = '';
			var domTransition = 'transition';
			var domTransform = 'transform';
			var prefixes = 'Webkit,Moz,O,ms,Ms'.split(',');
			var i;
			for (i = 0; i < prefixes.length; i++) {
				if (typeof document.body.style[prefixes[i] + 'Transform'] !== 'undefined') {
					cssPrefix = '-' + prefixes[i].toLowerCase() + '-';
					domTransition = prefixes[i] + 'Transition';
					domTransform = prefixes[i] + 'Transform';
				}
			}
	
			function SkinHotspotClass(skinObj, hotspot) {
				var me = this;
				var flag = false;
				this.player = skinObj.player;
				this.skin = skinObj;
				this.hotspot = hotspot;
				this.elementMouseDown = new Array();
				this.elementMouseOver = new Array();
				this.__div = document.createElement('div');
				this.__div.setAttribute('style', 'position:absolute; left:0px;top:0px;visibility: inherit;');
	
				this.findElements = function (id, regex) {
					return me.skin.findElements(id, regex);
				};
	
				{
					this.__div = document.createElement('div');
					this.__div.ggId = "hotspot";
					this.__div.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
					this.__div.ggVisible = true;
					this.__div.className = 'ggskin ggskin_hotspot';
					this.__div.ggType = 'hotspot';
					var hs = 'position:absolute;';
					hs += 'left: 350px;';
					hs += 'top:  20px;';
					hs += cssPrefix + 'transform-origin: 50% 50%;';
					hs += 'visibility: inherit;';
					this.__div.setAttribute('style', hs);
	
					this._hsimage = document.createElement('div');
					this._hsimage.ggId = "hsimage";
					this._hsimage.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
					this._hsimage.ggVisible = true;
					this._hsimage.className = 'ggskin ggskin_textdiv';
					this._hsimage.ggType = 'svg';
	
					hs += 'left: -75px;';
					hs += 'top:  -16px;';
					hs += cssPrefix + 'transform-origin: 50% 50%;';
					hs += 'visibility: inherit;';
					hs += 'cursor: pointer;';
					this._hsimage.setAttribute('style', hs);
					this._hsimage.setAttribute('panoId', me.hotspot.id);
					this.__div.onclick = function () {
						if (typeof cocheObj.hotspots[me.hotspot.id] !== "undefined" && typeof cocheObj.hotspots[me.hotspot.id].callback == "function") cocheObj.hotspots[me.hotspot.id].callback(me.hotspot.id);
					};
					this._hsimage__text = document.createElement('div');
					this._hsimage__text.className = 'ggskin ggskin_text';
					this._hsimage__text.innerHTML = me.hotspot.title;
					this._hsimage__text.setAttribute('style', 'color:#FFF;-webkit-user-drag:none;min-width: 150px;');
					this._hsimage__bk = document.createElement('div');
					this._hsimage__bk.className = 'ggskin ggskin_bk';
					this._hsimage.appendChild(this._hsimage__text);
					this._hsimage.appendChild(this._hsimage__bk);
					this.__div.appendChild(this._hsimage);
				}
			};
			this.addSkinHotspot = function (hotspot) {
				return new SkinHotspotClass(me, hotspot);
			};
		};
	
		this.generateXML = function (pan, tilt, fov) {
			if (typeof pan === "undefined" || pan == null) pan = 0;
			if (typeof tilt === "undefined" || tilt == null) tilt = 0;
			if (typeof fov === "undefined" || fov == null) fov = 90;
	
			var baseXML = '<?xml version="1.0" encoding="UTF-8"?>';
			baseXML += '<panorama id=""><view fovmode="0" pannorth="0">';
			baseXML += '<start pan="' + pan + '" fov="' + fov + '" tilt="' + tilt + '"/>';
			baseXML += '<min pan="0" fov="5" tilt="-90"/>';
			baseXML += '<max pan="360" fov="120" tilt="90"/>';
			baseXML += '</view>';
			if (this.hotspots) {
				baseXML += '<hotspots>';
				for (var h in this.hotspots) {
					var hotspotName = parseInt(h) + 1;
					if (typeof this.hotspots[h].title !== "undefined") hotspotName = this.hotspots[h].title;
					baseXML += '<hotspot title="' + hotspotName + '" hotspot="' + h + '" target="" pan="' + this.hotspots[h].pan + '" skinid="" url="" id="' + h + '" tilt="' + this.hotspots[h].tilt + '"/>';
				}
				baseXML += '</hotspots>';
			}
			baseXML += '<media/>';
			baseXML += '<input tilescale="1" tile0url="' + this.basePath + this.cubeImages[0] + '" tile5url="' + this.basePath + this.cubeImages[5] + '" tilesize="' + this.titleSize + '" tile4url="' + this.basePath + this.cubeImages[4] + '" tile3url="' + this.basePath + this.cubeImages[3] + '" tile2url="' + this.basePath + this.cubeImages[2] + '" tile1url="' + this.basePath + this.cubeImages[1] + '">';
			baseXML += '<preview color="0x000000"/></input></panorama>';
			return baseXML;
		};
	
		this.getPanTiltFov = function () {
			return {
				pan: this.pano.getPan(),
				tilt: this.pano.getTilt(),
				fov: this.pano.getFov()
			};
		};
	
		this.setPanTiltFov = function (options) {
			if (typeof options.moveTo !== "undefined" && options.moveTo === true && typeof options.pan !== "undefined" && typeof options.tilt !== "undefined" && typeof options.fov !== "undefined") {
				this.pano.moveTo(options.pan, options.tilt, options.fov, 5);
			} else {
				if (typeof options.pan !== "undefined") this.pano.setPan(options.pan);
				if (typeof options.tilt !== "undefined") this.pano.setTilt(options.tilt);
				if (typeof options.fov !== "undefined") this.pano.setFov(options.fov);
			}
			return true;
		};
	
		this.changePanoramaImage = function (images) {
			if (typeof images !== "undefined") {
				if (typeof images[0] !== "undefined") this.cubeImages[0] = images[0];
				if (typeof images.front !== "undefined") this.cubeImages[0] = images.front;
	
				if (typeof images[3] !== "undefined") this.cubeImages[1] = images[3];
				if (typeof images.left !== "undefined") this.cubeImages[1] = images.left;
	
				if (typeof images[2] !== "undefined") this.cubeImages[2] = images[2];
				if (typeof images.back !== "undefined") this.cubeImages[2] = images.back;
	
				if (typeof images[1] !== "undefined") this.cubeImages[3] = images[1];
				if (typeof images.right !== "undefined") this.cubeImages[3] = images.right;
	
				if (typeof images[4] !== "undefined") this.cubeImages[4] = images[4];
				if (typeof images.up !== "undefined") this.cubeImages[4] = images.up;
	
				if (typeof images[5] !== "undefined") this.cubeImages[5] = images[5];
				if (typeof images.down !== "undefined") this.cubeImages[5] = images.down;
			}
	
			var panTiltFov = this.getPanTiltFov();
	
			this.pano.readConfigString(this.generateXML(panTiltFov.pan, panTiltFov.tilt, panTiltFov.fov));
		};
	
		this.addNewHotspot = function (title, pointId, panTiltFov, callback) {
			var nowPanTiltFov = this.getPanTiltFov();
			if (typeof panTiltFov !== "undefined") {
				if (panTiltFov.tilt > 80) panTiltFov.tilt = 80;
				if (panTiltFov.tilt < -80) {
					panTiltFov.tilt = -80;
				}
				var info = { pan: panTiltFov.pan, tilt: panTiltFov.tilt, fov: panTiltFov.fov };
			} else {
				panTiltFov = nowPanTiltFov;
				if (panTiltFov.tilt > 80) panTiltFov.tilt = 80;
				if (panTiltFov.tilt < -80) {
					panTiltFov.tilt = -80;
				}
				var info = { pan: panTiltFov.pan, tilt: panTiltFov.tilt, fov: panTiltFov.fov };
			}
			if (typeof title !== "undefined") info.title = title;
			if (typeof callback == "function") info.callback = callback;
			if (typeof pointId !== "undefined") info.pointId = pointId;
			var total = this.hotspots.push(info);
			this.pano.readConfigString(this.generateXML(nowPanTiltFov.pan, nowPanTiltFov.tilt, nowPanTiltFov.fov));
			return {
				hotspotId: total - 1,
				pointId: pointId,
				pan: panTiltFov.pan,
				tilt: panTiltFov.tilt,
				fov: panTiltFov.fov
			};
		};
	
		this.removeHotspot = function (id) {
			if (typeof this.hotspots[id] !== "undefined") delete this.hotspots[id];
	
			for (var t in this.hotspots) {
				if (this.hotspots[t].pointId === id) delete this.hotspots[t];
			}
	
			var panTiltFov = this.getPanTiltFov();
			this.pano.readConfigString(this.generateXML(panTiltFov.pan, panTiltFov.tilt, panTiltFov.fov));
		};
	
		this.clearHotspot = function () {
			this.hotspots = [];
			var panTiltFov = this.getPanTiltFov();
			this.pano.readConfigString(this.generateXML(panTiltFov.pan, panTiltFov.tilt, panTiltFov.fov));
		};
	
		this.gotoHotspot = function (id) {
			if (typeof this.hotspots[id] !== "undefined") {
				this.setPanTiltFov({
					pan: this.hotspots[id].pan,
					tilt: this.hotspots[id].tilt,
					fov: this.hotspots[id].fov,
					moveTo: true
				});
			}
		};
	
		this.updateHotspot = function (id, options) {
			var panTiltFov = this.getPanTiltFov();
			if (panTiltFov.tilt > 80) panTiltFov.tilt = 80;
			if (panTiltFov.tilt < -80) {
				panTiltFov.tilt = -80;
			}
			if (typeof this.hotspots[id] === "undefined") {
				for (var t in this.hotspots) {
					if (this.hotspots[t].pointId === id) {
						id = t;
						break;
					}
				}
			}
			if (typeof this.hotspots[id] !== "undefined") {
				this.hotspots[id].pan = panTiltFov.pan;
				this.hotspots[id].tilt = panTiltFov.tilt;
				this.hotspots[id].fov = panTiltFov.fov;
				if (typeof options !== "undefined") {
					for (i in options) {
						this.hotspots[id][i] = options[i];
					}
				}
			}
	
			this.pano.readConfigString(this.generateXML(panTiltFov.pan, panTiltFov.tilt, panTiltFov.fov));
	
			return {
				hotspotId: id,
				pointId: this.hotspots[id].pointId,
				pan: panTiltFov.pan,
				tilt: panTiltFov.tilt,
				fov: panTiltFov.fov
			};
		};
	
		if (ggHasHtml5Css3D() || ggHasWebGL()) {
	
			this.pano = new pano2vrPlayer(container);
			this.pano.setLockedKeyboard(true);
			this.pano2vrSkin(this.pano, this);
	
			this.pano.readConfigString(this.generateXML());
		}
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(358);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	
	  scrollBehavior: function scrollBehavior() {
	    return { y: 0 };
	  },
	  routes: [{
	    name: 'Login',
	    path: '/login',
	    component: _vue2.default.component('login', __webpack_require__(273)),
	    meta: { requiresAuth: false }
	  }, {
	    name: 'Coches',
	    path: '/',
	    component: _vue2.default.component('coach', __webpack_require__(267)),
	    meta: { requiresAuth: true }
	  }, {
	    name: 'Utilizadores',
	    path: '/users',
	    component: _vue2.default.component('user', __webpack_require__(290)),
	    meta: { requiresAuth: true }
	  }, {
	    name: 'Coche',
	    path: '/:id',
	    component: _vue2.default.component('coach', __webpack_require__(258)),
	    meta: { requiresAuth: true }
	  }, {
	    name: 'Menu',
	    path: '/:id/menu/:cat',
	    component: _vue2.default.component('slidemenu', __webpack_require__(285)),
	    meta: { requiresAuth: true }
	  }, {
	    name: 'Sub-slide Menu',
	    path: '/:id/submenu/:cat',
	    component: _vue2.default.component('submenu', __webpack_require__(284)),
	    meta: { requiresAuth: true }
	  }, {
	    name: 'Visita Virtual',
	    path: '/:id/panorama',
	    component: _vue2.default.component('panorama', __webpack_require__(278)),
	    meta: { requiresAuth: true }
	  }, {
	    name: 'Exterior',
	    path: '/:id/exterior',
	    component: _vue2.default.component('exterior', __webpack_require__(270)),
	    meta: { requiresAuth: true }
	  }, {
	    name: '404',
	    path: '*',
	    component: _vue2.default.component('not-found', __webpack_require__(274)),
	    meta: { requiresAuth: true }
	  }]
	});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveUser = exports.updateUser = exports.deleteUser = exports.getUserList = exports.deleteExterior = exports.updateExterior = exports.saveExterior = exports.updateExteriorState = exports.reorderExteriors = exports.getExteriorsList = exports.deletePanoramaCube = exports.deletePanoramaPoint = exports.updatePanoramaPoint = exports.savePanoramaPoint = exports.updatePanorama = exports.getPanorama = exports.updateSubSlideCategory = exports.deleteSubMenu = exports.setSubSlideCategory = exports.updateSlideState = exports.reorderSlides = exports.deleteSlide = exports.updateSlide = exports.saveSlide = exports.getSlideList = exports.updateMenuState = exports.getCategoryList = exports.categoryCoachRemove = exports.updateCategoryCoachState = exports.categoryCoachUpdate = exports.categoryCoach = exports.updateCoachState = exports.updateCoachScreensaver = exports.deleteCoach = exports.updateCoach = exports.getCoach = exports.saveCoach = exports.getCoachList = exports.localLogin = exports.logout = exports.nextEvent = exports.deactivateScroll = exports.activateScroll = exports.newEvent = exports.nextNotification = exports.showNotification = exports.setNavbar = exports.setMobile = undefined;
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _cookies = __webpack_require__(18);
	
	var _api = __webpack_require__(64);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setMobile = exports.setMobile = function setMobile(_ref, value) {
	  var commit = _ref.commit;
	
	  commit(types.SET_MOBILE, value);
	};
	
	var setNavbar = exports.setNavbar = function setNavbar(_ref2, value) {
	  var commit = _ref2.commit;
	
	  commit(types.SET_NAVBAR, value);
	};
	
	var showNotification = exports.showNotification = function showNotification(_ref3, notificationData) {
	  var commit = _ref3.commit;
	
	  commit(types.SHOW_NOTIFICATION, notificationData);
	};
	
	var nextNotification = exports.nextNotification = function nextNotification(_ref4) {
	  var commit = _ref4.commit;
	
	  commit(types.UNLOCK_NOTIFICATION);
	};
	
	var newEvent = exports.newEvent = function newEvent(_ref5, eventString) {
	  var commit = _ref5.commit;
	
	  commit(types.ADD_EVENT, eventString);
	  setTimeout(function () {
	    commit(types.UNLOCK_EVENT);
	  }, 10);
	};
	
	var activateScroll = exports.activateScroll = function activateScroll(_ref6) {
	  var commit = _ref6.commit;
	
	  commit(types.ACTIVATE_SCROLL);
	};
	var deactivateScroll = exports.deactivateScroll = function deactivateScroll(_ref7) {
	  var commit = _ref7.commit;
	
	  commit(types.DEACTIVATE_SCROLL);
	};
	
	var nextEvent = exports.nextEvent = function nextEvent(_ref8) {
	  var commit = _ref8.commit;
	
	  commit(types.UNLOCK_EVENT);
	};
	
	var logout = exports.logout = function logout(_ref9) {
	  var dispatch = _ref9.dispatch,
	      router = _ref9.router;
	
	  (0, _cookies.signOut)();
	  dispatch(types.LOGOUT_USER);
	  window.location.pathname = '/';
	};
	
	var localLogin = exports.localLogin = function localLogin(_ref10, userInfo) {
	  var commit = _ref10.commit,
	      state = _ref10.state;
	
	  commit(types.ADD_LOADING_BTN, '.btn-submit-login');
	
	  _api2.default.localLogin(userInfo).then(function (response) {
	    (0, _cookies.signIn)(response.data.token, userInfo.email);
	    commit(types.LOGIN_SUCCESS, { token: response.data.token, email: response.data.email, admin: response.data.admin });
	
	    var notificationData = { title: 'Autenticação', message: 'Login realizado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.btn-submit-login');
	
	    var routeRedirect = window.router.currentRoute.query.redirect;
	    if (typeof routeRedirect === 'undefined') {
	      window.router.push('/');
	    } else {
	      window.router.push(routeRedirect);
	    }
	  }, function (response) {
	    var appError = null;
	
	    var jwtError = response.data.error;
	    switch (jwtError) {
	      case 'invalid_credentials':
	        appError = 'Par Email/Password Inválido.';
	        break;
	    }
	
	    var notificationData = { title: 'Autenticação', message: appError, type: 'danger' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.btn-submit-login');
	  });
	};
	
	var getCoachList = exports.getCoachList = function getCoachList(_ref11) {
	  var commit = _ref11.commit,
	      state = _ref11.state;
	
	  _api2.default.getCoachList().then(function (response) {
	    commit(types.COACH_LIST, response.data);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coches', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var saveCoach = exports.saveCoach = function saveCoach(_ref12, coachInfo) {
	  var commit = _ref12.commit,
	      state = _ref12.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	
	  _api2.default.saveCoach(coachInfo).then(function (response) {
	    var notificationData = { title: 'Coche', message: 'Novo Coche criado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getCoachList({ commit: commit, state: state });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var getCoach = exports.getCoach = function getCoach(_ref13, coachId) {
	  var commit = _ref13.commit,
	      state = _ref13.state;
	
	  _api2.default.getCoach(coachId).then(function (response) {
	    commit(types.GET_COACH_DATA, response.data.data.coach);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updateCoach = exports.updateCoach = function updateCoach(_ref14, coachInfo) {
	  var commit = _ref14.commit,
	      state = _ref14.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	  _api2.default.updateCoach(coachInfo.id, coachInfo.data).then(function (response) {
	    var notificationData = { title: 'Coche', message: 'Coche alterado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getCoach({ commit: commit, state: state }, coachInfo.id);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var deleteCoach = exports.deleteCoach = function deleteCoach(_ref15, coachId) {
	  var commit = _ref15.commit,
	      state = _ref15.state;
	
	  _api2.default.deleteCoach(coachId).then(function (response) {
	    var notificationData = { title: 'Coche', message: 'Coche apagado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    window.store.dispatch('newEvent', 'update-coach-list');
	
	    getCoachList({ commit: commit, state: state });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updateCoachScreensaver = exports.updateCoachScreensaver = function updateCoachScreensaver(_ref16, data) {
	  var commit = _ref16.commit,
	      state = _ref16.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	  _api2.default.updateCoachScreensaver(data).then(function (response) {
	    var notificationData = { title: 'Coche', message: 'Screensaver alterado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getCoach({ commit: commit, state: state }, data.id);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var updateCoachState = exports.updateCoachState = function updateCoachState(_ref17, data) {
	  var commit = _ref17.commit,
	      state = _ref17.state;
	
	  _api2.default.updateCoachState(data).then(function (response) {
	    var notificationData = { title: 'Coche', message: 'Estado do Coche alterado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getCoach({ commit: commit, state: state }, data.id);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var categoryCoach = exports.categoryCoach = function categoryCoach(_ref18, categoryInfo) {
	  var commit = _ref18.commit,
	      state = _ref18.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	
	  _api2.default.categoryCoach(categoryInfo).then(function (response) {
	    var notificationData = { title: 'Menu', message: 'Menu alterado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getCategoryList({ commit: commit, state: state }, categoryInfo.coach_id);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var categoryCoachUpdate = exports.categoryCoachUpdate = function categoryCoachUpdate(_ref19, categoryInfo) {
	  var commit = _ref19.commit,
	      state = _ref19.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	
	  _api2.default.categoryCoach(categoryInfo).then(function (response) {
	    var notificationData = { title: 'Menu', message: 'Menu alterado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getCategoryList({ commit: commit, state: state }, categoryInfo.coach_id);
	    getSlideList({ commit: commit, state: state }, { coach: categoryInfo.coach_id, category: categoryInfo.slide_category_id });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var updateCategoryCoachState = exports.updateCategoryCoachState = function updateCategoryCoachState(_ref20, data) {
	  var commit = _ref20.commit,
	      state = _ref20.state;
	
	  _api2.default.updateCategoryCoachState(data).then(function (response) {
	    var notificationData = { title: 'Menu', message: 'Estado do Menu alterado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getCategoryList({ commit: commit, state: state }, data.data.coach);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var categoryCoachRemove = exports.categoryCoachRemove = function categoryCoachRemove(_ref21, categoryInfo) {
	  var commit = _ref21.commit,
	      state = _ref21.state;
	
	  _api2.default.categoryCoachRemove(categoryInfo).then(function (response) {
	    var notificationData = { title: 'Menu', message: 'Menu removido com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    window.store.dispatch('newEvent', 'update-category-list');
	    getCategoryList({ commit: commit, state: state }, categoryInfo.coach_id);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var getCategoryList = exports.getCategoryList = function getCategoryList(_ref22, coachId) {
	  var commit = _ref22.commit,
	      state = _ref22.state;
	
	  _api2.default.getCategoryList(coachId).then(function (response) {
	    commit(types.MENU_LIST, response.data);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Menu', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updateMenuState = exports.updateMenuState = function updateMenuState(_ref23, data) {
	  var commit = _ref23.commit,
	      state = _ref23.state;
	
	  _api2.default.updateCategoryCoachState(data).then(function (response) {
	    var notificationData = { title: 'Menu', message: 'Estado do Menu alterado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getSlideList({ commit: commit, state: state }, { coach: data.data.coach, category: data.data.category });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Coche', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var getSlideList = exports.getSlideList = function getSlideList(_ref24, menuData) {
	  var commit = _ref24.commit,
	      state = _ref24.state;
	
	  _api2.default.getSlideList(menuData).then(function (response) {
	    commit(types.SLIDE_LIST, response.data);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Menu', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var saveSlide = exports.saveSlide = function saveSlide(_ref25, slideInfo) {
	  var commit = _ref25.commit,
	      state = _ref25.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	
	  _api2.default.saveSlide(slideInfo).then(function (response) {
	    var notificationData = { title: 'Slide', message: 'Slide criado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getSlideList({ commit: commit, state: state }, { coach: response.data.data.slide.coach_id, category: response.data.data.slide.slide_category_id });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var updateSlide = exports.updateSlide = function updateSlide(_ref26, slideInfo) {
	  var commit = _ref26.commit,
	      state = _ref26.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	  _api2.default.updateSlide(slideInfo.id, slideInfo.slide).then(function (response) {
	    var notificationData = { title: 'Slide', message: 'Slide alterado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getSlideList({ commit: commit, state: state }, { coach: slideInfo.slide.coach_id, category: slideInfo.slide.slide_category_id });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var deleteSlide = exports.deleteSlide = function deleteSlide(_ref27, id) {
	  var commit = _ref27.commit,
	      state = _ref27.state;
	
	  _api2.default.deleteSlide(id).then(function (response) {
	    var notificationData = { title: 'Slide', message: 'Slide apagado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getSlideList({ commit: commit, state: state }, { coach: response.data.data.slide.coach_id, category: response.data.data.slide.slide_category_id });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var reorderSlides = exports.reorderSlides = function reorderSlides(_ref28, data) {
	  var commit = _ref28.commit,
	      state = _ref28.state;
	
	  _api2.default.reorderSlides(data).then(function (response) {
	
	    getSlideList({ commit: commit, state: state }, { coach: data.slide.coach_id, category: data.slide.slide_category_id });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Slides', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updateSlideState = exports.updateSlideState = function updateSlideState(_ref29, data) {
	  var commit = _ref29.commit,
	      state = _ref29.state;
	
	  _api2.default.updateSlideState(data).then(function (response) {
	    var notificationData = { title: 'Slide', message: 'Estado do Slide alterado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getSlideList({ commit: commit, state: state }, { coach: data.data.coach, category: data.data.category });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var setSubSlideCategory = exports.setSubSlideCategory = function setSubSlideCategory(_ref30, data) {
	  var commit = _ref30.commit,
	      state = _ref30.state;
	
	  _api2.default.setSubSlideCategory(data).then(function (response) {
	    var notificationData = { title: 'Sub-Slide', message: 'Defenido novo set de sub-slides.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getSlideList({ commit: commit, state: state }, { coach: data.coach, category: data.menu });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Sub-Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var deleteSubMenu = exports.deleteSubMenu = function deleteSubMenu(_ref31, data) {
	  var commit = _ref31.commit,
	      state = _ref31.state;
	
	  _api2.default.deleteSubSlideCategory(data.id).then(function (response) {
	    var notificationData = { title: 'Sub-Slide', message: 'Set de sub-slides apagado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getSlideList({ commit: commit, state: state }, { coach: data.coach, category: data.menu });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Sub-Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updateSubSlideCategory = exports.updateSubSlideCategory = function updateSubSlideCategory(_ref32, data) {
	  var commit = _ref32.commit,
	      state = _ref32.state;
	
	  _api2.default.updateSubSlideCategory(data).then(function (response) {
	    var notificationData = { title: 'Sub-Slide', message: 'Set de sub-slides alterado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    getSlideList({ commit: commit, state: state }, { coach: data.coach, category: data.menu });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Sub-Slide', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var getPanorama = exports.getPanorama = function getPanorama(_ref33, coachId) {
	  var commit = _ref33.commit,
	      state = _ref33.state;
	
	  _api2.default.getPanorama(coachId).then(function (response) {
	    commit(types.GET_PANORAMA_DATA, response.data.data.panorama);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Panorama', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updatePanorama = exports.updatePanorama = function updatePanorama(_ref34, panoramaData) {
	  var commit = _ref34.commit,
	      state = _ref34.state;
	
	  _api2.default.updatePanorama(panoramaData.panoramaId, panoramaData).then(function (response) {
	    var notificationData = { title: 'Panorama', message: 'Panorama atualizado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Panorama', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var savePanoramaPoint = exports.savePanoramaPoint = function savePanoramaPoint(_ref35, pointData) {
	  var commit = _ref35.commit,
	      state = _ref35.state;
	
	  _api2.default.savePanoramaPoint(pointData).then(function (response) {
	    commit(types.GET_PANORAMA_DATA, response.data.data.panorama);
	
	    var notificationData = { title: 'Hotspot', message: 'Hotspot guardado com sucesso.', type: 'success' };
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    commit(types.SHOW_NOTIFICATION, notificationData);
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Hotspot', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updatePanoramaPoint = exports.updatePanoramaPoint = function updatePanoramaPoint(_ref36, pointData) {
	  var commit = _ref36.commit,
	      state = _ref36.state;
	
	  _api2.default.updatePanoramaPoint(pointData.pointId, pointData).then(function (response) {
	    commit(types.GET_PANORAMA_DATA, response.data.data.panorama);
	    var notificationData = { title: 'Hotspot', message: 'Hotspot alterado com sucesso.', type: 'success' };
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    commit(types.SHOW_NOTIFICATION, notificationData);
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Hotspot', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var deletePanoramaPoint = exports.deletePanoramaPoint = function deletePanoramaPoint(_ref37, pointId) {
	  var commit = _ref37.commit,
	      state = _ref37.state;
	
	  _api2.default.deletePanoramaPoint(pointId).then(function (response) {
	    commit(types.GET_PANORAMA_DATA, response.data.data.panorama);
	
	    var notificationData = { title: 'Hotspot', message: 'Hotspot apagado com sucesso.', type: 'success' };
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    commit(types.SHOW_NOTIFICATION, notificationData);
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Hotspot', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var deletePanoramaCube = exports.deletePanoramaCube = function deletePanoramaCube(_ref38, cubeData) {
	  var commit = _ref38.commit,
	      state = _ref38.state;
	
	  _api2.default.deletePanoramaCube(cubeData.panoramaId, cubeData.position).then(function (response) {
	    commit(types.GET_PANORAMA_DATA, response.data.data.panorama);
	
	    var notificationData = { title: 'Face', message: 'Face apagada com sucesso.', type: 'success' };
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    commit(types.SHOW_NOTIFICATION, notificationData);
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Face', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var getExteriorsList = exports.getExteriorsList = function getExteriorsList(_ref39, coachData) {
	  var commit = _ref39.commit,
	      state = _ref39.state;
	
	  _api2.default.getExteriorsList(coachData.coachId, coachData).then(function (response) {
	    commit(types.GET_EXTERIOR_DATA, response.data.data.exteriors);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Exterior', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var reorderExteriors = exports.reorderExteriors = function reorderExteriors(_ref40, data) {
	  var commit = _ref40.commit,
	      state = _ref40.state;
	
	  _api2.default.reorderExteriors(data).then(function (response) {
	    getExteriorsList({ commit: commit, state: state }, { coachId: data.coach });
	  }, function (response) {
	    if (response.data) {}
	  });
	};
	
	var updateExteriorState = exports.updateExteriorState = function updateExteriorState(_ref41, data) {
	  var commit = _ref41.commit,
	      state = _ref41.state;
	
	  _api2.default.updateExteriorState(data).then(function (response) {
	    var notificationData = { title: 'Exterior', message: 'Estado do Slide Exterior alterado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getExteriorsList({ commit: commit, state: state }, { coachId: data.data.coach });
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Exterior', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var saveExterior = exports.saveExterior = function saveExterior(_ref42, data) {
	  var commit = _ref42.commit,
	      state = _ref42.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	  _api2.default.saveExterior(data).then(function (response) {
	    var notificationData = { title: 'Exterior', message: 'Slide Exterior guardado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getExteriorsList({ commit: commit, state: state }, { coachId: data.coach });
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Exterior', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var updateExterior = exports.updateExterior = function updateExterior(_ref43, data) {
	  var commit = _ref43.commit,
	      state = _ref43.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	  _api2.default.updateExterior(data.exteriorId, data).then(function (response) {
	    var notificationData = { title: 'Exterior', message: 'Slide Exterior guardado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getExteriorsList({ commit: commit, state: state }, { coachId: data.coach });
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Exterior', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var deleteExterior = exports.deleteExterior = function deleteExterior(_ref44, data) {
	  var commit = _ref44.commit,
	      state = _ref44.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	  _api2.default.deleteExterior(data.exteriorId).then(function (response) {
	    var notificationData = { title: 'Exterior', message: 'Slide Exterior apagado.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    getExteriorsList({ commit: commit, state: state }, { coachId: data.coachId });
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Exterior', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var getUserList = exports.getUserList = function getUserList(_ref45) {
	  var commit = _ref45.commit,
	      state = _ref45.state;
	
	  _api2.default.getUserList().then(function (response) {
	    commit(types.USER_LIST, response.data);
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Utilizadores', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	    }
	  });
	};
	
	var deleteUser = exports.deleteUser = function deleteUser(_ref46, userId) {
	  var commit = _ref46.commit,
	      state = _ref46.state;
	
	  _api2.default.deleteUser(userId).then(function (response) {
	    commit(types.USER_LIST, response.data);
	
	    var notificationData = { title: 'Utilizadores', message: 'Utilizador apagado', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    commit(types.USER_LIST, response.data);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Utilizadores', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var updateUser = exports.updateUser = function updateUser(_ref47, userInfo) {
	  var commit = _ref47.commit,
	      state = _ref47.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	
	  _api2.default.updateUser(userInfo.id, userInfo).then(function (response) {
	    var notificationData = { title: 'Utilizador', message: 'Utilizador editado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    commit(types.USER_LIST, response.data);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	    window.store.dispatch('getUserList');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Utilizador', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};
	
	var saveUser = exports.saveUser = function saveUser(_ref48, userInfo) {
	  var commit = _ref48.commit,
	      state = _ref48.state;
	
	  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn');
	
	  _api2.default.saveUser(userInfo).then(function (response) {
	    var notificationData = { title: 'Utilizador', message: 'Utilizador criado com sucesso.', type: 'success' };
	    commit(types.SHOW_NOTIFICATION, notificationData);
	
	    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	
	    commit(types.USER_LIST, response.data);
	
	    window.store.dispatch('newEvent', 'modal-card-close');
	  }, function (response) {
	    if (response.data) {
	      var jwtError = response.data.error;
	      var notificationData = { title: 'Utilizador', message: jwtError, type: 'danger' };
	      commit(types.SHOW_NOTIFICATION, notificationData);
	
	      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn');
	    }
	  });
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(74);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(360);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _auth = __webpack_require__(76);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _coach = __webpack_require__(77);
	
	var _coach2 = _interopRequireDefault(_coach);
	
	var _config = __webpack_require__(78);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _logger = __webpack_require__(71);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _event = __webpack_require__(79);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _exterior = __webpack_require__(80);
	
	var _exterior2 = _interopRequireDefault(_exterior);
	
	var _notification = __webpack_require__(81);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _panorama = __webpack_require__(82);
	
	var _panorama2 = _interopRequireDefault(_panorama);
	
	var _slide = __webpack_require__(83);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _user = __webpack_require__(84);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = false;
	
	exports.default = new _vuex2.default.Store({
	  actions: actions,
	  modules: {
	    config: _config2.default,
	    auth: _auth2.default,
	    notification: _notification2.default,
	    event: _event2.default,
	    coach: _coach2.default,
	    panorama: _panorama2.default,
	    exterior: _exterior2.default,
	    slide: _slide2.default,
	    user: _user2.default
	  },
	  strict: debug,
	  plugins: debug ? [(0, _logger2.default)()] : []
	});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _cookies = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  token: (0, _cookies.getCookie)('token') || null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.LOGIN_SUCCESS, function (state, action) {
	  state.token = action.token;
	}), (0, _defineProperty3.default)(_mutations, types.USERINFO_SUCCESS, function (state, _ref) {
	  var action = _ref.action;
	
	  state.user = action.user;
	}), (0, _defineProperty3.default)(_mutations, types.USERINFO_FAILURE, function (state, _ref2) {
	  var action = _ref2.action;
	
	  state.user = null;
	}), (0, _defineProperty3.default)(_mutations, types.LOGOUT_USER, function (state, _ref3) {
	  var action = _ref3.action;
	
	  state.token = (0, _cookies.getCookie)('token') || null;
	  state.token = null;
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_USER_SUCCESS, function (state, _ref4) {
	  var action = _ref4.action;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  list: null,
	  data: null,
	  slideCategories: null,
	  coachCategories: null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.COACH_LIST, function (state, action) {
	  state.list = action;
	}), (0, _defineProperty3.default)(_mutations, types.GET_COACH_DATA, function (state, action) {
	  state.data = action;
	}), (0, _defineProperty3.default)(_mutations, types.MENU_LIST, function (state, action) {
	  state.slideCategories = action.data.slideCategories;
	  state.coachCategories = action.data.coachCategories;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  mobile: false,
	  navbar: false,
	  scrollEnabled: true
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_MOBILE, function (state, action) {
	  state.mobile = action;
	}), (0, _defineProperty3.default)(_mutations, types.SET_NAVBAR, function (state, action) {
	  state.navbar = action;
	}), (0, _defineProperty3.default)(_mutations, types.ACTIVATE_SCROLL, function (state, action) {
	  state.scrollEnabled = true;
	}), (0, _defineProperty3.default)(_mutations, types.DEACTIVATE_SCROLL, function (state, action) {
	  state.scrollEnabled = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  nextEvent: null,
	  eventLock: false,
	  eventQuee: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.ADD_EVENT, function (state, action) {
	  if (!state.eventLock) {
	    state.eventLock = true;
	    state.nextEvent = action;
	  } else {
	    state.eventQuee.push(action);
	  }
	}), (0, _defineProperty3.default)(_mutations, types.UNLOCK_EVENT, function (state) {
	  if (state.eventQuee.length) {
	    state.nextEvent = state.eventQuee.shift();
	  } else {
	    state.nextEvent = null;
	    state.eventLock = false;
	  }
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  data: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.GET_EXTERIOR_DATA, function (state, action) {
	  state.data = action;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  nextNotification: null,
	  notificationLock: false,
	  notificationQuee: [],
	  loadingButtons: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SHOW_NOTIFICATION, function (state, action) {
	  if (!state.notificationLock) {
	    state.notificationLock = true;
	    state.nextNotification = action;
	  } else {
	    state.notificationQuee.push(action);
	  }
	}), (0, _defineProperty3.default)(_mutations, types.UNLOCK_NOTIFICATION, function (state) {
	  if (state.notificationQuee.length) {
	    state.nextNotification = state.notificationQuee.shift();
	  } else {
	    state.nextNotification = null;
	    state.notificationLock = false;
	  }
	}), (0, _defineProperty3.default)(_mutations, types.ADD_LOADING_BTN, function (state, action) {
	  if (!state.loadingButtons.includes(action)) {
	    state.loadingButtons.push(action);
	  }
	}), (0, _defineProperty3.default)(_mutations, types.REMOVE_LOADING_BTN, function (state, action) {
	  var array = state.loadingButtons;
	  if (array.includes(action)) {
	    state.loadingButtons.splice(array.indexOf(action), 1);
	  }
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  data: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.GET_PANORAMA_DATA, function (state, action) {
	  state.data = action;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  menu: null,
	  list: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.SLIDE_LIST, function (state, action) {
	  state.menu = action.data.menu;
	  state.list = action.data.slides;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(7);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  list: null,
	  admin: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.USER_LIST, function (state, action) {
	  state.list = action.users;
	  state.admin = action.isAdmin;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(42);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(146);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.deepCopy = deepCopy;
	exports.isObject = isObject;
	exports.isPromise = isPromise;
	exports.assert = assert;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function find(list, f) {
	  return list.filter(f)[0];
	}
	
	function deepCopy(obj) {
	  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
	    return obj;
	  }
	
	  var hit = find(cache, function (c) {
	    return c.original === obj;
	  });
	  if (hit) {
	    return hit.copy;
	  }
	
	  var copy = Array.isArray(obj) ? [] : {};
	
	  cache.push({
	    original: obj,
	    copy: copy
	  });
	
	  (0, _keys2.default)(obj).forEach(function (key) {
	    copy[key] = deepCopy(obj[key], cache);
	  });
	
	  return copy;
	}
	
	function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object';
	}
	
	function isPromise(val) {
	  return val && typeof val.then === 'function';
	}
	
	function assert(condition, msg) {
	  if (!condition) throw new Error('[vuex] ' + msg);
	}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: {
	    type: String,
	    title: String,
	    message: String,
	    direction: {
	      type: String,
	      default: 'Right'
	    },
	    duration: {
	      type: Number,
	      default: 4500
	    },
	    container: {
	      type: String,
	      default: '.notifications'
	    }
	  },
	
	  data: function data() {
	    return {
	      $_parent_: null,
	      show: true
	    };
	  },
	  created: function created() {
	    var $parent = this.$parent;
	    if (!$parent) {
	      var parent = document.querySelector(this.container);
	      if (!parent) {
	        var className = this.container.replace('.', '');
	        var Notifications = _vue2.default.extend({
	          name: 'Notifications',
	          render: function render(h) {
	            return h('div', {
	              'class': (0, _defineProperty3.default)({}, '' + className, true)
	            });
	          }
	        });
	        $parent = new Notifications().$mount();
	        document.body.appendChild($parent.$el);
	      } else {
	        $parent = parent.__vue__;
	      }
	
	      this.$_parent_ = $parent;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.$_parent_) {
	      this.$_parent_.$el.appendChild(this.$el);
	      this.$parent = this.$_parent_;
	      delete this.$_parent_;
	    }
	    if (this.duration > 0) {
	      this.timer = setTimeout(function () {
	        return _this.close();
	      }, this.duration);
	    }
	  },
	  destroyed: function destroyed() {
	    this.$el.remove();
	  },
	
	
	  computed: {
	    transition: function transition() {
	      return 'bounce-' + this.direction;
	    },
	    enterClass: function enterClass() {
	      return 'bounceIn' + this.direction;
	    },
	    leaveClass: function leaveClass() {
	      return 'bounceOut' + this.direction;
	    }
	  },
	
	  methods: {
	    close: function close() {
	      clearTimeout(this.timer);
	      this.show = false;
	    },
	    afterLeave: function afterLeave() {
	      this.$destroy();
	    }
	  }
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _quill = __webpack_require__(250);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: {
	    options: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    autofocus: Boolean
	  },
	
	  data: function data() {
	    return {
	      focused: this.autofocus,
	      editor: null
	    };
	  },
	  mounted: function mounted() {
	    this.editor = new _quill2.default(this.$el, this.options);
	  },
	
	
	  watch: {
	    focused: function focused(val) {
	      this.editor[val ? 'focus' : 'blur']();
	    }
	  }
	
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkboard = __webpack_require__(295);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Alpha',
	  props: {
	    value: Object,
	    onChange: Function
	  },
	  components: {
	    checkboard: _Checkboard2.default
	  },
	  computed: {
	    colors: function colors() {
	      return this.value;
	    },
	    gradientColor: function gradientColor() {
	      var rgba = this.colors.rgba;
	      var rgbStr = [rgba.r, rgba.g, rgba.b].join(',');
	      return 'linear-gradient(to right, rgba(' + rgbStr + ', 0) 0%, rgba(' + rgbStr + ', 1) 100%)';
	    }
	  },
	  methods: {
	    handleChange: function handleChange(e, skip) {
	      !skip && e.preventDefault();
	      var container = this.$refs.container;
	      var containerWidth = container.clientWidth;
	
	      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
	      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
	      var left = pageX - xOffset;
	
	      var a;
	      if (left < 0) {
	        a = 0;
	      } else if (left > containerWidth) {
	        a = 1;
	      } else {
	        a = Math.round(left * 100 / containerWidth) / 100;
	      }
	
	      if (this.colors.a !== a) {
	        this.$emit('change', {
	          h: this.colors.hsl.h,
	          s: this.colors.hsl.s,
	          l: this.colors.hsl.l,
	          a: a,
	          source: 'rgba'
	        });
	      }
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      this.handleChange(e, true);
	      window.addEventListener('mousemove', this.handleChange);
	      window.addEventListener('mouseup', this.handleMouseUp);
	    },
	    handleMouseUp: function handleMouseUp() {
	      this.unbindEventListeners();
	    },
	    unbindEventListeners: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }
	};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var _checkboardCache = {};
	
	exports.default = {
	  name: 'Checkboard',
	  props: {
	    size: {
	      type: [Number, String],
	      default: 8
	    },
	    white: {
	      type: String,
	      default: '#fff'
	    },
	    grey: {
	      type: String,
	      default: '#e6e6e6'
	    }
	  },
	  computed: {
	    bgStyle: function bgStyle() {
	      return 'url(' + getCheckboard(this.white, this.grey, this.size) + ') center left';
	    }
	  }
	};
	
	
	function renderCheckboard(c1, c2, size) {
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  var canvas = document.createElement('canvas');
	  canvas.width = canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	
	  if (!ctx) {
	    return null;
	  }
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	}
	
	function getCheckboard(c1, c2, size) {
	  var key = c1 + ',' + c2 + ',' + size;
	
	  if (_checkboardCache[key]) {
	    return _checkboardCache[key];
	  } else {
	    var checkboard = renderCheckboard(c1, c2, size);
	    _checkboardCache[key] = checkboard;
	    return checkboard;
	  }
	}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'editableInput',
	  props: {
	    label: String,
	    value: [String, Number],
	    max: Number,
	    arrowOffset: {
	      type: Number,
	      default: 1
	    }
	  },
	  computed: {
	    val: function val() {
	      return this.value;
	    }
	  },
	  filters: {
	    maxFilter: {
	      read: function read(val) {
	        if (this.max && val > this.max) {
	          return this.max;
	        } else {
	          return val;
	        }
	      },
	      write: function write(val, oldVal) {
	        return val;
	      }
	    }
	  },
	  methods: {
	    update: function update(e) {
	      this.handleChange(e.target.value);
	    },
	    handleChange: function handleChange(newVal) {
	      var data = {};
	      data[this.label] = newVal;
	      if (data.hex === undefined && data['#'] === undefined) {
	        this.$emit('change', data);
	      } else if (newVal.length > 5) {
	        this.$emit('change', data);
	      }
	    },
	    handleBlur: function handleBlur(e) {
	      console.log(e);
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var val = this.val;
	      var number = Number(val);
	
	      if (number) {
	        var amount = this.arrowOffset || 1;
	
	        if (e.keyCode === 38) {
	          val = number + amount;
	          this.handleChange(val);
	          e.preventDefault();
	        }
	
	        if (e.keyCode === 40) {
	          val = number - amount;
	          this.handleChange(val);
	          e.preventDefault();
	        }
	      }
	    },
	    handleDrag: function handleDrag(e) {
	      console.log(e);
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      console.log(e);
	    }
	  }
	};

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Hue',
	  props: {
	    value: Object,
	    direction: {
	      type: String,
	
	      default: 'horizontal'
	    }
	  },
	  computed: {
	    colors: function colors() {
	      return this.value;
	    },
	    directionClass: function directionClass() {
	      return {
	        'vue-color__c-hue--horizontal': this.direction === 'horizontal',
	        'vue-color__c-hue--vertical': this.direction === 'vertical'
	      };
	    },
	    pointerTop: function pointerTop() {
	      if (this.direction === 'vertical') {
	        return -(this.colors.hsl.h * 100 / 360) + 100 + '%';
	      } else {
	        return 0;
	      }
	    },
	    pointerLeft: function pointerLeft() {
	      if (this.direction === 'vertical') {
	        return 0;
	      } else {
	        return this.colors.hsl.h * 100 / 360 + '%';
	      }
	    }
	  },
	  methods: {
	    handleChange: function handleChange(e, skip) {
	      !skip && e.preventDefault();
	
	      var container = this.$refs.container;
	      var containerWidth = container.clientWidth;
	      var containerHeight = container.clientHeight;
	
	      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
	      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
	      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
	      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
	      var left = pageX - xOffset;
	      var top = pageY - yOffset;
	
	      var h;
	      var percent;
	
	      if (this.direction === 'vertical') {
	        if (top < 0) {
	          h = 359;
	        } else if (top > containerHeight) {
	          h = 0;
	        } else {
	          percent = -(top * 100 / containerHeight) + 100;
	          h = 360 * percent / 100;
	        }
	
	        if (this.colors.hsl.h !== h) {
	          this.$emit('change', {
	            h: h,
	            s: this.colors.hsl.s,
	            l: this.colors.hsl.l,
	            a: this.colors.hsl.a,
	            source: 'hsl'
	          });
	        }
	      } else {
	        if (left < 0) {
	          h = 0;
	        } else if (left > containerWidth) {
	          h = 359;
	        } else {
	          percent = left * 100 / containerWidth;
	          h = 360 * percent / 100;
	        }
	
	        if (this.colors.hsl.h !== h) {
	          this.$emit('change', {
	            h: h,
	            s: this.colors.hsl.s,
	            l: this.colors.hsl.l,
	            a: this.colors.hsl.a,
	            source: 'hsl'
	          });
	        }
	      }
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      this.handleChange(e, true);
	      window.addEventListener('mousemove', this.handleChange);
	      window.addEventListener('mouseup', this.handleMouseUp);
	    },
	    handleMouseUp: function handleMouseUp(e) {
	      this.unbindEventListeners();
	    },
	    unbindEventListeners: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(248);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Saturation',
	  props: {
	    value: Object
	  },
	  computed: {
	    colors: function colors() {
	      return this.value;
	    },
	    bgColor: function bgColor() {
	      return 'hsl(' + this.colors.hsl.h + ', 100%, 50%)';
	    },
	    pointerTop: function pointerTop() {
	      return -(this.colors.hsv.v * 100) + 100 + '%';
	    },
	    pointerLeft: function pointerLeft() {
	      return this.colors.hsv.s * 100 + '%';
	    }
	  },
	  methods: {
	    throttle: (0, _lodash2.default)(function (fn, data) {
	      fn(data);
	    }, 20, {
	      'leading': true,
	      'trailing': false
	    }),
	    handleChange: function handleChange(e, skip) {
	      !skip && e.preventDefault();
	      var container = this.$refs.container;
	      var containerWidth = container.clientWidth;
	      var containerHeight = container.clientHeight;
	
	      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
	      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
	      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
	      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
	      var left = pageX - xOffset;
	      var top = pageY - yOffset;
	
	      if (left < 0) {
	        left = 0;
	      } else if (left > containerWidth) {
	        left = containerWidth;
	      } else if (top < 0) {
	        top = 0;
	      } else if (top > containerHeight) {
	        top = containerHeight;
	      }
	
	      var saturation = left * 100 / containerWidth;
	      var bright = -(top * 100 / containerHeight) + 100;
	
	      this.throttle(this.onChange, {
	        h: this.colors.hsl.h,
	        s: saturation,
	        v: bright > 0 ? bright : 0.01,
	        a: this.colors.hsl.a,
	        source: 'hsva'
	      });
	    },
	    onChange: function onChange(param) {
	      this.$emit('change', param);
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      window.addEventListener('mousemove', this.handleChange);
	      window.addEventListener('mouseup', this.handleChange);
	      window.addEventListener('mouseup', this.handleMouseUp);
	    },
	    handleMouseUp: function handleMouseUp(e) {
	      this.unbindEventListeners();
	    },
	    unbindEventListeners: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }
	};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'nprogress-container'
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NprogressContainer = __webpack_require__(299);
	
	var _NprogressContainer2 = _interopRequireDefault(_NprogressContainer);
	
	var _NavBar = __webpack_require__(272);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _AppMain = __webpack_require__(271);
	
	var _AppMain2 = _interopRequireDefault(_AppMain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NprogressContainer: _NprogressContainer2.default,
	    NavBar: _NavBar2.default,
	    AppMain: _AppMain2.default
	  },
	
	  beforeMount: function beforeMount() {
	
	    var handler = function handler() {
	      if (!document.hidden) {}
	    };
	
	    document.addEventListener('visibilitychange', handler);
	    window.addEventListener('DOMContentLoaded', handler);
	    window.addEventListener('resize', handler);
	
	    var el = document.createElement('script');
	    el.setAttribute('type', 'text/javascript');
	    el.setAttribute('src', 'http://services.mnc.takemedia.pt/resources/pano2vr_player.js');
	    document.getElementsByTagName('head')[0].appendChild(el);
	  },
	
	
	  computed: {
	    showNavBar: function showNavBar() {
	      return this.$store.state.config.navbar;
	    }
	  }
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__(22);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _CoachInfo = __webpack_require__(263);
	
	var _CoachInfo2 = _interopRequireDefault(_CoachInfo);
	
	var _CoachScreensaver = __webpack_require__(265);
	
	var _CoachScreensaver2 = _interopRequireDefault(_CoachScreensaver);
	
	var _CoachCategories = __webpack_require__(260);
	
	var _CoachCategories2 = _interopRequireDefault(_CoachCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Breadcrumb: _Breadcrumb2.default,
	    CoachInfo: _CoachInfo2.default,
	    CoachScreensaver: _CoachScreensaver2.default,
	    CoachCategories: _CoachCategories2.default
	  },
	
	  data: function data() {
	    return {
	      breadcrumbList: null,
	      isDataLoaded: false
	    };
	  },
	  mounted: function mounted() {
	    this.getCoachData();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    coach: function coach() {
	      return this.$store.state.coach.data;
	    }
	  },
	
	  methods: {
	    getCoachData: function getCoachData() {
	      this.$store.dispatch('getCoach', this.$store.state.route.params.id);
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	
	    coach: function coach(val) {
	      if (val) {
	        var id = val.id;
	        var name = val.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + name, path: '/' + id }];
	
	        this.isDataLoaded = true;
	      }
	    }
	  }
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _ImageComposite = __webpack_require__(61);
	
	var _ImageComposite2 = _interopRequireDefault(_ImageComposite);
	
	var _config = __webpack_require__(3);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _CoachDeleteModal = __webpack_require__(262);
	
	var _CoachDeleteModal2 = _interopRequireDefault(_CoachDeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardModalComponent = _vue2.default.extend(_CoachDeleteModal2.default);
	
	exports.default = {
	  components: {
	    ImageComposite: _ImageComposite2.default,
	    CardModal: _CoachDeleteModal2.default
	  },
	
	  props: {
	    coach: {}
	  },
	
	  data: function data() {
	    return {
	      confirmDelete: false
	    };
	  },
	
	
	  computed: {
	    coachState: function coachState() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(_config.CONTENT_STATES), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var state = _step.value;
	
	          if (state.id === parseInt(this.coach.state_id)) {
	            return state.name;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return null;
	    },
	    deleteText: function deleteText() {
	      if (this.confirmDelete) {
	        return 'Tem certeza?';
	      } else {
	        return 'Apagar';
	      }
	    },
	    background: function background() {
	      return this.coach.background_path ? _config.COACH_IMG_PATH + this.coach.background_path : null;
	    },
	    foreground: function foreground() {
	      return this.coach.foreground_path ? _config.COACH_IMG_PATH + this.coach.foreground_path : null;
	    }
	  },
	
	  methods: {
	    openDeleteModal: function openDeleteModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Apagar Coche?',
	        id: parseInt(this.coach.id)
	      });
	    },
	    editCoach: function editCoach() {
	      window.router.push({ name: 'Coche', params: { id: this.coach.id } });
	    },
	    deleteCoach: function deleteCoach() {
	      var _this = this;
	
	      if (this.confirmDelete) {
	        this.$store.dispatch('deleteCoach', this.coach.id);
	      } else {
	        this.confirmDelete = true;
	        setTimeout(function () {
	          _this.confirmDelete = false;
	        }, 4000);
	      }
	    }
	  }
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _CoachEditCategoryModal = __webpack_require__(54);
	
	var _CoachEditCategoryModal2 = _interopRequireDefault(_CoachEditCategoryModal);
	
	var _CoachDeleteCategoryModal = __webpack_require__(261);
	
	var _CoachDeleteCategoryModal2 = _interopRequireDefault(_CoachDeleteCategoryModal);
	
	var _StateSelector = __webpack_require__(17);
	
	var _StateSelector2 = _interopRequireDefault(_StateSelector);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachEditCategoryModalComponent = _vue2.default.extend(_CoachEditCategoryModal2.default);
	var CoachDeleteCategoryModalComponent = _vue2.default.extend(_CoachDeleteCategoryModal2.default);
	
	exports.default = {
	  components: {
	    StateSelector: _StateSelector2.default
	  },
	
	  data: function data() {
	    return {
	      coachId: this.$store.state.route.params.id,
	      selectedCategory: null,
	      imagePath: _config.BACKGROUND_IMG_PATH,
	      isDataLoaded: false
	    };
	  },
	  mounted: function mounted() {
	    this.getCategoryData();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    slideCategories: function slideCategories() {
	      return this.$store.state.coach.slideCategories;
	    },
	    coachCategories: function coachCategories() {
	      return this.$store.state.coach.coachCategories;
	    },
	    selectedCategoryText: function selectedCategoryText() {
	      if (this.selectedCategory) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.slideCategories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var category = _step.value;
	
	            if (parseInt(category.id) === this.selectedCategory) {
	              return category.languages[0].pivot.name;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      return null;
	    },
	    selectedCategorySlug: function selectedCategorySlug() {
	      if (this.selectedCategory) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.slideCategories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var category = _step2.value;
	
	            if (parseInt(category.id) === this.selectedCategory) {
	              return category.slug;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	      return null;
	    }
	  },
	
	  methods: {
	    getCategoryData: function getCategoryData() {
	      this.$store.dispatch('getCategoryList', this.coachId);
	    },
	    goToSlide: function goToSlide(slide) {
	      var route = this.coachId + '/menu/' + slide;
	      window.router.push(route);
	    },
	    goToExterior: function goToExterior() {
	      var route = this.coachId + '/exterior';
	      window.router.push(route);
	    },
	    goToPanorama: function goToPanorama() {
	      var route = this.coachId + '/panorama';
	      window.router.push(route);
	    },
	    addCoachEditCategoryModal: function addCoachEditCategoryModal() {
	      if (this.selectedCategorySlug !== 'panorama') {
	        var openCardModal = function openCardModal() {
	          var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          return new CoachEditCategoryModalComponent({
	            el: document.createElement('div'),
	            propsData: propsData
	          });
	        };
	
	        openCardModal({
	          title: 'Adicionar - ' + this.selectedCategoryText,
	          category_id: this.selectedCategory,
	          coach_id: parseInt(this.coachId)
	        });
	      } else {
	        var category = {
	          slide_category_id: this.selectedCategory,
	          coach_id: parseInt(this.coachId),
	          background_color: _config.WHITE_COLOR,
	          textbox_color: _config.WHITE_COLOR,
	          text_color: _config.WHITE_COLOR,
	          background_image_1: null,
	          background_image_2: null,
	          background_path_1: null,
	          background_path_2: null
	        };
	        this.$store.dispatch('categoryCoach', category);
	      }
	    },
	    editCoachEditCategoryModal: function editCoachEditCategoryModal(category) {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CoachEditCategoryModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Editar - ' + category.languages[0].pivot.name,
	        category_id: parseInt(category.slide_category_id),
	        coach_id: parseInt(this.coachId),
	        categoryData: category
	      });
	    },
	    removeCoachDeleteCategoryModal: function removeCoachDeleteCategoryModal(category) {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CoachDeleteCategoryModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Remover Menu?',
	        category_id: parseInt(category.slide_category_id),
	        coach_id: parseInt(this.coachId)
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	
	    coachCategories: function coachCategories(val) {
	      if (val) {
	        this.isDataLoaded = true;
	      }
	    }
	  }
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    category_id: Number,
	    coach_id: Number
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return true;
	    },
	    previewIsActive: function previewIsActive() {
	      return false;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        window.store.dispatch('categoryCoachRemove', { slide_category_id: this.category_id, coach_id: this.coach_id });
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    id: Number
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return true;
	    },
	    previewIsActive: function previewIsActive() {
	      return false;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        window.store.dispatch('deleteCoach', this.id);
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _ColorPicker = __webpack_require__(41);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _config = __webpack_require__(3);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _tinycolor = __webpack_require__(28);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setColor(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  if (hsl.s === 0) {
	    hsl.h = data.h || oldHue || 0;
	    hsv.h = data.h || oldHue || 0;
	  }
	  return {
	    hsl: hsl,
	    hex: color.toHexString().toUpperCase(),
	    rgba: color.toRgb(),
	    hsv: hsv,
	    a: 1
	  };
	}
	
	function getImgSize(imgSrc, callback) {
	  var newImg = new Image();
	  newImg.onload = function () {
	    if (callback !== undefined) {
	      callback({ width: newImg.width, height: newImg.height });
	    }
	  };
	  newImg.src = imgSrc;
	}
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    'sketch-picker': _ColorPicker2.default,
	    Dropzone: _DropzoneForm2.default
	  },
	
	  props: {
	    title: String,
	    category_id: Number,
	    coach_id: Number,
	    categoryData: Object
	  },
	
	  data: function data() {
	    return {
	      pickerColor: _config.WHITE_COLOR,
	      showColorPicker: false,
	      currentColorPicker: 'background',
	      colorPickerPosition: 1,
	      colorPickerBtnTextBackground: 'Selecionar Cor',
	      colorPickerBtnTextTextbox: 'Selecionar Cor',
	      colorPickerBtnTextText: 'Selecionar Cor',
	      showPreview: false,
	      category: {
	        slide_category_id: this.category_id,
	        coach_id: this.coach_id,
	        background_color: _config.WHITE_COLOR,
	        textbox_color: _config.WHITE_COLOR,
	        text_color: _config.WHITE_COLOR,
	        background_image_1: null,
	        background_image_2: null,
	        background_path_1: null,
	        background_path_2: null
	      },
	      newBackground1: false,
	      newBackground2: false
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var trash = document.body.querySelectorAll('.dz-hidden-input');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(trash), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        t.remove();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.categoryData) {
	      this.category.background_color = setColor(this.categoryData.background_color);
	      this.category.textbox_color = setColor(this.categoryData.textbox_color);
	      this.category.text_color = setColor(this.categoryData.text_color);
	
	      this.category.background_image_1 = this.categoryData.background_path_1 ? _config.BACKGROUND_IMG_PATH + this.categoryData.background_path_1 : null;
	      this.category.background_path_1 = this.categoryData.background_path_1;
	      this.category.background_image_2 = this.categoryData.background_path_2 ? _config.BACKGROUND_IMG_PATH + this.categoryData.background_path_2 : null;
	      this.category.background_path_2 = this.categoryData.background_path_2;
	    }
	
	    var _this = this;
	    if (_this.category.background_image_1) {
	      getImgSize(_this.category.background_image_1, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-1 img').style.minWidth = resize + 'px';
	        }
	      });
	    }
	
	    if (_this.category.background_image_2) {
	      getImgSize(_this.category.background_image_2, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-2 img').style.minWidth = resize + 'px';
	        }
	      });
	    }
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    userToken: function userToken() {
	      return window.store.state.auth.token;
	    },
	    dropzoneUploadUrl: function dropzoneUploadUrl() {
	      return _config.API_ROOT + 'resource/coach/upload/background?token=' + this.userToken;
	    }
	  },
	
	  methods: {
	    successUploadBackground: function successUploadBackground(file) {
	      var path = JSON.parse(file.xhr.response).file;
	      this.category.background_image_1 = path ? _config.BACKGROUND_IMG_PATH + JSON.parse(file.xhr.response).file : null;
	      this.category.background_path_1 = JSON.parse(file.xhr.response).file;
	
	      this.newBackground1 = false;
	
	      var _this = this;
	      getImgSize(_this.category.background_image_1, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-1 img').style.minWidth = resize + 'px';
	        }
	      });
	    },
	    removeBackground: function removeBackground() {
	      console.log('A file was been removed');
	      this.category.background_image_1 = null;
	      this.category.background_path_1 = null;
	    },
	    successUploadForeground: function successUploadForeground(file) {
	      var path = JSON.parse(file.xhr.response).file;
	      this.category.background_image_2 = path ? _config.BACKGROUND_IMG_PATH + JSON.parse(file.xhr.response).file : null;
	      this.category.background_path_2 = JSON.parse(file.xhr.response).file;
	
	      this.newBackground2 = false;
	
	      var _this = this;
	      getImgSize(_this.category.background_image_2, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-2 img').style.minWidth = resize + 'px';
	        }
	      });
	    },
	    removeForeground: function removeForeground() {
	      console.log('A file was been removed');
	      this.category.background_image_2 = null;
	      this.category.background_path_2 = null;
	    },
	    onChangePickerColor: function onChangePickerColor(val) {
	      switch (this.currentColorPicker) {
	        case 'background':
	          this.category.background_color = val;
	          break;
	        case 'textbox':
	          this.category.textbox_color = val;
	          break;
	        case 'text':
	          this.category.text_color = val;
	          break;
	      }
	    },
	    toogleColorPicker: function toogleColorPicker(selector) {
	      if (selector === this.currentColorPicker || !this.showColorPicker) {
	        this.showColorPicker = !this.showColorPicker;
	      }
	      this.currentColorPicker = selector;
	
	      this.colorPickerBtnTextBackground = 'Selecionar Cor';
	      this.colorPickerBtnTextTextbox = 'Selecionar Cor';
	      this.colorPickerBtnTextText = 'Selecionar Cor';
	
	      switch (selector) {
	        case 'background':
	          if (this.showColorPicker) {
	            this.pickerColor = this.category.background_color;
	            this.colorPickerBtnTextBackground = 'Fechar';
	          }
	          this.colorPickerPosition = 1;
	          break;
	        case 'textbox':
	          if (this.showColorPicker) {
	            this.pickerColor = this.category.textbox_color;
	            this.colorPickerBtnTextTextbox = 'Fechar';
	          }
	          this.colorPickerPosition = 2;
	          break;
	        case 'text':
	          if (this.showColorPicker) {
	            this.pickerColor = this.category.text_color;
	            this.colorPickerBtnTextText = 'Fechar';
	          }
	          this.colorPickerPosition = 3;
	          break;
	        default:
	          this.showColorPicker = false;
	      }
	    },
	    showDropzone: function showDropzone(selector) {
	      if (selector === 'background1') {
	        this.newBackground1 = true;
	        this.removeBackground();
	      }
	
	      if (selector === 'background2') {
	        this.newBackground2 = true;
	        this.removeForeground();
	      }
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        if (this.categoryData) {
	          window.store.dispatch('categoryCoachUpdate', this.category);
	        } else {
	          window.store.dispatch('categoryCoach', this.category);
	        }
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    }
	  }
	};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _ColorPicker = __webpack_require__(41);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _config = __webpack_require__(3);
	
	var _ImageComposite = __webpack_require__(61);
	
	var _ImageComposite2 = _interopRequireDefault(_ImageComposite);
	
	var _tinycolor = __webpack_require__(28);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setColor(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  if (hsl.s === 0) {
	    hsl.h = data.h || oldHue || 0;
	    hsv.h = data.h || oldHue || 0;
	  }
	  return {
	    hsl: hsl,
	    hex: color.toHexString().toUpperCase(),
	    rgba: color.toRgb(),
	    hsv: hsv,
	    a: 1
	  };
	}
	
	var DESKTOP_MIN_WIDTH = 769;
	var MAX_PREVIEW_SIZE_MOBILE = 671;
	var DEFAULT_PREVIEW_SIZE = 600;
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    'sketch-picker': _ColorPicker2.default,
	    Dropzone: _DropzoneForm2.default,
	    ImageComposite: _ImageComposite2.default
	  },
	
	  props: {
	    title: String,
	    coachData: Object
	  },
	
	  data: function data() {
	    return {
	      pickerColor: _config.WHITE_COLOR,
	      showColorPicker: false,
	      currentColorPicker: 'background',
	      colorPickerPosition: 1,
	      colorPickerBtnTextBackground: 'Selecionar Cor',
	      colorPickerBtnTextTitle: 'Selecionar Cor',
	      colorPickerBtnTextFilet: 'Selecionar Cor',
	      colorPickerBtnTextActive: 'Selecionar Cor',
	      colorPickerBtnTextInactive: 'Selecionar Cor',
	      showPreview: false,
	      previewLanguage: 'pt',
	      previewText: null,
	      previewImageWidth: 600,
	      previewWarning: 'Esta pré-visualização pode não ser uma representação fiel dos quiosques.',
	      coach: {
	        name: {
	          pt: null,
	          en: null,
	          es: null,
	          fr: null
	        },
	        background_color: _config.WHITE_COLOR,
	        title_color: _config.WHITE_COLOR,
	        filet_color: _config.WHITE_COLOR,
	        active_color: _config.WHITE_COLOR,
	        inactive_color: _config.WHITE_COLOR,
	        background_image: null,
	        foreground_image: null,
	        background_path: null,
	        foreground_path: null
	      },
	      previewActiveStyle: {
	        color: '#FFFFFF',
	        background: '#FFFFFF',
	        border: '1px solid #FFFFFF'
	      },
	      previewInactiveStyle: {
	        color: '#FFFFFF',
	        background: '#FFFFFF',
	        border: '1px solid #FFFFFF'
	      },
	      newBackground: false,
	      newForeground: false
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var trash = document.body.querySelectorAll('.dz-hidden-input');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(trash), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        t.remove();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$nextTick(function () {
	      window.addEventListener('resize', this.handleResize);
	
	      if (this.coach.background_color) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	
	      if (this.coachData) {
	        this.coach.name.pt = this.coachData.languages[0].pivot.name;
	        this.coach.name.en = this.coachData.languages[1].pivot.name;
	        this.coach.name.es = this.coachData.languages[2].pivot.name;
	        this.coach.name.fr = this.coachData.languages[3].pivot.name;
	
	        this.coach.background_color = this.coachData.background_color ? setColor(this.coachData.background_color) : _config.WHITE_COLOR;
	        this.coach.title_color = this.coachData.title_color ? setColor(this.coachData.title_color) : _config.WHITE_COLOR;
	        this.coach.filet_color = this.coachData.filet_color ? setColor(this.coachData.filet_color) : _config.WHITE_COLOR;
	        this.coach.active_color = this.coachData.active_color ? setColor(this.coachData.active_color) : _config.WHITE_COLOR;
	        this.coach.inactive_color = this.coachData.inactive_color ? setColor(this.coachData.inactive_color) : _config.WHITE_COLOR;
	
	        this.coach.background_image = this.coachData.background_path ? _config.COACH_IMG_PATH + this.coachData.background_path : null;
	        this.coach.background_path = this.coachData.background_path;
	        this.coach.foreground_image = _config.COACH_IMG_PATH + this.coachData.foreground_path;
	        this.coach.foreground_path = this.coachData.foreground_path;
	      }
	    });
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    zoomScaleValue: function zoomScaleValue() {
	      return this.previewImageWidth / DEFAULT_PREVIEW_SIZE;
	    },
	    textZoom: function textZoom() {
	      return 'scale(' + this.zoomScaleValue + ')';
	    },
	    leftScale: function leftScale() {
	      return 88 * this.zoomScaleValue + 'px';
	    },
	    submitIsActive: function submitIsActive() {
	      return this.coach.name.pt && this.coach.name.en && this.coach.name.es && this.coach.name.fr && this.coach.foreground_image;
	    },
	    previewIsActive: function previewIsActive() {
	      return this.coach.background_color;
	    },
	    userToken: function userToken() {
	      return window.store.state.auth.token;
	    },
	    dropzoneUploadUrl: function dropzoneUploadUrl() {
	      return _config.API_ROOT + 'resource/coach/upload?token=' + this.userToken;
	    },
	    backgroundLightness: function backgroundLightness() {
	      return this.coach.background_color.hsl.l;
	    }
	  },
	
	  methods: {
	    successUploadBackground: function successUploadBackground(file) {
	      this.coach.background_image = _config.COACH_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.coach.background_path = JSON.parse(file.xhr.response).file;
	
	      this.newBackground = false;
	    },
	    removeBackground: function removeBackground() {
	      console.log('A file was been removed');
	      this.coach.background_image = null;
	      this.coach.background_path = null;
	    },
	    successUploadForeground: function successUploadForeground(file) {
	      this.coach.foreground_image = _config.COACH_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.coach.foreground_path = JSON.parse(file.xhr.response).file;
	
	      this.newForeground = false;
	    },
	    removeForeground: function removeForeground() {
	      console.log('A file was been removed');
	      this.coach.foreground_image = null;
	      this.coach.foreground_path = null;
	    },
	    isSelectedLanguage: function isSelectedLanguage(slug) {
	      return slug === this.previewLanguage;
	    },
	    onChangePickerColor: function onChangePickerColor(val) {
	      switch (this.currentColorPicker) {
	        case 'background':
	          this.coach.background_color = val;
	          break;
	        case 'title':
	          this.coach.title_color = val;
	          break;
	        case 'filet':
	          this.coach.filet_color = val;
	          break;
	        case 'inactive':
	          this.coach.inactive_color = val;
	          break;
	        case 'active':
	          this.coach.active_color = val;
	          break;
	      }
	    },
	    handleResize: function handleResize() {
	      if (this.showPreview) {
	        var element = document.getElementById('coach-image-preview-container');
	        if (element) {
	          this.previewImageWidth = element.getBoundingClientRect().width;
	        }
	      }
	    },
	    toogleColorPicker: function toogleColorPicker(selector) {
	      if (selector === this.currentColorPicker || !this.showColorPicker) {
	        this.showColorPicker = !this.showColorPicker;
	      }
	      this.currentColorPicker = selector;
	
	      this.colorPickerBtnTextBackground = 'Selecionar Cor';
	      this.colorPickerBtnTextTitle = 'Selecionar Cor';
	      this.colorPickerBtnTextFilet = 'Selecionar Cor';
	      this.colorPickerBtnTextInactive = 'Selecionar Cor';
	      this.colorPickerBtnTextActive = 'Selecionar Cor';
	
	      switch (selector) {
	        case 'background':
	          if (this.showColorPicker) {
	            this.pickerColor = this.coach.background_color;
	            this.colorPickerBtnTextBackground = 'Fechar';
	          }
	          this.colorPickerPosition = 1;
	          break;
	        case 'title':
	          if (this.showColorPicker) {
	            this.pickerColor = this.coach.title_color;
	            this.colorPickerBtnTextTitle = 'Fechar';
	          }
	          this.colorPickerPosition = 2;
	          break;
	        case 'inactive':
	          if (this.showColorPicker) {
	            this.pickerColor = this.coach.inactive_color;
	            this.colorPickerBtnTextInactive = 'Fechar';
	          }
	          this.colorPickerPosition = 3;
	          break;
	        case 'active':
	          if (this.showColorPicker) {
	            this.pickerColor = this.coach.active_color;
	            this.colorPickerBtnTextActive = 'Fechar';
	          }
	          this.colorPickerPosition = 4;
	          break;
	        case 'filet':
	          if (this.showColorPicker) {
	            this.pickerColor = this.coach.filet_color;
	            this.colorPickerBtnTextFilet = 'Fechar';
	          }
	          this.colorPickerPosition = 5;
	          break;
	        default:
	          this.showColorPicker = false;
	      }
	    },
	    showDropzone: function showDropzone(selector) {
	      if (selector === 'background') {
	        this.newBackground = true;
	        this.removeBackground();
	      }
	
	      if (selector === 'foreground') {
	        this.newForeground = true;
	        this.removeForeground();
	      }
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      this.toogleColorPicker(null);
	
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        if (this.coachData) {
	          window.store.dispatch('updateCoach', { id: this.coachData.id, data: this.coach });
	        } else {
	          window.store.dispatch('saveCoach', this.coach);
	        }
	      }
	      if (val === 'modal-card-preview') {
	        if (!this.showPreview) {
	          this.previewText = this.coach.name[this.previewLanguage];
	
	          this.previewActiveStyle.color = this.coach.inactive_color.hex;
	          this.previewActiveStyle.background = this.coach.active_color.hex;
	          this.previewActiveStyle.border = '1px solid ' + this.coach.active_color.hex;
	
	          this.previewInactiveStyle.color = this.coach.active_color.hex;
	          this.previewInactiveStyle.background = this.coach.inactive_color.hex;
	          this.previewInactiveStyle.border = '1px solid ' + this.coach.active_color.hex;
	        }
	
	        this.showPreview = !this.showPreview;
	      }
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    showPreview: function showPreview(val) {
	      if (val && window.innerWidth < DESKTOP_MIN_WIDTH) {
	        this.previewImageWidth = MAX_PREVIEW_SIZE_MOBILE - (DESKTOP_MIN_WIDTH - 1 - window.innerWidth);
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (document.querySelector('.card-modal-ok-btn')) {
	        if (val) {
	          document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	        } else {
	          document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	        }
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (document.querySelector('.card-modal-preview-btn')) {
	        if (val) {
	          document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	        } else {
	          document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	        }
	      }
	    },
	
	    previewLanguage: function previewLanguage(val) {
	      this.previewText = this.coach.name[val];
	    }
	  }
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _config = __webpack_require__(3);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _CoachEditModal = __webpack_require__(55);
	
	var _CoachEditModal2 = _interopRequireDefault(_CoachEditModal);
	
	var _StateSelector = __webpack_require__(17);
	
	var _StateSelector2 = _interopRequireDefault(_StateSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachEditModalComponent = _vue2.default.extend(_CoachEditModal2.default);
	
	exports.default = {
	  components: {
	    StateSelector: _StateSelector2.default
	  },
	
	  props: ['coach'],
	
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    coachState: function coachState() {
	      var stateId = this.getCoachProperty('state_id');
	      var text = null;
	      var color = null;
	
	      switch (parseInt(stateId)) {
	        case 1:
	          text = 'Rascunho';
	          color = 'is-danger';
	          break;
	        case 2:
	          text = 'Pendente';
	          color = 'is-warning';
	          break;
	        case 3:
	          text = 'Publicado';
	          color = 'is-success';
	          break;
	        case 4:
	          text = 'Apagado';
	          color = 'is-dark';
	          break;
	        default:
	          text = 'Estado desconhecido';
	          color = 'is-info';
	      }
	
	      return { text: text, color: color };
	    },
	    coachBackground: function coachBackground() {
	      return this.getCoachProperty('background_path') ? _config.COACH_IMG_PATH + this.coach.background_path : null;
	    },
	    coachForeground: function coachForeground() {
	      return this.getCoachProperty('foreground_path') ? _config.COACH_IMG_PATH + this.coach.foreground_path : null;
	    }
	  },
	
	  methods: {
	    getCoachNameByLanguage: function getCoachNameByLanguage(slug) {
	      if (this.coach) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.coach.languages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var lang = _step.value;
	
	            if (lang.slug === slug) {
	              return lang.pivot.name;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      return null;
	    },
	    getCoachProperty: function getCoachProperty(property) {
	      if (this.coach) {
	        return this.coach[property];
	      }
	      return null;
	    },
	    openEditCoachModal: function openEditCoachModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CoachEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Editar Coche',
	        coachData: this.coach
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {}
	  }
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _CoachEditModal = __webpack_require__(55);
	
	var _CoachEditModal2 = _interopRequireDefault(_CoachEditModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardModalComponent = _vue2.default.extend(_CoachEditModal2.default);
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	
	  methods: {
	    openNewCoachModal: function openNewCoachModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Novo Coche',
	        coachData: null
	      });
	    }
	  }
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(3);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _CoachScreensaverModal = __webpack_require__(266);
	
	var _CoachScreensaverModal2 = _interopRequireDefault(_CoachScreensaverModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachScreensaverModalComponent = _vue2.default.extend(_CoachScreensaverModal2.default);
	
	exports.default = {
	  components: {},
	
	  props: ['coach'],
	
	  data: function data() {
	    return {
	      screensaverLocation: _config.COACH_SAVER_PATH
	    };
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {
	    openCoachScreensaverModal: function openCoachScreensaverModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CoachScreensaverModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Editar Screensaver',
	        coach: this.coach.id,
	        video: this.coach.screensaver_path
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {}
	  }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    Dropzone: _DropzoneForm2.default
	  },
	
	  props: {
	    title: String,
	    coach: String,
	    video: String
	  },
	
	  data: function data() {
	    return {
	      screensaverLocation: _config.COACH_SAVER_PATH,
	      newVideo: false,
	      coachVideo: this.video,
	      showPreview: false
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var trash = document.body.querySelectorAll('.dz-hidden-input');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(trash), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        t.remove();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    userToken: function userToken() {
	      return window.store.state.auth.token;
	    },
	    dropzoneUploadUrl: function dropzoneUploadUrl() {
	      return _config.API_ROOT + 'resource/coach/upload/screensaver?token=' + this.userToken;
	    },
	    submitIsActive: function submitIsActive() {
	      return false;
	    }
	  },
	
	  methods: {
	    successUploadVideo: function successUploadVideo(file) {
	      this.coachVideo = JSON.parse(file.xhr.response).file;
	    },
	    removeVideo: function removeVideo() {
	      console.log('A file was been removed');
	      this.coachVideo = null;
	    },
	    showDropzone: function showDropzone() {
	      this.newVideo = true;
	      this.removeVideo();
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        window.store.dispatch('updateCoachScreensaver', { id: this.coach, data: { file: this.coachVideo } });
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachNew = __webpack_require__(264);
	
	var _CoachNew2 = _interopRequireDefault(_CoachNew);
	
	var _CoachCard = __webpack_require__(259);
	
	var _CoachCard2 = _interopRequireDefault(_CoachCard);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CoachNew: _CoachNew2.default,
	    CoachCard: _CoachCard2.default
	  },
	
	  data: function data() {
	    return {
	      states: _config.CONTENT_STATES,
	      selectedState: 0,
	      searchText: ''
	    };
	  },
	  mounted: function mounted() {
	    this.getCoachList();
	  },
	
	
	  computed: {
	    coaches: function coaches() {
	      return this.$store.state.coach.list;
	    },
	    filteredCoaches: function filteredCoaches() {
	      var searchText = this.searchText;
	      var selectedState = this.selectedState;
	      var coachList = this.coaches;
	
	      if (searchText.length) {
	        coachList = coachList.filter(function (coach) {
	          return coach.languages[0].pivot.name.toLowerCase().includes(searchText.toLowerCase());
	        });
	      }
	
	      if (selectedState) {
	        coachList = coachList.filter(function (coach) {
	          return parseInt(coach.state_id) === selectedState;
	        });
	      }
	
	      return coachList;
	    },
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {
	    getCoachList: function getCoachList() {
	      this.$store.dispatch('getCoachList');
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'update-coach-list') {
	        this.getCoachList();
	      }
	    }
	  }
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ExteriorEditModal = __webpack_require__(56);
	
	var _ExteriorEditModal2 = _interopRequireDefault(_ExteriorEditModal);
	
	var _ExteriorDeleteModal = __webpack_require__(269);
	
	var _ExteriorDeleteModal2 = _interopRequireDefault(_ExteriorDeleteModal);
	
	var _StateSelector = __webpack_require__(17);
	
	var _StateSelector2 = _interopRequireDefault(_StateSelector);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExteriorEditModalComponent = _vue2.default.extend(_ExteriorEditModal2.default);
	var ExteriorDeleteModalComponent = _vue2.default.extend(_ExteriorDeleteModal2.default);
	
	exports.default = {
	  components: {
	    StateSelector: _StateSelector2.default
	  },
	
	  props: {
	    exterior: Object,
	    exteriorTotal: Number
	  },
	
	  data: function data() {
	    return {
	      coachId: this.$store.state.route.params.id,
	      exteriorImagePath: _config.EXTERIOR_IMG_PATH,
	      mounted: false,
	      images: {
	        pt: null,
	        en: null,
	        es: null,
	        fr: null
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.mounted = true;
	    this.setImages();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {
	    reorderExteriors: function reorderExteriors(newPosition) {
	      this.$store.dispatch('reorderExteriors', { coach: this.coachId, exterior: this.exterior, position: newPosition });
	    },
	    setImages: function setImages() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.exterior.images), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var image = _step.value;
	
	          this.images[image.lang] = image.imageUrl;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    openExteriorEditModal: function openExteriorEditModal() {
	      var openCardModalExterior = function openCardModalExterior() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new ExteriorEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModalExterior({
	        title: 'Editar Exterior',
	        exteriorTotal: this.exteriorTotal,
	        exteriorData: this.exterior
	      });
	    },
	    openExteriorDeleteModal: function openExteriorDeleteModal() {
	      var openCardModalExterior = function openCardModalExterior() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new ExteriorDeleteModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModalExterior({
	        title: 'Apagar Exterior',
	        id: parseInt(this.exterior.exteriorId)
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	    exterior: function exterior(val) {
	      this.setImages();
	    }
	  }
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    id: Number
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return true;
	    },
	    previewIsActive: function previewIsActive() {
	      return false;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        window.store.dispatch('deleteExterior', { exteriorId: this.id, coachId: window.store.state.route.params.id });
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    Dropzone: _DropzoneForm2.default
	  },
	
	  props: {
	    title: String,
	    exteriorTotal: Number,
	    exteriorData: Object
	  },
	
	  data: function data() {
	    return {
	      exterior: {
	        exteriorId: null,
	        coach: window.store.state.route.params.id,
	        images: {
	          pt: {
	            path: null,
	            url: null
	          },
	          en: {
	            path: null,
	            url: null
	          },
	          es: {
	            path: null,
	            url: null
	          },
	          fr: {
	            path: null,
	            url: null
	          }
	        },
	        order: this.exteriorTotal + 1
	      },
	      newImagePT: false,
	      newImageEN: false,
	      newImageES: false,
	      newImageFR: false
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var trash = document.body.querySelectorAll('.dz-hidden-input');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(trash), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        t.remove();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.setImages();
	    if (this.exteriorData) {
	      this.exterior.exteriorId = this.exteriorData.exteriorId;
	    }
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return this.exterior.images.pt.path && this.exterior.images.en.path && this.exterior.images.es.path && this.exterior.images.fr.path;
	    },
	    orderOptions: function orderOptions() {
	      var object = [];
	      var target = this.exteriorTotal;
	      if (!this.exteriorData) {
	        target += 1;
	      }
	      for (var i = 1; i <= target; i++) {
	        object.push({ id: i, value: i });
	      }
	      return object;
	    },
	    userToken: function userToken() {
	      return window.store.state.auth.token;
	    },
	    dropzoneUploadUrl: function dropzoneUploadUrl() {
	      return _config.API_ROOT + 'resource/exterior/upload?token=' + this.userToken;
	    }
	  },
	
	  methods: {
	    setImages: function setImages() {
	      if (this.exteriorData) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.exteriorData.images), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var image = _step2.value;
	
	            this.exterior.images[image.lang].path = image.imagePath;
	            this.exterior.images[image.lang].url = image.imageUrl;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        this.exterior.order = parseInt(this.exteriorData.order);
	      }
	    },
	    successUploadPT: function successUploadPT(file) {
	      this.exterior.images.pt.url = _config.EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.exterior.images.pt.path = JSON.parse(file.xhr.response).file;
	
	      this.newImagePT = false;
	    },
	    removePT: function removePT() {
	      console.log('A file was been removed');
	      this.exterior.images.pt.url = null;
	      this.exterior.images.pt.path = null;
	    },
	    successUploadEN: function successUploadEN(file) {
	      this.exterior.images.en.url = _config.EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.exterior.images.en.path = JSON.parse(file.xhr.response).file;
	
	      this.newImageEN = false;
	    },
	    removeEN: function removeEN() {
	      console.log('A file was been removed');
	      this.exterior.images.en.url = null;
	      this.exterior.images.en.path = null;
	    },
	    successUploadES: function successUploadES(file) {
	      this.exterior.images.es.url = _config.EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.exterior.images.es.path = JSON.parse(file.xhr.response).file;
	
	      this.newImageES = false;
	    },
	    removeES: function removeES() {
	      console.log('A file was been removed');
	      this.exterior.images.es.url = null;
	      this.exterior.images.es.path = null;
	    },
	    successUploadFR: function successUploadFR(file) {
	      this.exterior.images.fr.url = _config.EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.exterior.images.fr.path = JSON.parse(file.xhr.response).file;
	
	      this.newImageFR = false;
	    },
	    removeFR: function removeFR() {
	      console.log('A file was been removed');
	      this.exterior.images.fr.url = null;
	      this.exterior.images.fr.path = null;
	    },
	    showDropzone: function showDropzone(selector) {
	      if (selector === 'imagePT') {
	        this.newImagePT = true;
	        this.removePT();
	      }
	
	      if (selector === 'imageEN') {
	        this.newImageEN = true;
	        this.removeEN();
	      }
	
	      if (selector === 'imageES') {
	        this.newImageES = true;
	        this.removeES();
	      }
	
	      if (selector === 'imageFR') {
	        this.newImageFR = true;
	        this.removeFR();
	      }
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        if (this.exteriorData) {
	          window.store.dispatch('updateExterior', this.exterior);
	        } else {
	          window.store.dispatch('saveExterior', this.exterior);
	        }
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__(22);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _ExteriorCard = __webpack_require__(268);
	
	var _ExteriorCard2 = _interopRequireDefault(_ExteriorCard);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ExteriorEditModal = __webpack_require__(56);
	
	var _ExteriorEditModal2 = _interopRequireDefault(_ExteriorEditModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExteriorEditModalComponent = _vue2.default.extend(_ExteriorEditModal2.default);
	
	exports.default = {
	  components: {
	    Breadcrumb: _Breadcrumb2.default,
	    ExteriorCard: _ExteriorCard2.default
	  },
	
	  data: function data() {
	    return {
	      breadcrumbList: null,
	      coachId: this.$store.state.route.params.id
	    };
	  },
	  mounted: function mounted() {
	    this.getExteriorsList();
	    this.getCoachData();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    coach: function coach() {
	      return this.$store.state.coach.data;
	    },
	    exteriors: function exteriors() {
	      return this.$store.state.exterior.data;
	    }
	  },
	
	  methods: {
	    getExteriorsList: function getExteriorsList() {
	      this.$store.dispatch('getExteriorsList', { coachId: this.coachId });
	    },
	    getCoachData: function getCoachData() {
	      this.$store.dispatch('getCoach', this.$store.state.route.params.id);
	    },
	    openExteriorEditModal: function openExteriorEditModal() {
	      var openCardModalExterior = function openCardModalExterior() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new ExteriorEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModalExterior({
	        title: 'Criar Exterior',
	        exteriorTotal: this.exteriors.length,
	        exteriorData: null
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'update-exterior-list') {
	        this.getUserList();
	      }
	    },
	
	    coach: function coach(val) {
	      if (val) {
	        var id = val.id;
	        var name = val.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + name, path: '/' + id }, { name: 'VISITA EXTERIOR', path: '' }];
	      }
	    }
	  }
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueBulmaNotification = __webpack_require__(293);
	
	var _vueBulmaNotification2 = _interopRequireDefault(_vueBulmaNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationComponent = _vue2.default.extend(_vueBulmaNotification2.default);
	
	var openNotification = function openNotification() {
	  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    title: '',
	    message: '',
	    type: '',
	    direction: '',
	    duration: 45000,
	    container: '.notifications'
	  };
	
	  return new NotificationComponent({
	    el: document.createElement('div'),
	    propsData: propsData
	  });
	};
	
	exports.default = {
	  components: {
	    Notification: _vueBulmaNotification2.default
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  computed: {
	    notification: function notification() {
	      return this.$store.state.notification.nextNotification;
	    },
	    currentRoute: function currentRoute() {
	      return this.$store.state.route.name;
	    },
	    showNavBar: function showNavBar() {
	      return this.$store.state.config.navbar;
	    }
	  },
	
	  created: function created() {
	    this.setNavBarState(this.currentRoute);
	  },
	
	  methods: {
	    openNotificationWithData: function openNotificationWithData() {
	      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';
	
	      openNotification({
	        title: title,
	        message: message,
	        type: type
	      });
	    },
	    setNavBarState: function setNavBarState(route) {
	      var showNavBar = this.$store.state.config.navbar;
	
	      if (route === 'Login') {
	        if (showNavBar) {
	          this.$store.dispatch('setNavbar', false);
	        }
	      } else {
	        if (!showNavBar) {
	          this.$store.dispatch('setNavbar', true);
	        }
	      }
	    }
	  },
	
	  watch: {
	    notification: function notification(val) {
	      if (val) {
	        this.openNotificationWithData(val.title, val.message, val.type);
	        this.$store.dispatch('nextNotification');
	      }
	    },
	    currentRoute: function currentRoute(val) {
	      this.setNavBarState(val);
	    }
	  }
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookies = __webpack_require__(18);
	
	var _tooltip = __webpack_require__(69);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Tooltip: _tooltip2.default
	  },
	
	  props: {
	    show: Boolean
	  },
	
	  data: function data() {
	    return {
	      showNavMenu: false
	    };
	  },
	
	
	  computed: {
	    username: function username() {
	      return (0, _cookies.getCookie)('username');
	    }
	  },
	
	  methods: {
	    logout: function logout() {
	      (0, _cookies.signOut)();
	      window.router.push({
	        path: '/login',
	        query: { redirect: this.$store.state.route.fullPath }
	      });
	    },
	    goTo: function goTo(path) {
	      window.router.push({
	        path: path
	      });
	    }
	  }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      user: {
	        email: '',
	        password: ''
	      }
	    };
	  },
	
	
	  route: {
	    activate: function activate(transition) {
	      this.token ? transition.redirect('/') : transition.next();
	    }
	  },
	
	  computed: {
	    btnIsLoading: function btnIsLoading() {
	      if (this.$store.state.notification.loadingButtons.includes('.btn-submit-login')) {
	        return true;
	      }
	      return false;
	    }
	  },
	
	  methods: {
	    login: function login() {
	      var user = this.user;
	      if (user.email && user.password) {
	        this.$store.dispatch('localLogin', user);
	      }
	    }
	  }
	};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _panoCoaches = __webpack_require__(72);
	
	var _panoCoaches2 = _interopRequireDefault(_panoCoaches);
	
	var _config = __webpack_require__(3);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _PanoramaHotspotModal = __webpack_require__(277);
	
	var _PanoramaHotspotModal2 = _interopRequireDefault(_PanoramaHotspotModal);
	
	var _PanoramaDeleteModal = __webpack_require__(276);
	
	var _PanoramaDeleteModal2 = _interopRequireDefault(_PanoramaDeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardHotspotModalComponent = _vue2.default.extend(_PanoramaHotspotModal2.default);
	var CardDeleteModalComponent = _vue2.default.extend(_PanoramaDeleteModal2.default);
	
	exports.default = {
	  components: {
	    Dropzone: _DropzoneForm2.default,
	    HotspotModal: _PanoramaHotspotModal2.default,
	    DeleteModal: _PanoramaDeleteModal2.default
	  },
	  props: {
	    panoramaData: Object
	  },
	
	  data: function data() {
	    return {
	      dropzoneUploadUrl: _config.API_ROOT + 'resource/panorama/upload/' + this.$store.state.route.params.id,
	      panoCoches: null,
	
	      panoramaInfo: {
	        pan: 0,
	        tilt: 0,
	        fov: 90,
	        cubes: [],
	        points: []
	      },
	      originalInformation: null,
	      newImages: {
	        0: true,
	        1: true,
	        2: true,
	        3: true,
	        4: true,
	        5: true
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        _this.panoCoches = new _panoCoaches2.default('panoramaViewer', { basePath: 'http://services.mnc.takemedia.pt/media/coach/panoramas/' });
	        var changeInfo = {};
	        for (var f in _this.panoramaInfo.cubes) {
	          changeInfo[f] = _this.panoramaInfo.cubes[f];
	        }
	        _this.panoCoches.changePanoramaImage(changeInfo);
	        changeInfo = {
	          pan: _this.panoramaInfo.pan,
	          tilt: _this.panoramaInfo.tilt,
	          fov: _this.panoramaInfo.fov
	        };
	        _this.panoCoches.setPanTiltFov(changeInfo);
	
	        for (var p in _this.panoramaData.panoramaPoints) {
	          var info = _this.panoramaData.panoramaPoints[p];
	          _this.panoCoches.addNewHotspot(info.languages[0].name, info.pointId, { pan: info.pan, tilt: info.tilt, fov: info.fov });
	        }
	      }, 500);
	    });
	
	    this.drawAnimation();
	
	    if (this.panoramaData) {
	      for (var i in this.panoramaData.panoramaCubes) {
	        var position = this.panoramaData.panoramaCubes[i].position;
	        this.panoramaInfo.cubes[position] = this.panoramaData.panoramaCubes[i].imagePath;
	        this.newImages[position] = false;
	      }
	      if (!this.originalInformation) {
	        this.originalInformation = { pan: null, tilt: null, fov: null };
	        this.originalInformation.pan = this.panoramaInfo.pan = this.panoramaData.pan;
	        this.originalInformation.tilt = this.panoramaInfo.tilt = this.panoramaData.tilt;
	        this.originalInformation.fov = this.panoramaInfo.fov = this.panoramaData.fov;
	        this.originalInformation.points = this.panoramaData.panoramaPoints;
	      }
	    }
	  },
	
	
	  computed: {
	    panoramaPoints: function panoramaPoints() {
	      if (this.panoramaData) {
	        return this.panoramaData.panoramaPoints;
	      } else {
	        return [];
	      }
	    },
	    panoramaCubes: function panoramaCubes() {
	      if (this.panoramaData) {
	        return this.panoramaData.panoramaCubes;
	      } else {
	        return [];
	      }
	    },
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    panoramaId: function panoramaId() {
	      return this.panoramaData ? this.panoramaData.id : null;
	    }
	  },
	  methods: {
	    successUploadImage: function successUploadImage(file, serverInfo) {
	      if (serverInfo) {
	        var changeInfo = {};
	        changeInfo[serverInfo.position] = serverInfo.file;
	        this.panoCoches.changePanoramaImage(changeInfo);
	        this.panoramaInfo.cubes[serverInfo.position] = serverInfo.file;
	        this.newImages[serverInfo.position] = false;
	      }
	    },
	    removeImage: function removeImage(position) {
	      if (!this.newImages[position]) {
	        var openCardModal = function openCardModal() {
	          var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          return new CardDeleteModalComponent({
	            el: document.createElement('div'),
	            propsData: propsData
	          });
	        };
	        openCardModal({
	          title: 'Apagar Face',
	          panoramaId: parseInt(this.panoramaData.id),
	          id: parseInt(position),
	          warningText: 'Tem a certeza que pretende apagar esta face do panorama?',
	          type: 'cube'
	        });
	      }
	    },
	    drawAnimation: function drawAnimation() {
	      if (this.panoCoches) {
	        try {
	          var ptf = this.panoCoches.getPanTiltFov();
	          this.panoramaInfo.pan = ptf.pan;
	          this.panoramaInfo.tilt = ptf.tilt;
	          this.panoramaInfo.fov = ptf.fov;
	        } catch (err) {}
	      }
	      window.requestAnimationFrame(this.drawAnimation);
	    },
	    showDropzone: function showDropzone(selector) {
	      this.removeImage(selector);
	    },
	    imageUrl: function imageUrl(imageIndex) {
	      return _config.API_ROOT + 'media/coach/panoramas/' + this.panoramaInfo.cubes[imageIndex];
	    },
	    resetPanoramaView: function resetPanoramaView() {
	      if (this.originalInformation) {
	        var changeInfo = {
	          pan: this.originalInformation.pan,
	          tilt: this.originalInformation.tilt,
	          fov: this.originalInformation.fov,
	          moveTo: true
	        };
	      }
	      this.panoCoches.setPanTiltFov(changeInfo);
	    },
	    setNewStart: function setNewStart() {
	      if (this.panoCoches) {
	        var ptf = this.panoCoches.getPanTiltFov();
	        this.originalInformation.pan = ptf.pan;
	        this.originalInformation.tilt = ptf.tilt;
	        this.originalInformation.fov = ptf.fov;
	        window.store.dispatch('updatePanorama', {
	          panoramaId: this.panoramaId,
	          pan: ptf.pan,
	          tilt: ptf.tilt,
	          fov: ptf.fov
	        });
	      }
	    },
	    setNewView: function setNewView(id) {
	      if (this.panoCoches) {
	        var ptf = this.panoCoches.updateHotspot(id);
	        window.store.dispatch('updatePanoramaPoint', {
	          pointId: id,
	          pan: ptf.pan,
	          tilt: ptf.tilt,
	          fov: ptf.fov
	        });
	      }
	    },
	    createHotspot: function createHotspot() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardHotspotModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	      openCardModal({
	        title: 'Criar Hotspot',
	        panoramaId: this.panoramaId,
	        hotspotData: this.panoCoches.getPanTiltFov()
	      });
	    },
	    updateHotspot: function updateHotspot(id) {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardHotspotModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	      var pointData = null;
	      for (var i in this.panoramaData.panoramaPoints) {
	        if (this.panoramaData.panoramaPoints[i].pointId === id) {
	          pointData = this.panoramaData.panoramaPoints[i];
	        }
	      }
	      openCardModal({
	        title: 'Editar Hotspot',
	        panoramaId: parseInt(this.panoramaId),
	        pointId: parseInt(id),
	        hotspotData: pointData
	      });
	    },
	    deleteHotspot: function deleteHotspot(id) {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardDeleteModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	      openCardModal({
	        title: 'Apagar Hotspot',
	        panoramaId: parseInt(this.panoramaData.id),
	        id: parseInt(id),
	        warningText: 'Tem a certeza que pretende apagar este Hotspot?',
	        type: 'hotspot'
	      });
	    },
	    setView: function setView(val) {
	      if (this.panoCoches) {
	        for (var i in this.panoramaData.panoramaPoints) {
	          if (this.panoramaData.panoramaPoints[i].pointId === val) {
	            var changeInfo = {
	              pan: this.panoramaData.panoramaPoints[i].pan,
	              tilt: this.panoramaData.panoramaPoints[i].tilt,
	              fov: this.panoramaData.panoramaPoints[i].fov,
	              moveTo: true
	            };
	            this.panoCoches.setPanTiltFov(changeInfo);
	            break;
	          }
	        }
	      }
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	    panoramaPoints: function panoramaPoints(val) {
	      if (this.panoCoches) {
	        var _this = this;
	        this.panoCoches.clearHotspot();
	        for (var p in val) {
	          var info = val[p];
	          this.panoCoches.addNewHotspot(info.languages[0].name, info.pointId, { pan: info.pan, tilt: info.tilt, fov: info.fov }, function (pointId) {
	            _this.panoCoches.gotoHotspot(pointId);
	          });
	        }
	      }
	    },
	    panoramaCubes: function panoramaCubes(val) {
	      this.panoramaInfo.cubes = [];
	      this.newImages = {
	        0: true,
	        1: true,
	        2: true,
	        3: true,
	        4: true,
	        5: true
	      };
	      var changeInfo = {};
	      changeInfo = ['blank.jpg', 'blank.jpg', 'blank.jpg', 'blank.jpg', 'blank.jpg', 'blank.jpg'];
	      for (var p in val) {
	        var position = val[p].position;
	        this.panoramaInfo.cubes[position] = val[p].imagePath;
	        this.newImages[position] = false;
	        changeInfo[position] = val[p].imagePath;
	      }
	      if (this.panoCoches) {
	        this.panoCoches.changePanoramaImage(changeInfo);
	      }
	    }
	  }
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    panoramaId: Number,
	    id: Number,
	    warningText: String,
	    type: String
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        if (this.type === 'hotspot') {
	          window.store.dispatch('deletePanoramaPoint', this.id);
	        }
	        if (this.type === 'cube') {
	          window.store.dispatch('deletePanoramaCube', { position: this.id, panoramaId: this.panoramaId });
	        }
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    }
	  }
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _vueBulmaQuill = __webpack_require__(62);
	
	var _vueBulmaQuill2 = _interopRequireDefault(_vueBulmaQuill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Quill: _vueBulmaQuill2.default,
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    panoramaId: Number,
	    pointId: Number,
	    hotspotData: Object
	  },
	  data: function data() {
	    return {
	      languages: ['pt', 'en', 'es', 'fr'],
	      editLanguage: 'pt',
	      point: {
	        parentPanoramaId: null,
	        pan: null,
	        tilt: null,
	        fov: null,
	        name: {
	          pt: null,
	          en: null,
	          es: null,
	          fr: null
	        },
	        description: {
	          pt: null,
	          en: null,
	          es: null,
	          fr: null
	        }
	      },
	      editors: null,
	      quillOptions: {
	        theme: 'snow',
	        formats: ['italic'],
	        modules: {
	          toolbar: ['italic']
	        }
	      }
	    };
	  },
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return this.point.name.pt && this.point.name.en && this.point.name.es && this.point.name.fr;
	    }
	  },
	  methods: {},
	  mounted: function mounted() {
	    this.point.parentPanoramaId = this.panoramaId;
	    this.editors = {
	      pt: {
	        q1: this.$refs.q1pt[0].editor
	      },
	      en: {
	        q1: this.$refs.q1en[0].editor
	      },
	      es: {
	        q1: this.$refs.q1es[0].editor
	      },
	      fr: {
	        q1: this.$refs.q1fr[0].editor
	      }
	    };
	    if (this.pointId) {
	      for (var l in this.hotspotData.languages) {
	        var langData = this.hotspotData.languages[l];
	        this.point.name[langData.lang] = langData.name;
	        this.editors[langData.lang].q1.setContents(langData.description);
	      }
	    } else {
	      this.point.pan = this.hotspotData.pan;
	      this.point.tilt = this.hotspotData.tilt;
	      this.point.fov = this.hotspotData.fov;
	    }
	  },
	
	  watch: {
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        this.point.description.pt = this.editors.pt.q1.getContents();
	        this.point.description.en = this.editors.en.q1.getContents();
	        this.point.description.es = this.editors.es.q1.getContents();
	        this.point.description.fr = this.editors.fr.q1.getContents();
	
	        if (!this.pointId) {
	          window.store.dispatch('savePanoramaPoint', this.point);
	        } else {
	          var tmpPoint = this.point;
	          tmpPoint['pointId'] = this.pointId;
	          window.store.dispatch('updatePanoramaPoint', tmpPoint);
	        }
	      }
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    }
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__(22);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _PanoramaContainer = __webpack_require__(275);
	
	var _PanoramaContainer2 = _interopRequireDefault(_PanoramaContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Breadcrumb: _Breadcrumb2.default,
	    PanoramaContainer: _PanoramaContainer2.default
	  },
	
	  data: function data() {
	    return {
	      breadcrumbList: null,
	      isDataLoaded: false
	    };
	  },
	  mounted: function mounted() {
	    this.getPanoramaData();
	    this.getCoachData();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    coach: function coach() {
	      return this.$store.state.coach.data;
	    },
	    panorama: function panorama() {
	      return this.$store.state.panorama.data;
	    }
	  },
	
	  methods: {
	    getPanoramaData: function getPanoramaData() {
	      this.$store.dispatch('getPanorama', this.$store.state.route.params.id);
	    },
	    getCoachData: function getCoachData() {
	      this.$store.dispatch('getCoach', this.$store.state.route.params.id);
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	
	    coach: function coach(val) {
	      if (val) {
	        var id = val.id;
	        var name = val.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + name, path: '/' + id }, { name: 'VISITA VIRTUAL', path: '' }];
	      }
	    },
	
	    panorama: function panorama(val) {
	      if (val) {
	        this.isDataLoaded = true;
	      }
	    }
	  }
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _SlideEditModal = __webpack_require__(57);
	
	var _SlideEditModal2 = _interopRequireDefault(_SlideEditModal);
	
	var _SlideDeleteModal = __webpack_require__(281);
	
	var _SlideDeleteModal2 = _interopRequireDefault(_SlideDeleteModal);
	
	var _SlideSetEditModal = __webpack_require__(59);
	
	var _SlideSetEditModal2 = _interopRequireDefault(_SlideSetEditModal);
	
	var _SlideSetDeleteModal = __webpack_require__(282);
	
	var _SlideSetDeleteModal2 = _interopRequireDefault(_SlideSetDeleteModal);
	
	var _StateSelector = __webpack_require__(17);
	
	var _StateSelector2 = _interopRequireDefault(_StateSelector);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideEditModalComponent = _vue2.default.extend(_SlideEditModal2.default);
	var SlideDeleteModalComponent = _vue2.default.extend(_SlideDeleteModal2.default);
	var SlideSetEditModalComponent = _vue2.default.extend(_SlideSetEditModal2.default);
	var SlideSetDeleteModalComponent = _vue2.default.extend(_SlideSetDeleteModal2.default);
	
	exports.default = {
	  components: {
	    StateSelector: _StateSelector2.default
	  },
	
	  props: {
	    slide: Object,
	    slideTotal: Number,
	    parent: Number,
	    menu: Object
	  },
	
	  data: function data() {
	    return {
	      coachId: this.$store.state.route.params.id,
	      categoryId: this.$store.state.route.params.cat,
	      slideImagePath: _config.SLIDE_IMG_PATH,
	      mounted: false
	    };
	  },
	  mounted: function mounted() {
	    this.mounted = true;
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    showPlusDetail: function showPlusDetail() {
	      var category = parseInt(this.slide.slide_category_id);
	      var parentCategory = parseInt(this.menu.parent_id);
	      if (category === _config.MENUS.ambepoca || parentCategory === _config.MENUS.ambepoca || category === _config.MENUS.eraumavez || parentCategory === _config.MENUS.eraumavez) {
	        return false;
	      }
	      return true;
	    },
	    showSubMenu: function showSubMenu() {
	      var category = parseInt(this.slide.slide_category_id);
	      var parentCategory = parseInt(this.menu.parent_id);
	      if (category === _config.MENUS.eraumavez || parentCategory === _config.MENUS.eraumavez) {
	        return false;
	      }
	      return true;
	    },
	    slideState: function slideState() {
	      var stateId = this.slide.state_id;
	      var text = null;
	      var color = null;
	
	      switch (parseInt(stateId)) {
	        case 1:
	          text = 'Rascunho';
	          color = 'is-danger';
	          break;
	        case 2:
	          text = 'Pendente';
	          color = 'is-warning';
	          break;
	        case 3:
	          text = 'Publicado';
	          color = 'is-success';
	          break;
	        case 4:
	          text = 'Apagado';
	          color = 'is-dark';
	          break;
	        default:
	          text = 'Estado desconhecido';
	          color = 'is-info';
	      }
	
	      return { text: text, color: color };
	    },
	    htmlText: function htmlText() {
	      if (this.mounted) {
	        return {
	          pt: {
	            description: this.slide.languages[0].pivot.description ? this.deltaToHtml(this.slide.languages[0].pivot.description) : null,
	            plus_detail: this.slide.languages[0].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[0].pivot.plus_detail) : null
	          },
	          en: {
	            description: this.slide.languages[1].pivot.description ? this.deltaToHtml(this.slide.languages[1].pivot.description) : null,
	            plus_detail: this.slide.languages[1].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[1].pivot.plus_detail) : null
	          },
	          es: {
	            description: this.slide.languages[2].pivot.description ? this.deltaToHtml(this.slide.languages[2].pivot.description) : null,
	            plus_detail: this.slide.languages[2].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[2].pivot.plus_detail) : null
	          },
	          fr: {
	            description: this.slide.languages[3].pivot.description ? this.deltaToHtml(this.slide.languages[3].pivot.description) : null,
	            plus_detail: this.slide.languages[3].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[3].pivot.plus_detail) : null
	          }
	        };
	      } else {
	        return {
	          pt: {
	            description: null,
	            plus_detail: null
	          },
	          en: {
	            description: null,
	            plus_detail: null
	          },
	          es: {
	            description: null,
	            plus_detail: null
	          },
	          fr: {
	            description: null,
	            plus_detail: null
	          }
	        };
	      }
	    }
	  },
	
	  methods: {
	    deltasToHtml: function deltasToHtml() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.slide.languages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var language = _step.value;
	
	          var description = language.pivot.description ? this.deltaToHtml(language.pivot.description) : null;
	          var plusDetail = language.pivot.plus_detail ? this.deltaToHtml(language.pivot.plus_detail) : null;
	
	          this.htmlText[language.slug].description = description;
	          this.htmlText[language.slug].plus_detail = plusDetail;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    deltaToHtml: function deltaToHtml(delta) {
	      var html = '';
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(delta.ops), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var section = _step2.value;
	
	          if (section.attributes) {
	            if (section.attributes.bold) {
	              html += '<b>';
	            }
	            if (section.attributes.italic) {
	              html += '<i>';
	            }
	            if (section.attributes.script && section.attributes.script === 'super') {
	              html += '<sup>';
	            }
	
	            html += section.insert;
	
	            if (section.attributes.bold) {
	              html += '</b>';
	            }
	            if (section.attributes.italic) {
	              html += '</i>';
	            }
	            if (section.attributes.script && section.attributes.script === 'super') {
	              html += '</sup>';
	            }
	          } else {
	            html += section.insert;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return html;
	    },
	    reorderSlides: function reorderSlides(newPosition) {
	      this.$store.dispatch('reorderSlides', { slide: this.slide, position: newPosition });
	    },
	    openSlideEditModal: function openSlideEditModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new SlideEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      var data = {
	        title: 'Editar Slide',
	        slideTotal: this.slideTotal,
	        slideData: this.slide,
	        parent: null,
	        menu: this.menu,
	        isSubslide: false
	      };
	
	      if (this.parent) {
	        data = {
	          title: 'Editar Sub-slide',
	          slideTotal: this.slideTotal,
	          slideData: this.slide,
	          parent: this.parent,
	          menu: this.menu,
	          isSubslide: true
	        };
	      }
	
	      openCardModal(data);
	    },
	    openSlideDeleteModal: function openSlideDeleteModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new SlideDeleteModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      var data = {
	        title: 'Apagar Slide',
	        id: parseInt(this.slide.id),
	        is_sub: false
	      };
	
	      if (this.parent) {
	        data = {
	          title: 'Apagar Sub-slide',
	          id: parseInt(this.slide.id),
	          is_sub: true
	        };
	      }
	
	      openCardModal(data);
	    },
	    openSlideSetEditModal: function openSlideSetEditModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new SlideSetEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Definir Características dos Sub-Slides',
	        coach_id: parseInt(this.coachId),
	        menu_id: parseInt(this.categoryId),
	        parent_slide_id: parseInt(this.slide.id),
	        categoryData: null
	      });
	    },
	    openSlideSetDeleteModal: function openSlideSetDeleteModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new SlideSetDeleteModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Apagar Sub-slides',
	        coach_id: parseInt(this.coachId),
	        menu_id: parseInt(this.categoryId),
	        id: parseInt(this.slide.sub_menu)
	      });
	    },
	    goToSubSlide: function goToSubSlide() {
	      window.router.push({ path: '/' + this.coachId + '/submenu/' + this.slide.sub_menu });
	    },
	    isVideo: function isVideo(path) {
	      var videoExtensions = ['mp4', 'mov', 'mkv', 'avi'];
	
	      var splitPath = path.split('.');
	      var extension = splitPath.pop();
	
	      if (videoExtensions.includes(extension)) {
	        return true;
	      }
	      return false;
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	
	    slide: function slide(val) {
	      if (this.isVideo(val.foreground_path_1)) {
	        var video = document.getElementById('video-' + this.slide.id);
	        if (video) {
	          video.load(this.slideImagePath + val);
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _CoachEditCategoryModal = __webpack_require__(54);
	
	var _CoachEditCategoryModal2 = _interopRequireDefault(_CoachEditCategoryModal);
	
	var _StateSelector = __webpack_require__(17);
	
	var _StateSelector2 = _interopRequireDefault(_StateSelector);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachEditCategoryModalComponent = _vue2.default.extend(_CoachEditCategoryModal2.default);
	
	exports.default = {
	  components: {
	    StateSelector: _StateSelector2.default
	  },
	
	  props: ['menu'],
	
	  data: function data() {
	    return {
	      coachId: this.$store.state.route.params.id,
	      coachImagePath: _config.BACKGROUND_IMG_PATH
	    };
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    showTextboxColor: function showTextboxColor() {
	      return _config.MENUS.eraumavez !== parseInt(this.menu.id);
	    }
	  },
	
	  methods: {
	    editCoachEditCategoryModal: function editCoachEditCategoryModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CoachEditCategoryModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Editar - ' + this.menu.languages[0].pivot.name,
	        category_id: parseInt(this.menu.slide_category_id),
	        coach_id: parseInt(this.coachId),
	        categoryData: this.menu
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {}
	  }
	};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    id: Number,
	    is_sub: Boolean
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return true;
	    },
	    previewIsActive: function previewIsActive() {
	      return false;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        window.store.dispatch('deleteSlide', this.id);
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _vueBulmaQuill = __webpack_require__(62);
	
	var _vueBulmaQuill2 = _interopRequireDefault(_vueBulmaQuill);
	
	var _ParallaxComposite = __webpack_require__(291);
	
	var _ParallaxComposite2 = _interopRequireDefault(_ParallaxComposite);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DESKTOP_MIN_WIDTH = 769;
	var MAX_PREVIEW_SIZE_MOBILE = 671;
	var DEFAULT_PREVIEW_SIZE = 600;
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    Quill: _vueBulmaQuill2.default,
	    Dropzone: _DropzoneForm2.default,
	    ParallaxComposite: _ParallaxComposite2.default
	  },
	
	  props: {
	    title: String,
	    slideTotal: Number,
	    slideData: Object,
	    parent: Number,
	    menu: Object,
	    isSubslide: Boolean
	  },
	
	  data: function data() {
	    return {
	      languageList: _config.LANGUAGE_LIST,
	      editLanguage: 'pt',
	      insertMode: 1,
	      defaultMode: null,
	      defaultModePath: null,
	      states: _config.CONTENT_STATES,
	      showPreview: false,
	      previewLanguage: 'pt',
	      previewText: null,
	      previewImageWidth: null,
	      previewReady: false,
	      previewWarning: 'Esta pré-visualização pode não ser uma representação fiel dos quiosques.',
	      slide: {
	        coach_id: window.store.state.route.params.id,
	        slide_category_id: parseInt(window.store.state.route.params.cat),
	        pt: {
	          description: null,
	          plus_detail: null
	        },
	        en: {
	          description: null,
	          plus_detail: null
	        },
	        es: {
	          description: null,
	          plus_detail: null
	        },
	        fr: {
	          description: null,
	          plus_detail: null
	        },
	        foreground_image_1: null,
	        foreground_image_2: null,
	        foreground_path_1: null,
	        foreground_path_2: null,
	        state_id: 1,
	        order: this.slideTotal + 1,
	        parent_id: this.parent
	      },
	      newForeground1: false,
	      newForeground2: false,
	      newForegroundVideo: false,
	      quillOptions: {
	        theme: 'snow',
	        formats: ['italic', 'script'],
	        modules: {
	          toolbar: [['italic'], [{ 'script': 'super' }]]
	        }
	      },
	      editors: null,
	      currentDescription: null,
	      currentDetail: null,
	      showDetail: false,
	      submitIsActive: true,
	      previewIsActive: true
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var trash = document.body.querySelectorAll('.dz-hidden-input');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(trash), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        t.remove();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      window.addEventListener('resize', this.handleResize);
	    });
	
	    setTimeout(function () {
	      _this.handleResize();
	      _this.previewReady = true;
	    }, 10);
	
	    this.editors = {
	      pt: {
	        q1: this.$refs.q1pt[0].editor,
	        q2: this.$refs.q2pt ? this.$refs.q2pt[0].editor : null
	      },
	      en: {
	        q1: this.$refs.q1en[0].editor,
	        q2: this.$refs.q2en ? this.$refs.q2en[0].editor : null
	      },
	      es: {
	        q1: this.$refs.q1es[0].editor,
	        q2: this.$refs.q2es ? this.$refs.q2es[0].editor : null
	      },
	      fr: {
	        q1: this.$refs.q1fr[0].editor,
	        q2: this.$refs.q2fr ? this.$refs.q2fr[0].editor : null
	      }
	    };
	
	    if (this.slideData) {
	      this.slide.state_id = this.slideData.state_id;
	      this.slide.order = parseInt(this.slideData.order);
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.slideData.languages), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var language = _step2.value;
	
	          if (language.pivot.description) {
	            this.editors[language.slug].q1.setContents(language.pivot.description, 'api');
	          }
	          if (language.pivot.plus_detail && this.showPlusDetail) {
	            this.editors[language.slug].q2.setContents(language.pivot.plus_detail, 'api');
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.updateCurrentText('pt');
	
	      this.slide.foreground_image_1 = this.slideData.foreground_path_1 ? _config.SLIDE_IMG_PATH + this.slideData.foreground_path_1 : null;
	      this.slide.foreground_path_1 = this.slideData.foreground_path_1;
	      this.slide.foreground_image_2 = this.slideData.foreground_path_2 ? _config.SLIDE_IMG_PATH + this.slideData.foreground_path_2 : null;
	      this.slide.foreground_path_2 = this.slideData.foreground_path_2;
	
	      this.newForeground1 = this.slideData.foreground_path_1 === null;
	      this.newForeground2 = this.slideData.foreground_path_2 === null;
	
	      this.insertMode = this.isVideo(this.slideData.foreground_path_1) ? 2 : 1;
	      this.defaultMode = this.insertMode;
	      this.defaultModePath = this.slideData.foreground_path_1;
	    }
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    userToken: function userToken() {
	      return window.store.state.auth.token;
	    },
	    dropzoneUploadUrl: function dropzoneUploadUrl() {
	      return _config.API_ROOT + 'resource/slide/upload?token=' + this.userToken;
	    },
	    textZoom: function textZoom() {
	      return 'scale(' + this.previewImageWidth / DEFAULT_PREVIEW_SIZE + ')';
	    },
	    orderOptions: function orderOptions() {
	      var object = [];
	      var target = this.slideTotal;
	      if (!this.slideData) {
	        target += 1;
	      }
	      for (var i = 1; i <= target; i++) {
	        object.push({ id: i, value: i });
	      }
	      return object;
	    },
	    menuBackground1: function menuBackground1() {
	      if (this.menu.background_path_1) {
	        return _config.BACKGROUND_IMG_PATH + this.menu.background_path_1;
	      }
	      return null;
	    },
	    menuBackground2: function menuBackground2() {
	      if (this.menu.background_path_2) {
	        return _config.BACKGROUND_IMG_PATH + this.menu.background_path_2;
	      }
	      return null;
	    },
	    showPlusDetail: function showPlusDetail() {
	      if (this.slide.slide_category_id === _config.MENUS.ambepoca || this.slide.slide_category_id === _config.MENUS.eraumavez) {
	        return false;
	      }
	      return true;
	    },
	    foreground1Type: function foreground1Type() {
	      if (this.parent) {
	        return 3;
	      } else {
	        return 1;
	      }
	    },
	    foreground2Type: function foreground2Type() {
	      if (this.parent) {
	        return 4;
	      } else {
	        return 2;
	      }
	    },
	    foreground1Text: function foreground1Text() {
	      return this.isSubslide ? '(1848x1008px)' : '(1920x1080px)';
	    },
	    foreground2Text: function foreground2Text() {
	      return this.isSubslide ? '(2772x1008px)' : '(2880x1080px)';
	    }
	  },
	
	  methods: {
	    successUploadForeground1: function successUploadForeground1(file) {
	      this.slide.foreground_image_1 = _config.SLIDE_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.slide.foreground_path_1 = JSON.parse(file.xhr.response).file;
	
	      this.newForeground1 = false;
	      this.newForegroundVideo = false;
	    },
	    removeForeground1: function removeForeground1() {
	      console.log('A file was been removed');
	      this.slide.foreground_image_1 = null;
	      this.slide.foreground_path_1 = null;
	    },
	    successUploadForeground2: function successUploadForeground2(file) {
	      this.slide.foreground_image_2 = _config.SLIDE_IMG_PATH + JSON.parse(file.xhr.response).file;
	      this.slide.foreground_path_2 = JSON.parse(file.xhr.response).file;
	
	      this.newForeground2 = false;
	    },
	    removeForeground2: function removeForeground2() {
	      console.log('A file was been removed');
	      this.slide.foreground_image_2 = null;
	      this.slide.foreground_path_2 = null;
	    },
	    isSelectedLanguage: function isSelectedLanguage(slug) {
	      return slug === this.previewLanguage;
	    },
	    handleResize: function handleResize() {
	      var element = document.getElementById('modal-edit-content');
	      if (element) {
	        this.previewImageWidth = element.getBoundingClientRect().width;
	      }
	    },
	    showDropzone: function showDropzone(selector) {
	      if (selector === 'foreground1') {
	        this.newForeground1 = true;
	        this.newForegroundVideo = true;
	        this.removeForeground1();
	      }
	
	      if (selector === 'foreground2') {
	        this.newForeground2 = true;
	        this.removeForeground2();
	      }
	    },
	    deltaToHtml: function deltaToHtml(delta) {
	      var html = '';
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(delta.ops), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var section = _step3.value;
	
	          if (section.attributes) {
	            if (section.attributes.bold) {
	              html += '<b>';
	            }
	            if (section.attributes.italic) {
	              html += '<i>';
	            }
	            if (section.attributes.script && section.attributes.script === 'super') {
	              html += '<sup>';
	            }
	
	            html += section.insert.replace(/\n/g, '<br/>');
	
	            if (section.attributes.bold) {
	              html += '</b>';
	            }
	            if (section.attributes.italic) {
	              html += '</i>';
	            }
	            if (section.attributes.script && section.attributes.script === 'super') {
	              html += '</sup>';
	            }
	          } else {
	            html += section.insert.replace(/\n/g, '<br/>');
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return html;
	    },
	    updateCurrentText: function updateCurrentText(lang) {
	      var delta1 = this.deltaToHtml(this.editors[lang].q1.editor.delta);
	      this.currentDescription = delta1 === '<br/>' ? null : delta1;
	      if (this.editors[lang].q2) {
	        var delta2 = this.deltaToHtml(this.editors[lang].q2.editor.delta);
	        this.currentDetail = delta2 === '<br/>' ? null : delta2;
	      }
	    },
	    isVideo: function isVideo(path) {
	      var videoExtensions = ['mp4', 'mov', 'mkv', 'avi'];
	
	      var splitPath = path.split('.');
	      var extension = splitPath.pop();
	
	      if (videoExtensions.includes(extension)) {
	        return true;
	      }
	      return false;
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        this.slide.pt.description = this.editors.pt.q1.getContents();
	        this.slide.en.description = this.editors.en.q1.getContents();
	        this.slide.es.description = this.editors.es.q1.getContents();
	        this.slide.fr.description = this.editors.fr.q1.getContents();
	
	        if (this.showPlusDetail) {
	          this.slide.pt.plus_detail = this.editors.pt.q2.getContents();
	          this.slide.en.plus_detail = this.editors.en.q2.getContents();
	          this.slide.es.plus_detail = this.editors.es.q2.getContents();
	          this.slide.fr.plus_detail = this.editors.fr.q2.getContents();
	        }
	
	        if (this.slideData) {
	          window.store.dispatch('updateSlide', { id: this.slideData.id, slide: this.slide });
	        } else {
	          window.store.dispatch('saveSlide', this.slide);
	        }
	      }
	      if (val === 'modal-card-preview') {
	        this.updateCurrentText(this.previewLanguage);
	        this.showPreview = !this.showPreview;
	      }
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    showPreview: function showPreview(val) {
	      if (val && window.innerWidth < DESKTOP_MIN_WIDTH) {
	        this.previewImageWidth = MAX_PREVIEW_SIZE_MOBILE - (DESKTOP_MIN_WIDTH - 1 - window.innerWidth);
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewLanguage: function previewLanguage(val) {
	      this.updateCurrentText(val);
	    },
	
	    insertMode: function insertMode(oldval, val) {
	      if (oldval !== val) {
	        if (val !== this.defaultMode && this.defaultModePath) {
	          this.slide.foreground_image_1 = _config.SLIDE_IMG_PATH + this.defaultModePath;
	          this.slide.foreground_path_1 = this.defaultModePath;
	
	          this.newForeground1 = false;
	          this.newForegroundVideo = false;
	        } else {
	          this.removeForeground1();
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _SlideEditModal = __webpack_require__(57);
	
	var _SlideEditModal2 = _interopRequireDefault(_SlideEditModal);
	
	var _LevelSlide = __webpack_require__(279);
	
	var _LevelSlide2 = _interopRequireDefault(_LevelSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideEditModalComponent = _vue2.default.extend(_SlideEditModal2.default);
	
	exports.default = {
	  components: {
	    LevelSlide: _LevelSlide2.default
	  },
	
	  props: {
	    slides: Array,
	    parent: Number,
	    menu: Object
	  },
	
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {
	    openSlideEditModal: function openSlideEditModal() {
	      if (this.parent) {
	        var openCardModalSubSlide = function openCardModalSubSlide() {
	          var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          return new SlideEditModalComponent({
	            el: document.createElement('div'),
	            propsData: propsData
	          });
	        };
	
	        openCardModalSubSlide({
	          title: 'Criar Sub-slide',
	          slideTotal: this.slides.length,
	          slideData: null,
	          menu: this.menu,
	          parent: this.parent,
	          isSubslide: true
	        });
	      } else {
	        var openCardModalSlide = function openCardModalSlide() {
	          var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          return new SlideEditModalComponent({
	            el: document.createElement('div'),
	            propsData: propsData
	          });
	        };
	
	        openCardModalSlide({
	          title: 'Criar Slide',
	          slideTotal: this.slides.length,
	          slideData: null,
	          menu: this.menu,
	          parent: null,
	          isSubslide: false
	        });
	      }
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {}
	  }
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    coach_id: Number,
	    menu_id: Number,
	    id: Number
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return true;
	    },
	    previewIsActive: function previewIsActive() {
	      return false;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        var data = {
	          coach: this.coach_id,
	          menu: this.menu_id,
	          id: this.id
	        };
	        window.store.dispatch('deleteSubMenu', data);
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(6);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _ColorPicker = __webpack_require__(41);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _config = __webpack_require__(3);
	
	var _DropzoneForm = __webpack_require__(15);
	
	var _DropzoneForm2 = _interopRequireDefault(_DropzoneForm);
	
	var _tinycolor = __webpack_require__(28);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setColor(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  if (hsl.s === 0) {
	    hsl.h = data.h || oldHue || 0;
	    hsv.h = data.h || oldHue || 0;
	  }
	  return {
	    hsl: hsl,
	    hex: color.toHexString().toUpperCase(),
	    rgba: color.toRgb(),
	    hsv: hsv,
	    a: 1
	  };
	}
	
	function getImgSize(imgSrc, callback) {
	  var newImg = new Image();
	  newImg.onload = function () {
	    if (callback !== undefined) {
	      callback({ width: newImg.width, height: newImg.height });
	    }
	  };
	  newImg.src = imgSrc;
	}
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    'sketch-picker': _ColorPicker2.default,
	    Dropzone: _DropzoneForm2.default
	  },
	
	  props: {
	    title: String,
	    coach_id: Number,
	    menu_id: Number,
	    parent_slide_id: Number,
	    categoryData: Object
	  },
	
	  data: function data() {
	    return {
	      languageList: _config.LANGUAGE_LIST,
	      editLanguage: 'pt',
	      pickerColor: _config.WHITE_COLOR,
	      showColorPicker: false,
	      currentColorPicker: 'background',
	      colorPickerPosition: 1,
	      colorPickerBtnTextBackground: 'Selecionar Cor',
	      colorPickerBtnTextTextbox: 'Selecionar Cor',
	      colorPickerBtnTextText: 'Selecionar Cor',
	      showPreview: false,
	      category: {
	        background_color: _config.WHITE_COLOR,
	        textbox_color: _config.WHITE_COLOR,
	        text_color: _config.WHITE_COLOR,
	        background_image_1: null,
	        background_image_2: null,
	        background_path_1: null,
	        background_path_2: null,
	        local: {
	          pt: {
	            button: null,
	            title: null
	          },
	          en: {
	            button: null,
	            title: null
	          },
	          es: {
	            button: null,
	            title: null
	          },
	          fr: {
	            button: null,
	            title: null
	          }
	        }
	      },
	      newBackground1: false,
	      newBackground2: false
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var trash = document.body.querySelectorAll('.dz-hidden-input');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(trash), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        t.remove();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.categoryData) {
	      this.category.local.pt.button = this.categoryData.parent_languages[0].pivot.popup_button;
	      this.category.local.en.button = this.categoryData.parent_languages[1].pivot.popup_button;
	      this.category.local.es.button = this.categoryData.parent_languages[2].pivot.popup_button;
	      this.category.local.fr.button = this.categoryData.parent_languages[3].pivot.popup_button;
	
	      this.category.local.pt.title = this.categoryData.languages[0].pivot.name ? this.categoryData.languages[0].pivot.name : null;
	      this.category.local.en.title = this.categoryData.languages[1].pivot.name ? this.categoryData.languages[1].pivot.name : null;
	      this.category.local.es.title = this.categoryData.languages[2].pivot.name ? this.categoryData.languages[2].pivot.name : null;
	      this.category.local.fr.title = this.categoryData.languages[3].pivot.name ? this.categoryData.languages[3].pivot.name : null;
	
	      this.category.background_color = setColor(this.categoryData.background_color);
	      this.category.textbox_color = setColor(this.categoryData.textbox_color);
	      this.category.text_color = setColor(this.categoryData.text_color);
	
	      this.category.background_image_1 = this.categoryData.background_path_1 ? _config.BACKGROUND_IMG_PATH + this.categoryData.background_path_1 : null;
	      this.category.background_path_1 = this.categoryData.background_path_1;
	      this.category.background_image_2 = this.categoryData.background_path_2 ? _config.BACKGROUND_IMG_PATH + this.categoryData.background_path_2 : null;
	      this.category.background_path_2 = this.categoryData.background_path_2;
	    }
	
	    var _this = this;
	    if (_this.category.background_image_1) {
	      getImgSize(_this.category.background_image_1, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-1 img').style.minWidth = resize + 'px';
	        }
	      });
	    }
	
	    if (_this.category.background_image_2) {
	      getImgSize(_this.category.background_image_2, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-2 img').style.minWidth = resize + 'px';
	        }
	      });
	    }
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    userToken: function userToken() {
	      return window.store.state.auth.token;
	    },
	    dropzoneUploadUrl: function dropzoneUploadUrl() {
	      return _config.API_ROOT + 'resource/subslide/upload/background?token=' + this.userToken;
	    }
	  },
	
	  methods: {
	    successUploadBackground: function successUploadBackground(file) {
	      var path = JSON.parse(file.xhr.response).file;
	      this.category.background_image_1 = path ? _config.BACKGROUND_IMG_PATH + JSON.parse(file.xhr.response).file : null;
	      this.category.background_path_1 = JSON.parse(file.xhr.response).file;
	
	      this.newBackground1 = false;
	
	      var _this = this;
	      getImgSize(_this.category.background_image_1, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-1 img').style.minWidth = resize + 'px';
	        }
	      });
	    },
	    removeBackground: function removeBackground() {
	      console.log('A file was been removed');
	      this.category.background_image_1 = null;
	      this.category.background_path_1 = null;
	    },
	    successUploadForeground: function successUploadForeground(file) {
	      var path = JSON.parse(file.xhr.response).file;
	      this.category.background_image_2 = path ? _config.BACKGROUND_IMG_PATH + JSON.parse(file.xhr.response).file : null;
	      this.category.background_path_2 = JSON.parse(file.xhr.response).file;
	
	      this.newBackground2 = false;
	
	      var _this = this;
	      getImgSize(_this.category.background_image_2, function (imgSize) {
	        if (imgSize.width > 6458) {
	          var resize = imgSize.width * 100 / 1080;
	          document.querySelector('.background-2 img').style.minWidth = resize + 'px';
	        }
	      });
	    },
	    removeForeground: function removeForeground() {
	      console.log('A file was been removed');
	      this.category.background_image_2 = null;
	      this.category.background_path_2 = null;
	    },
	    onChangePickerColor: function onChangePickerColor(val) {
	      switch (this.currentColorPicker) {
	        case 'background':
	          this.category.background_color = val;
	          break;
	        case 'textbox':
	          this.category.textbox_color = val;
	          break;
	        case 'text':
	          this.category.text_color = val;
	          break;
	      }
	    },
	    toogleColorPicker: function toogleColorPicker(selector) {
	      if (selector === this.currentColorPicker || !this.showColorPicker) {
	        this.showColorPicker = !this.showColorPicker;
	      }
	      this.currentColorPicker = selector;
	
	      this.colorPickerBtnTextBackground = 'Selecionar Cor';
	      this.colorPickerBtnTextTextbox = 'Selecionar Cor';
	      this.colorPickerBtnTextText = 'Selecionar Cor';
	
	      switch (selector) {
	        case 'background':
	          if (this.showColorPicker) {
	            this.pickerColor = this.category.background_color;
	            this.colorPickerBtnTextBackground = 'Fechar';
	          }
	          this.colorPickerPosition = 1;
	          break;
	        case 'textbox':
	          if (this.showColorPicker) {
	            this.pickerColor = this.category.textbox_color;
	            this.colorPickerBtnTextTextbox = 'Fechar';
	          }
	          this.colorPickerPosition = 2;
	          break;
	        case 'text':
	          if (this.showColorPicker) {
	            this.pickerColor = this.category.text_color;
	            this.colorPickerBtnTextText = 'Fechar';
	          }
	          this.colorPickerPosition = 3;
	          break;
	        default:
	          this.showColorPicker = false;
	      }
	    },
	    showDropzone: function showDropzone(selector) {
	      if (selector === 'background1') {
	        this.newBackground1 = true;
	        this.removeBackground();
	      }
	
	      if (selector === 'background2') {
	        this.newBackground2 = true;
	        this.removeForeground();
	      }
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        if (this.categoryData) {
	          var data = {
	            coach: this.coach_id,
	            menu: this.menu_id,
	            parent: null,
	            category: this.category
	          };
	          window.store.dispatch('updateSubSlideCategory', data);
	        } else {
	          var _data = {
	            coach: this.coach_id,
	            menu: this.menu_id,
	            parent: this.parent_slide_id,
	            category: this.category
	          };
	          window.store.dispatch('setSubSlideCategory', _data);
	        }
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    }
	  }
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _SlideSetEditModal = __webpack_require__(59);
	
	var _SlideSetEditModal2 = _interopRequireDefault(_SlideSetEditModal);
	
	var _StateSelector = __webpack_require__(17);
	
	var _StateSelector2 = _interopRequireDefault(_StateSelector);
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideSetEditModalComponent = _vue2.default.extend(_SlideSetEditModal2.default);
	
	exports.default = {
	  components: {
	    StateSelector: _StateSelector2.default
	  },
	
	  props: ['menu', 'title'],
	
	  data: function data() {
	    return {
	      coachId: this.$store.state.route.params.id,
	      categoryId: this.$store.state.route.params.cat,
	      coachImagePath: _config.BACKGROUND_IMG_PATH
	    };
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {
	    openSlideSetEditModal: function openSlideSetEditModal() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new SlideSetEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Editar Características dos Sub-Slides',
	        coach_id: parseInt(this.coachId),
	        menu_id: parseInt(this.categoryId),
	        parent_slide_id: null,
	        categoryData: this.menu
	      });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {}
	  }
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__(22);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _SubMenuInfo = __webpack_require__(283);
	
	var _SubMenuInfo2 = _interopRequireDefault(_SubMenuInfo);
	
	var _SlideList = __webpack_require__(58);
	
	var _SlideList2 = _interopRequireDefault(_SlideList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Breadcrumb: _Breadcrumb2.default,
	    SubMenuInfo: _SubMenuInfo2.default,
	    SlideList: _SlideList2.default
	  },
	
	  data: function data() {
	    return {
	      breadcrumbList: null,
	      coachId: this.$store.state.route.params.id,
	      categoryId: this.$store.state.route.params.cat
	    };
	  },
	  mounted: function mounted() {
	    this.getCoachData();
	    this.getSlideList();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    coach: function coach() {
	      return this.$store.state.coach.data;
	    },
	    menu: function menu() {
	      return this.$store.state.slide.menu;
	    },
	    slides: function slides() {
	      return this.$store.state.slide.list;
	    },
	    parent_slide: function parent_slide() {
	      if (this.menu) {
	        return this.menu.child ? parseInt(this.menu.child) : null;
	      }
	      return null;
	    }
	  },
	
	  methods: {
	    getCoachData: function getCoachData() {
	      this.$store.dispatch('getCoach', this.$store.state.route.params.id);
	    },
	    getSlideList: function getSlideList() {
	      this.$store.dispatch('getSlideList', { coach: this.coachId, category: this.categoryId });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	
	    coach: function coach(_coach) {
	      if (_coach && this.menu) {
	        var id = _coach.id;
	        var name = _coach.languages[0].pivot.name;
	        var menuId = this.menu.id;
	        var menuName = this.menu.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + name, path: '/' + id }, { name: '' + menuName, path: '/' + menuId }];
	      }
	    },
	
	    menu: function menu(_menu) {
	      if (_menu && this.coach) {
	        var id = _menu.id;
	        var name = _menu.languages[0].pivot.name;
	        var coachId = this.coach.id;
	        var coachName = this.coach.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + coachName, path: '/' + coachId }, { name: '' + name, path: '/' + id }];
	      }
	    }
	  }
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__(22);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _MenuInfo = __webpack_require__(280);
	
	var _MenuInfo2 = _interopRequireDefault(_MenuInfo);
	
	var _SlideList = __webpack_require__(58);
	
	var _SlideList2 = _interopRequireDefault(_SlideList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Breadcrumb: _Breadcrumb2.default,
	    MenuInfo: _MenuInfo2.default,
	    SlideList: _SlideList2.default
	  },
	
	  data: function data() {
	    return {
	      breadcrumbList: null,
	      coachId: this.$store.state.route.params.id,
	      categoryId: this.$store.state.route.params.cat,
	      isDataLoaded: false
	    };
	  },
	  mounted: function mounted() {
	    this.getCoachData();
	    this.getSlideList();
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    coach: function coach() {
	      return this.$store.state.coach.data;
	    },
	    menu: function menu() {
	      return this.$store.state.slide.menu;
	    },
	    slides: function slides() {
	      return this.$store.state.slide.list;
	    }
	  },
	
	  methods: {
	    getCoachData: function getCoachData() {
	      this.$store.dispatch('getCoach', this.$store.state.route.params.id);
	    },
	    getSlideList: function getSlideList() {
	      this.$store.dispatch('getSlideList', { coach: this.coachId, category: this.categoryId });
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {},
	
	    coach: function coach(_coach) {
	      if (_coach && this.menu) {
	        var id = _coach.id;
	        var name = _coach.languages[0].pivot.name;
	        var menuId = this.menu.id;
	        var menuName = this.menu.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + name, path: '/' + id }, { name: '' + menuName, path: '/' + menuId }];
	      }
	    },
	
	    menu: function menu(_menu) {
	      if (_menu && this.coach) {
	        var id = _menu.id;
	        var name = _menu.languages[0].pivot.name;
	        var coachId = this.coach.id;
	        var coachName = this.coach.languages[0].pivot.name;
	
	        this.breadcrumbList = [{ name: 'Início', path: '/' }, { name: '' + coachName, path: '/' + coachId }, { name: '' + name, path: '/' + id }];
	
	        this.isDataLoaded = true;
	      }
	    }
	  }
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _UserDeleteModal = __webpack_require__(287);
	
	var _UserDeleteModal2 = _interopRequireDefault(_UserDeleteModal);
	
	var _UserEditModal = __webpack_require__(60);
	
	var _UserEditModal2 = _interopRequireDefault(_UserEditModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardEditModalComponent = _vue2.default.extend(_UserEditModal2.default);
	var CardDeleteModalComponent = _vue2.default.extend(_UserDeleteModal2.default);
	
	exports.default = {
	
	  components: {
	    CardDeleteModalComponent: CardDeleteModalComponent,
	    CardEditModalComponent: CardEditModalComponent
	  },
	
	  props: {
	    user: {}
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  computed: {},
	
	  methods: {
	    editUser: function editUser() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Editar utilizador',
	        userData: this.user
	      });
	    },
	    deleteUser: function deleteUser() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardDeleteModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Apagar Utlizador?',
	        id: parseInt(this.user.id)
	      });
	    }
	  }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default
	  },
	
	  props: {
	    title: String,
	    id: Number
	  },
	
	  data: function data() {
	    return {
	      showPreview: false
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    submitIsActive: function submitIsActive() {
	      return true;
	    },
	    previewIsActive: function previewIsActive() {
	      return false;
	    }
	  },
	
	  methods: {},
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        window.store.dispatch('deleteUser', this.id);
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    previewIsActive: function previewIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled');
	      }
	    }
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardModal = __webpack_require__(4);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _Switch = __webpack_require__(292);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CardModal: _CardModal2.default,
	    VbSwitch: _Switch2.default
	  },
	
	  props: {
	    title: String,
	    userData: Object
	  },
	
	  data: function data() {
	    return {
	      showPreview: false,
	      passwordMissmatch: false,
	      disableEmail: false,
	      user: {
	        id: null,
	        admin: null,
	        name: null,
	        email: null,
	        newPassword: '',
	        newPasswordRepeat: ''
	      },
	      adminSwitch: null
	    };
	  },
	
	
	  computed: {
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    },
	    userLoggedAdmin: function userLoggedAdmin() {
	      return parseInt(window.store.state.user.admin);
	    },
	    submitIsActive: function submitIsActive() {
	      if (this.user.id) {
	        return Boolean(this.user.name && this.user.email);
	      } else {
	        return Boolean(this.user.name && this.user.email && this.user.newPassword && this.user.newPasswordRepeat);
	      }
	    }
	  },
	
	  methods: {},
	
	  mounted: function mounted() {
	    this.adminSwitch = false;
	
	    if (typeof this.userData !== 'undefined') {
	      this.user.name = this.userData.name;
	      this.user.email = this.userData.email;
	      this.user.id = parseInt(this.userData.id);
	      this.user.admin = parseInt(this.userData.admin);
	
	      this.adminSwitch = !!this.user.admin;
	      this.disableEmail = true;
	    }
	  },
	
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'switch-change-true') {
	        this.adminSwitch = true;
	      }
	      if (val === 'switch-change-false') {
	        this.adminSwitch = false;
	      }
	      if (val === 'modal-card-close') {
	        this.$destroy();
	      }
	      if (val === 'modal-card-ok') {
	        if (this.user.newPassword !== this.user.newPasswordRepeat) {
	          this.passwordMissmatch = true;
	        } else {
	          this.passwordMissmatch = false;
	          if (this.user.id) {
	            window.store.dispatch('updateUser', this.user);
	          } else {
	            window.store.dispatch('saveUser', this.user);
	          }
	          window.store.dispatch('newEvent', 'modal-card-close');
	        }
	      }
	      if (val === 'modal-card-preview') {}
	      if (val === 'modal-card-cancel') {
	        window.store.dispatch('newEvent', 'modal-card-close');
	      }
	    },
	
	    submitIsActive: function submitIsActive(val) {
	      if (val) {
	        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled');
	      } else {
	        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled');
	      }
	    },
	
	    adminSwitch: function adminSwitch(val) {
	      console.log('watch switch 1', val, this.user.admin, this.adminSwitch);
	      this.user.admin = val ? 1 : 0;
	      console.log('watch switch 2', val, this.user.admin, this.adminSwitch);
	    }
	  }
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _UserEditModal = __webpack_require__(60);
	
	var _UserEditModal2 = _interopRequireDefault(_UserEditModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardEditModalComponent = _vue2.default.extend(_UserEditModal2.default);
	
	exports.default = {
	  components: {
	    EditUserCardModal: _UserEditModal2.default
	  },
	  data: function data() {
	    return {};
	  },
	
	
	  methods: {
	    editUser: function editUser() {
	      var openCardModal = function openCardModal() {
	        var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return new CardEditModalComponent({
	          el: document.createElement('div'),
	          propsData: propsData
	        });
	      };
	
	      openCardModal({
	        title: 'Novo Utilizador'
	      });
	    }
	  }
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      searchString: null
	    };
	  },
	
	
	  methods: {}
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserCard = __webpack_require__(286);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	var _UserSearch = __webpack_require__(289);
	
	var _UserSearch2 = _interopRequireDefault(_UserSearch);
	
	var _UserNew = __webpack_require__(288);
	
	var _UserNew2 = _interopRequireDefault(_UserNew);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UserCard: _UserCard2.default,
	    UserSearch: _UserSearch2.default,
	    UserNew: _UserNew2.default
	  },
	
	  data: function data() {
	    return {
	      searchString: ''
	    };
	  },
	  mounted: function mounted() {
	    this.getUserList();
	  },
	
	
	  computed: {
	    users: function users() {
	      var searchString = this.searchString;
	      var filteredList = null;
	      if (this.$store.state.user.list) {
	        filteredList = this.$store.state.user.list.filter(function (val) {
	          return val.name.toLowerCase().includes(searchString.toLowerCase());
	        });
	      }
	      return filteredList;
	    },
	    currentEvent: function currentEvent() {
	      return window.store.state.event.nextEvent;
	    }
	  },
	
	  methods: {
	    getUserList: function getUserList() {
	      this.$store.dispatch('getUserList');
	    }
	  },
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'update-user-list') {
	        this.getUserList();
	      }
	    }
	  }
	};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  props: {
	    list: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    separator: String
	  },
	
	  mounted: function mounted() {
	    if (this.separator) {
	      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
	    }
	  },
	
	
	  methods: {
	    isLast: function isLast(index) {
	      return index === this.list.length - 1;
	    },
	    showName: function showName(item) {
	      return item.meta && item.meta.label || item.name;
	    }
	  }
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseModal = __webpack_require__(67);
	
	var _BaseModal2 = _interopRequireDefault(_BaseModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_BaseModal2.default],
	
	  props: {
	    title: {
	      type: String
	    },
	    disableOk: {
	      type: Boolean,
	      default: true
	    },
	    okText: {
	      type: String,
	      default: 'Submeter'
	    },
	    disablePreview: {
	      type: Boolean,
	      default: true
	    },
	    showPreview: {
	      type: Boolean,
	      default: true
	    },
	    cancelText: {
	      type: String,
	      default: 'Cancelar'
	    }
	  },
	
	  mounted: function mounted() {
	    window.store.dispatch('deactivateScroll');
	  },
	  data: function data() {
	    return {
	      previewText: 'Pré-visualizar',
	      previewActive: false,
	      auxScroll: 0
	    };
	  },
	  currentEvent: function currentEvent() {
	    return window.store.state.event.nextEvent;
	  },
	
	
	  watch: {
	    currentEvent: function currentEvent(val) {
	      if (val === 'modal-card-close') {
	        this.close();
	        this.$destroy();
	      }
	    },
	
	    scrollEnabled: function scrollEnabled(val) {
	      if (!val) {
	        this.auxScroll = window.scrollY;
	        document.getElementById('app').classList.add('model-open');
	        document.getElementById('app').style.marginTop = '-' + this.auxScroll + 'px';
	      } else {
	        document.getElementById('app').style.marginTop = '0';
	        document.getElementById('app').classList.remove('model-open');
	        document.body.scrollTop = this.auxScroll;
	      }
	    }
	  },
	
	  computed: {
	    scrollEnabled: function scrollEnabled() {
	      return window.store.state.config.scrollEnabled;
	    },
	    btnIsLoading: function btnIsLoading() {
	      if (window.store.state.notification.loadingButtons.includes('.card-modal-ok-btn')) {
	        return true;
	      }
	      return false;
	    }
	  },
	
	  methods: {
	    ok: function ok() {
	      window.store.dispatch('newEvent', 'modal-card-ok');
	      window.store.dispatch('activateScroll');
	    },
	    preview: function preview() {
	      this.previewActive = !this.previewActive;
	      window.store.dispatch('newEvent', 'modal-card-preview');
	
	      if (this.previewActive) {
	        this.previewText = 'Editar';
	      } else {
	        this.previewText = 'Pré-visualizar';
	      }
	    },
	    cancel: function cancel() {
	      window.store.dispatch('newEvent', 'modal-card-cancel');
	      window.store.dispatch('activateScroll');
	    }
	  }
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var Dropzone = __webpack_require__(187);
	Dropzone.autoDiscover = false;
	
	exports.default = {
	  props: {
	    id: {
	      type: String,
	      required: true
	    },
	    url: {
	      type: String,
	      required: true
	    },
	    clickable: {
	      type: Boolean,
	      default: true
	    },
	    acceptedFileTypes: {
	      type: String
	    },
	    thumbnailHeight: {
	      type: Number,
	      default: 200
	    },
	    thumbnailWidth: {
	      type: Number,
	      default: 200
	    },
	    showRemoveLink: {
	      type: Boolean,
	      default: true
	    },
	    maxFileSizeInMB: {
	      type: Number,
	      default: 70
	    },
	    maxThumbnailFilesize: {
	      type: Number,
	      default: 70
	    },
	    maxNumberOfFiles: {
	      type: Number,
	      default: 1
	    },
	    autoProcessQueue: {
	      type: Boolean,
	      default: true
	    },
	    dictDefaultMessage: {
	      type: String,
	      default: '<i class="fa fa-cloud-upload fa-2x" aria-hidden="true"></i><br>Carregar ficheiro aqui'
	    },
	    dictRemoveFile: {
	      type: String,
	      default: 'Remover'
	    },
	    dictFileTooBig: {
	      type: String,
	      default: 'Ficheiro demasiado grande ({{filesize}}MiB). Max: {{maxFilesize}}MiB.'
	    },
	    dictInvalidFileType: {
	      type: String,
	      default: 'Tipo de ficheiro inválido.'
	    },
	    dictCancelUpload: {
	      type: String,
	      default: 'Cancelar upload'
	    },
	    dictCancelUploadConfirmation: {
	      type: String,
	      default: 'Tem a certeza que quer cancelar o upload?'
	    },
	    dictMaxFilesExceeded: {
	      type: String,
	      default: 'Não pode carregar mais ficheiros'
	    },
	    useCustomDropzoneOptions: {
	      type: Boolean,
	      default: false
	    },
	    dropzoneOptions: {
	      type: Object
	    }
	  },
	
	  events: {
	    removeAllFiles: function removeAllFiles() {
	      this.dropzone.removeAllFiles(true);
	    },
	    processQueue: function processQueue() {
	      this.dropzone.processQueue();
	    }
	  },
	  mounted: function mounted() {
	    var element = document.getElementById(this.id);
	    if (!element) {
	      element = this.$el;
	    }
	    if (!this.useCustomDropzoneOptions) {
	      this.dropzone = new Dropzone(element, {
	        clickable: this.clickable,
	        thumbnailWidth: this.thumbnailWidth,
	        thumbnailHeight: this.thumbnailHeight,
	        maxFiles: this.maxNumberOfFiles,
	        maxFilesize: this.maxFileSizeInMB,
	        maxThumbnailFilesize: this.maxThumbnailFilesize,
	        dictRemoveFile: this.dictRemoveFile,
	        addRemoveLinks: this.showRemoveLink,
	        acceptedFiles: this.acceptedFileTypes,
	        autoProcessQueue: this.autoProcessQueue,
	        dictDefaultMessage: this.dictDefaultMessage,
	        dictFileTooBig: this.dictFileTooBig,
	        dictInvalidFileType: this.dictInvalidFileType,
	        dictCancelUpload: this.dictCancelUpload,
	        dictCancelUploadConfirmation: this.dictCancelUploadConfirmation,
	        dictMaxFilesExceeded: this.dictMaxFilesExceeded,
	        previewTemplate: '<div class="dz-preview dz-file-preview">  <div class="dz-image" style="width:' + this.thumbnailWidth + 'px;height:' + this.thumbnailHeight + 'px"><img data-dz-thumbnail /></div>  <div class="dz-details">    <div class="dz-size"><span data-dz-size></span></div>    <div class="dz-filename"><span data-dz-name></span></div>  </div>  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>  <div class="dz-error-message"><span data-dz-errormessage></span></div>  <div class="dz-success-mark"> <span class="fa-stack fa-lg fa-coach-preview"> <i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-check fa-stack-1x"></i> </span> </div>  <div class="dz-error-mark"> <span class="fa-stack fa-lg fa-coach-preview"> <i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-exclamation fa-stack-1x"></i> </span> </div></div>'
	      });
	    } else {
	      this.dropzone = new Dropzone(element, this.dropzoneOptions);
	    }
	
	    var vm = this;
	    this.dropzone.on('addedfile', function (file) {
	      vm.$emit('vdropzone-fileAdded', file);
	    });
	
	    this.dropzone.on('maxfilesexceeded', function (file) {
	      this.removeFile(file);
	      vm.$emit('vdropzone-maxfilesexceeded', file);
	    });
	
	    this.dropzone.on('removedfile', function (file) {
	      vm.$emit('vdropzone-removedfile', file);
	    });
	
	    this.dropzone.on('success', function (file, response) {
	      var _this = this;
	
	      setTimeout(function () {
	        var success = _this.element.querySelector('.dz-success-mark');
	        if (success) {
	          success.classList.add('dropzone-hidden');
	        }
	      }, 3000);
	      vm.$emit('vdropzone-success', file, response);
	    });
	
	    this.dropzone.on('error', function (file, error, xhr) {
	      vm.$emit('vdropzone-error', file, error, xhr);
	    });
	  }
	};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    background: {
	      type: String,
	      default: null
	    },
	    foreground: {
	      type: String,
	      default: null
	    },
	    showLogo: {
	      type: Boolean,
	      default: false
	    },
	    logoColor: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  methods: {}
	};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(3);
	
	var DEFAULT_PREVIEW_SIZE = 600;
	
	exports.default = {
	  props: {
	    background1: {
	      type: String,
	      default: null
	    },
	    background2: {
	      type: String,
	      default: null
	    },
	    foreground1: {
	      type: String,
	      default: null
	    },
	    foreground2: {
	      type: String,
	      default: null
	    },
	    backgroundColor: {
	      type: String,
	      default: null
	    },
	    textboxColor: {
	      type: String,
	      default: null
	    },
	    textColor: {
	      type: String,
	      default: null
	    },
	    description: {
	      type: String,
	      default: null
	    },
	    plusDetail: {
	      type: String,
	      default: null
	    },
	    showDetail: {
	      type: Boolean,
	      default: false
	    },
	    slide: {
	      type: Number,
	      default: 0
	    },
	    category: {
	      type: Number,
	      default: 1
	    },
	    editWidth: {
	      type: Number,
	      default: 600
	    },
	    insertMode: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  data: function data() {
	    return {
	      transparent: 'url(' + __webpack_require__(256) + ')',
	      imageWidth: 600
	    };
	  },
	  mounted: function mounted() {
	    this.imageWidth = this.editWidth;
	
	    this.$nextTick(function () {
	      window.addEventListener('resize', this.handleResize);
	    });
	  },
	
	
	  computed: {
	    background1Offset: function background1Offset() {
	      return -(this.imageWidth * 180) / 600 * this.slide;
	    },
	    background2Offset: function background2Offset() {
	      return -(this.imageWidth * 360) / 600 * this.slide;
	    },
	    foreground2Offset: function foreground2Offset() {
	      return -(this.imageWidth * 150) / 600;
	    },
	    imageHeight: function imageHeight() {
	      return this.imageWidth * 9 / 16;
	    },
	    textboxText: function textboxText() {
	      if (this.showDetail) {
	        return this.description + this.plusDetail;
	      } else {
	        return this.description;
	      }
	    },
	    textboxClass: function textboxClass() {
	      if (_config.MENUS.eraumavez === this.category) {
	        return 'parallax-textbox-eraumavez';
	      }
	      return 'parallax-textbox-default';
	    },
	    textClass: function textClass() {
	      if (_config.MENUS.ambepoca === this.category) {
	        return 'parallax-text-ambepoca';
	      }
	      return 'parallax-text-default';
	    },
	    textboxZoom: function textboxZoom() {
	      return 'scale(' + this.imageWidth / DEFAULT_PREVIEW_SIZE + ')';
	    },
	    textboxPosition: function textboxPosition() {
	      var position = {
	        top: null,
	        bottom: null,
	        left: 11.25 * (this.imageWidth / DEFAULT_PREVIEW_SIZE)
	      };
	
	      if (_config.MENUS.eraumavez === this.category) {
	        position.top = 260 * (this.imageWidth / DEFAULT_PREVIEW_SIZE);
	      } else {
	        if (this.insertMode === 2) {
	          position.bottom = 6.25;
	        } else {
	          position.bottom = 0;
	        }
	        position.bottom = position.bottom + 11.25 * (this.imageWidth / DEFAULT_PREVIEW_SIZE);
	      }
	
	      return position;
	    },
	    isImage: function isImage() {
	      return !this.isVideo(this.background1);
	    }
	  },
	
	  methods: {
	    handleResize: function handleResize() {
	      var element = document.getElementById('modal-preview-content');
	      var elementEdit = document.getElementById('modal-edit-content');
	
	      if (element && element.getBoundingClientRect().width !== 0) {
	        this.imageWidth = element.getBoundingClientRect().width;
	      } else if (elementEdit && elementEdit.getBoundingClientRect().width !== 0) {
	        this.imageWidth = elementEdit.getBoundingClientRect().width;
	      }
	    },
	    isVideo: function isVideo(path) {
	      var videoExtensions = ['mp4', 'mov', 'mkv', 'avi'];
	
	      var splitPath = path.split('.');
	      var extension = splitPath.pop();
	
	      if (videoExtensions.includes(extension)) {
	        return true;
	      }
	      return false;
	    }
	  }
	};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(68);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _EditableInput = __webpack_require__(296);
	
	var _EditableInput2 = _interopRequireDefault(_EditableInput);
	
	var _Saturation = __webpack_require__(298);
	
	var _Saturation2 = _interopRequireDefault(_Saturation);
	
	var _Hue = __webpack_require__(297);
	
	var _Hue2 = _interopRequireDefault(_Hue);
	
	var _Alpha = __webpack_require__(294);
	
	var _Alpha2 = _interopRequireDefault(_Alpha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var presetColors = ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'];
	
	exports.default = {
	  name: 'Sketch',
	  mixins: [_color2.default],
	  components: {
	    saturation: _Saturation2.default,
	    hue: _Hue2.default,
	    alpha: _Alpha2.default,
	    'ed-in': _EditableInput2.default
	  },
	  data: function data() {
	    return {
	      presetColors: presetColors
	    };
	  },
	
	  computed: {
	    activeColor: function activeColor() {
	      var rgba = this.colors.rgba;
	      return 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')';
	    }
	  },
	  methods: {
	    handlePreset: function handlePreset(c) {
	      this.colorChange({
	        hex: c,
	        source: 'hex'
	      });
	    },
	    childChange: function childChange(data) {
	      this.colorChange(data);
	    },
	    inputChange: function inputChange(data) {
	      if (!data) {
	        return;
	      }
	      if (data.hex) {
	        this.isValidHex(data.hex) && this.colorChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b || data.a) {
	        this.colorChange({
	          r: data.r || this.colors.rgba.r,
	          g: data.g || this.colors.rgba.g,
	          b: data.b || this.colors.rgba.b,
	          a: data.a || this.colors.rgba.a,
	          source: 'rgba'
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    selected: Number,
	    target: Object,
	    update: String
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  methods: {
	    updateState: function updateState(state) {
	      if (this.update === 'coach') {
	        this.$store.dispatch('updateCoachState', { id: this.target.id, data: { state: state } });
	      }
	      if (this.update === 'menu') {
	        var data = {
	          state: state,
	          coach: this.target.coach_id,
	          category: this.target.id
	        };
	        this.$store.dispatch('updateCategoryCoachState', { id: this.target.coach_id, data: data });
	      }
	      if (this.update === 'menu-slides') {
	        var _data = {
	          state: state,
	          coach: this.target.coach_id,
	          category: this.target.id
	        };
	        this.$store.dispatch('updateMenuState', { id: this.target.coach_id, data: _data });
	      }
	      if (this.update === 'slide') {
	        var _data2 = {
	          state: state,
	          coach: this.target.coach_id,
	          category: this.target.slide_category_id
	        };
	        this.$store.dispatch('updateSlideState', { id: this.target.id, data: _data2 });
	      }
	      if (this.update === 'exterior') {
	        var _data3 = {
	          state: state,
	          coach: this.target.coachId,
	          exterior: this.target.exteriorId
	        };
	        this.$store.dispatch('updateExteriorState', { id: this.target.exteriorId, data: _data3 });
	      }
	    }
	  }
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(5);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    disabled: Boolean,
	    isFullwidth: Boolean,
	    type: String,
	    size: String,
	    checked: Boolean
	  },
	
	  data: function data() {
	    return {
	      realValue: this.checked
	    };
	  },
	  mounted: function mounted() {
	    this.realValue = !!this.checked;
	  },
	
	
	  computed: {
	    classObject: function classObject() {
	      var _ref;
	
	      var type = this.type,
	          size = this.size,
	          realValue = this.realValue;
	
	      return _ref = {}, (0, _defineProperty3.default)(_ref, 'is-' + type, type), (0, _defineProperty3.default)(_ref, 'is-' + size, size), (0, _defineProperty3.default)(_ref, 'checked', realValue), _ref;
	    }
	  },
	
	  watch: {
	    realValue: function realValue(val) {
	      this.$emit('change', val);
	      window.store.dispatch('newEvent', 'switch-change-' + val);
	    }
	  }
	};

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/coche_logo.2b99501.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/coche_logo_white.1af2e11.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/coches-big-black.a3c0745.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/coches-small-black.649d626.png";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(237)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(94),
	  /* template */
	  __webpack_require__(347),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(236)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(95),
	  /* template */
	  __webpack_require__(346),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(189)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(96),
	  /* template */
	  __webpack_require__(300),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(220)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(97),
	  /* template */
	  __webpack_require__(330),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(224)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(98),
	  /* template */
	  __webpack_require__(335),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(240)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(99),
	  /* template */
	  __webpack_require__(350),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(192)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(102),
	  /* template */
	  __webpack_require__(303),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(214)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(103),
	  /* template */
	  __webpack_require__(324),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(235)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(104),
	  /* template */
	  __webpack_require__(345),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(242)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(105),
	  /* template */
	  __webpack_require__(352),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(197)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(106),
	  /* template */
	  __webpack_require__(308),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(204)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(107),
	  /* template */
	  __webpack_require__(314),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(225)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(108),
	  /* template */
	  __webpack_require__(336),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(210)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(110),
	  /* template */
	  __webpack_require__(320),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(226)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(111),
	  /* template */
	  __webpack_require__(337),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(207)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(112),
	  /* template */
	  __webpack_require__(317),
	  /* scopeId */
	  "data-v-45e7c1ca",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(212)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(113),
	  /* template */
	  __webpack_require__(322),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(230)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(114),
	  /* template */
	  __webpack_require__(341),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(191)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(115),
	  /* template */
	  __webpack_require__(302),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(245)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(116),
	  /* template */
	  __webpack_require__(355),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(206)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(117),
	  /* template */
	  __webpack_require__(316),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(205)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(118),
	  /* template */
	  __webpack_require__(315),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(190)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(119),
	  /* template */
	  __webpack_require__(301),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(216)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(120),
	  /* template */
	  __webpack_require__(326),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(234)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(121),
	  /* template */
	  __webpack_require__(344),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(208)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(124),
	  /* template */
	  __webpack_require__(318),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(223)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(126),
	  /* template */
	  __webpack_require__(333),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(211)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(127),
	  /* template */
	  __webpack_require__(321),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(243)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(128),
	  /* template */
	  __webpack_require__(353),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(199)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(129),
	  /* template */
	  __webpack_require__(310),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(241)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(130),
	  /* template */
	  __webpack_require__(351),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(227)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(132),
	  /* template */
	  __webpack_require__(338),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(221)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(133),
	  /* template */
	  __webpack_require__(331),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(228)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(134),
	  /* template */
	  __webpack_require__(339),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(217)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(139),
	  /* template */
	  __webpack_require__(327),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(196)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(142),
	  /* template */
	  __webpack_require__(307),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(246)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(86),
	  /* template */
	  __webpack_require__(356),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(238)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(88),
	  /* template */
	  __webpack_require__(348),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(244)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(89),
	  /* template */
	  __webpack_require__(354),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(218)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(90),
	  /* template */
	  __webpack_require__(328),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(193)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(91),
	  /* template */
	  __webpack_require__(304),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(200)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(92),
	  /* template */
	  __webpack_require__(311),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(231)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(93),
	  /* template */
	  __webpack_require__(342),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card coach-card"
	  }, [_c('div', {
	    staticClass: "card-image"
	  }, [_c('figure', {
	    staticClass: "image",
	    style: ({
	      backgroundColor: _vm.coach.background_color
	    })
	  }, [_c('image-composite', {
	    attrs: {
	      "background": _vm.background,
	      "foreground": _vm.foreground
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "card-content"
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_c('div', {
	    staticClass: "media-content"
	  }, [_c('p', {
	    staticClass: "title is-5"
	  }, [_vm._v(_vm._s(_vm.coach.languages[0].pivot.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('small', [_c('b', [_vm._v(_vm._s(_vm.coachState))]), _vm._v(" " + _vm._s(_vm.coach.updated_at))])])]), _vm._v(" "), _c('footer', {
	    staticClass: "card-footer"
	  }, [_c('a', {
	    staticClass: "card-footer-item",
	    on: {
	      "click": _vm.editCoach
	    }
	  }, [_vm._v("Editar")]), _vm._v(" "), _c('a', {
	    staticClass: "card-footer-item",
	    on: {
	      "click": _vm.openDeleteModal
	    }
	  }, [_vm._v(_vm._s(_vm.deleteText))])])])
	},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slide-container"
	  }, [_c('div', {
	    staticClass: "title-with-selector h3-selector"
	  }, [_c('h3', {
	    staticClass: "subtitle"
	  }, [_c('b', [_vm._v(_vm._s('Slide ' + _vm.slide.order))])]), _vm._v(" "), _c('state-selector', {
	    attrs: {
	      "selected": _vm.slide ? parseInt(_vm.slide.state_id) : null,
	      "target": _vm.slide,
	      "update": 'slide'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "columns is-multiline"
	  }, [_c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Descrição [PT]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.pt.description)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.pt.description) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Mais Detalhes [PT]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.pt.plus_detail)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.pt.plus_detail) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Descrição [EN]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.en.description)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.en.description) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Mais Detalhes [EN]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.en.plus_detail)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.en.plus_detail) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Descrição [ES]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.es.description)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.es.description) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Mais Detalhes [ES]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.es.plus_detail)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.es.plus_detail) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Descrição [FR]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.fr.description)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.fr.description) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
	    staticClass: "column is-6"
	  }, [_c('b', [_vm._v("Mais Detalhes [FR]")]), _c('br'), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText.fr.plus_detail)
	    }
	  }), _vm._v(" "), (!_vm.htmlText.fr.plus_detail) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [(_vm.slide.foreground_path_1) ? _c('div', {
	    staticClass: "column is-6"
	  }, [_vm._m(0), _vm._v(" "), (_vm.isVideo(_vm.slide.foreground_path_1)) ? _c('figure', {
	    staticClass: "image"
	  }, [_c('video', {
	    attrs: {
	      "width": "100%",
	      "height": "100%",
	      "controls": "",
	      "id": ("video-" + (_vm.slide.id))
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": _vm.slideImagePath + _vm.slide.foreground_path_1,
	      "type": "video/mp4"
	    }
	  }), _vm._v("\n          Your browser does not support the video tag.\n        ")])]) : _c('figure', {
	    staticClass: "image coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.slideImagePath + _vm.slide.foreground_path_1
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.slide.foreground_path_2 && !_vm.isVideo(_vm.slide.foreground_path_1)) ? _c('div', {
	    staticClass: "column is-6"
	  }, [_vm._m(1), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.slideImagePath + _vm.slide.foreground_path_2
	    }
	  })])]) : _vm._e()]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('b', {
	    staticClass: "inline-lable"
	  }, [_vm._v("Posição:")]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.slide.order == 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderSlides(1)
	      }
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Topo")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.slide.order == 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderSlides(parseInt(_vm.slide.order) - 1)
	      }
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("-1")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.slide.order == _vm.slideTotal
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderSlides(parseInt(_vm.slide.order) + 1)
	      }
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("+1")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.slide.order == _vm.slideTotal
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderSlides(_vm.slideTotal)
	      }
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Fundo")])])]), _vm._v(" "), (!_vm.slide.sub_menu && !_vm.slide.parent_id && _vm.showSubMenu) ? _c('a', {
	    staticClass: "button is-small is-info",
	    on: {
	      "click": _vm.openSlideSetEditModal
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Adicionar Sub-slides")])]) : _vm._e(), _vm._v(" "), (_vm.slide.sub_menu) ? _c('a', {
	    staticClass: "button is-small is-danger",
	    on: {
	      "click": _vm.openSlideSetDeleteModal
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Apagar Sub-slides")])]) : _vm._e(), _vm._v(" "), (_vm.slide.sub_menu) ? _c('a', {
	    staticClass: "button is-small is-info",
	    on: {
	      "click": _vm.goToSubSlide
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Sub-slides")])]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "button is-small is-primary",
	    on: {
	      "click": _vm.openSlideEditModal
	    }
	  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Editar")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small is-danger",
	    on: {
	      "click": _vm.openSlideDeleteModal
	    }
	  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Apagar")])]), _vm._v(" "), _c('hr')])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Foreground 1")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Foreground 2")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-up"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-up"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  })])
	}]}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "panoramaContainer"
	    }
	  }, [_c('div', {
	    staticClass: "container container-margin-top is-fluid content-padding",
	    attrs: {
	      "id": "view-panorama"
	    }
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('div', {
	    attrs: {
	      "id": "panorama-cube-holder"
	    }
	  }, [_c('div', {
	    staticClass: "columns is-multiline"
	  }, [_c('div', {
	    staticClass: "column is-one-third-tablet is-2-desktop"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Frente")]), _vm._v(" "), _c('figure', {
	    staticClass: "image is-square"
	  }, [(!_vm.newImages[0] && _vm.panoramaInfo.cubes[0]) ? _c('figure', {
	    staticClass: "panorama-image fake-dropzone",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone(0)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imageUrl(0)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove"
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[0] || !_vm.panoramaInfo.cubes[0]) ? _c('p', {
	    staticClass: "control dropzone-holder"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom dz-element",
	    attrs: {
	      "id": "panoramaPosition0Dz",
	      "url": _vm.dropzoneUploadUrl + '?position=0',
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadImage,
	      "vdropzone-removedfile": function($event) {
	        _vm.removeImage(0)
	      }
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-third-tablet is-2-desktop"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Esquerda")]), _vm._v(" "), _c('figure', {
	    staticClass: "image is-square"
	  }, [(!_vm.newImages[1] && _vm.panoramaInfo.cubes[1]) ? _c('figure', {
	    staticClass: "panorama-image fake-dropzone",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone(1)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imageUrl(1)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove"
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[1] || !_vm.panoramaInfo.cubes[1]) ? _c('p', {
	    staticClass: "control dropzone-holder"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom dz-element",
	    attrs: {
	      "id": "panoramaPosition1Dz",
	      "url": _vm.dropzoneUploadUrl + '?position=1',
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadImage,
	      "vdropzone-removedfile": function($event) {
	        _vm.removeImage(1)
	      }
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-third-tablet is-2-desktop"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Trás")]), _vm._v(" "), _c('figure', {
	    staticClass: "image is-square"
	  }, [(!_vm.newImages[2] && _vm.panoramaInfo.cubes[2]) ? _c('figure', {
	    staticClass: "panorama-image fake-dropzone",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone(2)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imageUrl(2)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove"
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[2] || !_vm.panoramaInfo.cubes[2]) ? _c('p', {
	    staticClass: "control dropzone-holder"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom dz-element",
	    attrs: {
	      "id": "panoramaPosition2Dz",
	      "url": _vm.dropzoneUploadUrl + '?position=2',
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadImage,
	      "vdropzone-removedfile": function($event) {
	        _vm.removeImage(2)
	      }
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-third-tablet is-2-desktop"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Direita")]), _vm._v(" "), _c('figure', {
	    staticClass: "image is-square"
	  }, [(!_vm.newImages[3] && _vm.panoramaInfo.cubes[3]) ? _c('figure', {
	    staticClass: "panorama-image fake-dropzone",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone(3)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imageUrl(3)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove"
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[3] || !_vm.panoramaInfo.cubes[3]) ? _c('p', {
	    staticClass: "control dropzone-holder"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom dz-element",
	    attrs: {
	      "id": "panoramaPosition3Dz",
	      "url": _vm.dropzoneUploadUrl + '?position=3',
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadImage,
	      "vdropzone-removedfile": function($event) {
	        _vm.removeImage(3)
	      }
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-third-tablet is-2-desktop"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Topo")]), _vm._v(" "), _c('figure', {
	    staticClass: "image is-square"
	  }, [(!_vm.newImages[4] && _vm.panoramaInfo.cubes[4]) ? _c('figure', {
	    staticClass: "panorama-image fake-dropzone",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone(4)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imageUrl(4)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove"
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[4] || !_vm.panoramaInfo.cubes[4]) ? _c('p', {
	    staticClass: "control dropzone-holder"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom dz-element",
	    attrs: {
	      "id": "panoramaPosition4Dz",
	      "url": _vm.dropzoneUploadUrl + '?position=4',
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadImage,
	      "vdropzone-removedfile": function($event) {
	        _vm.removeImage(4)
	      }
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-third-tablet is-2-desktop"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Fundo")]), _vm._v(" "), _c('figure', {
	    staticClass: "image is-square"
	  }, [(!_vm.newImages[5] && _vm.panoramaInfo.cubes[5]) ? _c('figure', {
	    staticClass: "panorama-image fake-dropzone",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone(5)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.imageUrl(5)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove"
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[5] || !_vm.panoramaInfo.cubes[5]) ? _c('p', {
	    staticClass: "control dropzone-holder"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom dz-element",
	    attrs: {
	      "id": "panoramaPosition5Dz",
	      "url": _vm.dropzoneUploadUrl + '?position=5',
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadImage,
	      "vdropzone-removedfile": function($event) {
	        _vm.removeImage(5)
	      }
	    }
	  })], 1) : _vm._e()])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "columns pantitltfov is-mobile"
	  }, [_c('div', {
	    staticClass: "column is-fifth"
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Pan")]), _vm._v(": " + _vm._s(_vm.panoramaInfo.pan.toFixed(4)))])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-fifth"
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Tilt")]), _vm._v(": " + _vm._s(_vm.panoramaInfo.tilt.toFixed(4)))])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-fifth"
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Fov")]), _vm._v(": " + _vm._s(_vm.panoramaInfo.fov.toFixed(4)))])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-fifth"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "column is-fifth"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "columns panoramaButtons"
	  }, [_c('div', {
	    staticClass: "column is-third"
	  }, [_c('a', {
	    staticClass: "button",
	    on: {
	      "click": _vm.resetPanoramaView
	    }
	  }, [_vm._v("Voltar à vista inicial")])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-third"
	  }, [_c('a', {
	    staticClass: "button",
	    on: {
	      "click": _vm.setNewStart
	    }
	  }, [_vm._v("Definir nova vista inicial")])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-third"
	  }, [_c('a', {
	    staticClass: "button is-success",
	    on: {
	      "click": _vm.createHotspot
	    }
	  }, [_vm._v("Criar Hotspot")])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.panoramaPoints), function(point) {
	    return _c('tr', {
	      attrs: {
	        "id": 'point_' + point.pointId
	      }
	    }, [_c('td', [_vm._v(_vm._s(point.languages[0].name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.pan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.tilt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.fov))]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "button is-success",
	      on: {
	        "click": function($event) {
	          _vm.setView(point.pointId)
	        }
	      }
	    }, [_vm._v("Mostrar no panorama")])]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "button",
	      on: {
	        "click": function($event) {
	          _vm.updateHotspot(point.pointId)
	        }
	      }
	    }, [_vm._v("Editar texto")])]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "button",
	      on: {
	        "click": function($event) {
	          _vm.setNewView(point.pointId)
	        }
	      }
	    }, [_vm._v("Definir novo enquadramento")])]), _vm._v(" "), _c('td', [_c('a', {
	      staticClass: "button is-danger",
	      on: {
	        "click": function($event) {
	          _vm.deleteHotspot(point.pointId)
	        }
	      }
	    }, [_vm._v("Apagar")])])])
	  }))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('figure', {
	    staticClass: "image is-16by9"
	  }, [_c('div', {
	    attrs: {
	      "id": "panoramaViewer"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "crossairHolder"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "crossairInner"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Pan")]), _vm._v(" "), _c('th', [_vm._v("Tilt")]), _vm._v(" "), _c('th', [_vm._v("Fov")]), _vm._v(" "), _c('th', [_vm._v("Mostrar")]), _vm._v(" "), _c('th', [_vm._v("Editar Texto")]), _vm._v(" "), _c('th', [_vm._v("Enquadramento")]), _vm._v(" "), _c('th', [_vm._v("Apagar")])])])
	}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('div', {
	    staticClass: "title-with-selector h1-selector"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.coach ? _vm.coach.languages[0].pivot.name : null))]), _vm._v(" "), _c('state-selector', {
	    attrs: {
	      "selected": _vm.coach ? parseInt(_vm.coach.state_id) : null,
	      "target": _vm.coach,
	      "update": 'coach'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('span', [_c('b', [_vm._v("Nome [PT]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('pt')))])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('span', [_c('b', [_vm._v("Nome [EN]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('en')))])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('span', [_c('b', [_vm._v("Nome [ES]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('es')))])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('span', [_c('b', [_vm._v("Nome [FR]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('fr')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns is-multiline"
	  }, [_c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('background_color')) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.getCoachProperty('background_color')
	    })
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor de Titulo + Texto do Menu")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('title_color')) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.getCoachProperty('title_color')
	    })
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor Botões Inactivos")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('inactive_color')) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.getCoachProperty('inactive_color')
	    })
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor Botões Activos")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('active_color')) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.getCoachProperty('active_color')
	    })
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor de Separadores do Menu")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('filet_color')) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.getCoachProperty('filet_color')
	    })
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [(_vm.coach && _vm.coach.background_path) ? _c('div', {
	    staticClass: "column is-half"
	  }, [_vm._m(0), _vm._v(" "), _c('figure', {
	    staticClass: "image is-16by9 coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coachBackground
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.coach && _vm.coach.foreground_path) ? _c('div', {
	    staticClass: "column is-half"
	  }, [_vm._m(1), _vm._v(" "), _c('figure', {
	    staticClass: "image is-16by9 coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coachForeground
	    }
	  })])]) : _vm._e()]), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.openEditCoachModal
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Editar")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Foreground")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	}]}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['vue-color__c-hue', _vm.directionClass]
	  }, [_c('div', {
	    ref: "container",
	    staticClass: "vue-color__c-hue__container",
	    on: {
	      "mousedown": _vm.handleMouseDown,
	      "touchmove": _vm.handleChange,
	      "touchstart": _vm.handleChange
	    }
	  }, [_c('div', {
	    staticClass: "vue-color__c-hue__pointer",
	    style: ({
	      top: _vm.pointerTop,
	      left: _vm.pointerLeft
	    })
	  }, [_c('div', {
	    staticClass: "vue-color__c-hue__picker"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-color__sketch"
	  }, [_c('div', {
	    staticClass: "vue-color__sketch__saturation-wrap"
	  }, [_c('saturation', {
	    on: {
	      "change": _vm.childChange
	    },
	    model: {
	      value: (_vm.colors),
	      callback: function($$v) {
	        _vm.colors = $$v
	      },
	      expression: "colors"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__sketch__controls"
	  }, [_c('div', {
	    staticClass: "vue-color__sketch__sliders"
	  }, [_c('div', {
	    staticClass: "vue-color__sketch__hue-wrap"
	  }, [_c('hue', {
	    on: {
	      "change": _vm.childChange
	    },
	    model: {
	      value: (_vm.colors),
	      callback: function($$v) {
	        _vm.colors = $$v
	      },
	      expression: "colors"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__sketch__color-wrap"
	  }, [_c('div', {
	    staticClass: "vue-color__sketch__active-color",
	    style: ({
	      background: _vm.activeColor
	    })
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__sketch__field"
	  }, [_c('div', {
	    staticClass: "vue-color__sketch__field--double"
	  }, [_c('ed-in', {
	    attrs: {
	      "label": "hex"
	    },
	    on: {
	      "change": _vm.inputChange
	    },
	    model: {
	      value: (_vm.colors.hex),
	      callback: function($$v) {
	        _vm.colors.hex = $$v
	      },
	      expression: "colors.hex"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__sketch__field--single"
	  }, [_c('ed-in', {
	    attrs: {
	      "label": "r"
	    },
	    on: {
	      "change": _vm.inputChange
	    },
	    model: {
	      value: (_vm.colors.rgba.r),
	      callback: function($$v) {
	        _vm.colors.rgba.r = $$v
	      },
	      expression: "colors.rgba.r"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__sketch__field--single"
	  }, [_c('ed-in', {
	    attrs: {
	      "label": "g"
	    },
	    on: {
	      "change": _vm.inputChange
	    },
	    model: {
	      value: (_vm.colors.rgba.g),
	      callback: function($$v) {
	        _vm.colors.rgba.g = $$v
	      },
	      expression: "colors.rgba.g"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__sketch__field--single"
	  }, [_c('ed-in', {
	    attrs: {
	      "label": "b"
	    },
	    on: {
	      "change": _vm.inputChange
	    },
	    model: {
	      value: (_vm.colors.rgba.b),
	      callback: function($$v) {
	        _vm.colors.rgba.b = $$v
	      },
	      expression: "colors.rgba.b"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Submeter',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content category-model",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor de Fundo")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.category.background_color.hex),
	      expression: "category.background_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.category.background_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.category.background_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextBackground === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('background')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextBackground))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input category-color-preview",
	    style: ({
	      backgroundColor: _vm.category.background_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), (_vm.category_id != 5) ? _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor Caixa de Texto")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.category.textbox_color.hex),
	      expression: "category.textbox_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.category.textbox_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.category.textbox_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextTextbox === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('textbox')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextTextbox))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input category-color-preview",
	    style: ({
	      backgroundColor: _vm.category.textbox_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor do Texto")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.category.text_color.hex),
	      expression: "category.text_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.category.text_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.category.text_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextText === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('text')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextText))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input category-color-preview",
	    style: ({
	      backgroundColor: _vm.category.text_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('sketch-picker', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showColorPicker),
	      expression: "showColorPicker"
	    }],
	    class: 'color-picker-position-' + _vm.colorPickerPosition,
	    on: {
	      "input": _vm.onChangePickerColor
	    },
	    model: {
	      value: (_vm.pickerColor),
	      callback: function($$v) {
	        _vm.pickerColor = $$v
	      },
	      expression: "pickerColor"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Background 1 "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(*x1080px)")])]), _vm._v(" "), (!_vm.newBackground1 && _vm.category.background_image_1) ? _c('figure', {
	    staticClass: "image coach-image background-1 fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.category.background_image_1
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('background1')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "categoryBackground1",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 596,
	      "thumbnail-height": 150,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadBackground,
	      "vdropzone-removedfile": _vm.removeBackground
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Background 2 "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(*x1080px)")])]), _vm._v(" "), (!_vm.newBackground2 && _vm.category.background_image_2) ? _c('figure', {
	    staticClass: "image coach-image background-2 fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.category.background_image_2
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('background2')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "categoryBackground2",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 596,
	      "thumbnail-height": 150,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadForeground,
	      "vdropzone-removedfile": _vm.removeForeground
	    }
	  })], 1)])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch",
	    class: _vm.classObject
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.realValue),
	      expression: "realValue"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.realValue) ? _vm._i(_vm.realValue, null) > -1 : (_vm.realValue)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.realValue,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.realValue = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.realValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.realValue = $$c
	        }
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "view-coaches-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "view-coaches"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "columns coach-toolbar"
	  }, [_c('div', {
	    staticClass: "column is-8"
	  }, [_c('p', {
	    staticClass: "control has-icon search-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    staticClass: "input is-medium",
	    attrs: {
	      "type": "text",
	      "placeholder": "Procurar Coches"
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-search"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-2"
	  }, [_c('div', {
	    staticClass: "control"
	  }, [_c('div', {
	    staticClass: "select is-medium is-fullwidth"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedState),
	      expression: "selectedState"
	    }],
	    class: {
	      'gray-select': _vm.selectedState === 0
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    staticClass: "gray-select",
	    domProps: {
	      "value": 0
	    }
	  }, [_vm._v("Estados")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
	    return _c('option', {
	      staticClass: "black-select",
	      domProps: {
	        "value": state.id
	      }
	    }, [_vm._v(_vm._s(state.name))])
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-2"
	  }, [_c('coach-new')], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "flexbox-grid"
	  }, _vm._l((_vm.filteredCoaches), function(coach) {
	    return _c('coach-card', {
	      attrs: {
	        "coach": coach
	      }
	    })
	  }))])])])
	},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v("Lista de Slides")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.slides), function(slide) {
	    return _c('level-slide', {
	      attrs: {
	        "slide": slide,
	        "slideTotal": _vm.slides.length,
	        "parent": _vm.parent,
	        "menu": _vm.menu
	      }
	    })
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.openSlideEditModal
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Criar")])])], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	}]}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card user-card"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "card-content"
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_c('div', {
	    staticClass: "media-content"
	  }, [_c('p', {
	    staticClass: "title is-5"
	  }, [_vm._v(_vm._s(_vm.user.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('small', [_vm._v(_vm._s(_vm.user.email))])])]), _vm._v(" "), _c('footer', {
	    staticClass: "card-footer"
	  }, [_c('a', {
	    staticClass: "card-footer-item",
	    on: {
	      "click": _vm.editUser
	    }
	  }, [_vm._v("Editar")]), _vm._v(" "), _c('a', {
	    staticClass: "card-footer-item",
	    on: {
	      "click": _vm.deleteUser
	    }
	  }, [_vm._v("Apagar")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-image"
	  }, [_c('figure', {
	    staticClass: "image"
	  })])
	}]}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "container",
	    staticClass: "vue-color__saturation",
	    style: ({
	      background: _vm.bgColor
	    }),
	    on: {
	      "mousedown": _vm.handleMouseDown
	    }
	  }, [_c('div', {
	    staticClass: "vue-color__saturation--white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__saturation--black"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__saturation--pointer",
	    style: ({
	      top: _vm.pointerTop,
	      left: _vm.pointerLeft
	    })
	  }, [_c('div', {
	    staticClass: "vue-color__saturation--circle"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "disableOk": false,
	      "disablePreview": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    class: [_vm.showPreview ? 'is-hidden' : ''],
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('p', {
	    staticClass: "control"
	  }, [(_vm.isSubslide) ? _c('span', {
	    staticClass: "select mode-select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.insertMode),
	      expression: "insertMode"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.insertMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": 1
	    }
	  }, [_vm._v("Imagem")]), _vm._v(" "), _c('option', {
	    domProps: {
	      "value": 2
	    }
	  }, [_vm._v("Video")])])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editLanguage),
	      expression: "editLanguage"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.editLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.languageList), function(language) {
	    return _c('option', {
	      domProps: {
	        "value": language.slug
	      }
	    }, [_vm._v(_vm._s(language.name))])
	  }))])]), _vm._v(" "), _vm._l((_vm.languageList), function(language) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (language.slug === _vm.editLanguage),
	        expression: "language.slug === editLanguage"
	      }],
	      staticClass: "localization columns"
	    }, [_c('div', {
	      staticClass: "column column-quill is-12"
	    }, [_c('p', {
	      staticClass: "control"
	    }, [_c('label', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s('Descrição [' + language.name + ']'))]), _vm._v(" "), _c('quill', {
	      ref: 'q1' + language.slug,
	      refInFor: true,
	      attrs: {
	        "options": _vm.quillOptions
	      }
	    })], 1), _vm._v(" "), (_vm.showPlusDetail) ? _c('p', {
	      staticClass: "control"
	    }, [_c('label', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s('Mais Detalhes [' + language.name + ']'))]), _vm._v(" "), _c('quill', {
	      ref: 'q2' + language.slug,
	      refInFor: true,
	      attrs: {
	        "options": _vm.quillOptions
	      }
	    })], 1) : _vm._e()])])
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isSubslide || (_vm.isSubslide && _vm.insertMode === 1)),
	      expression: "!isSubslide || (isSubslide && insertMode === 1)"
	    }],
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Foreground 1 "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v(_vm._s(_vm.foreground1Text))])]), _vm._v(" "), (!_vm.newForeground1 && _vm.slide.foreground_image_1) ? _c('figure', {
	    staticClass: "image is-16by9 slide-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.slide.foreground_image_1
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('foreground1')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "slideForeground1",
	      "url": _vm.dropzoneUploadUrl + '&type=' + _vm.foreground1Type,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadForeground1,
	      "vdropzone-removedfile": _vm.removeForeground1
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isSubslide || (_vm.isSubslide && _vm.insertMode === 1)),
	      expression: "!isSubslide || (isSubslide && insertMode === 1)"
	    }],
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Foreground 2 "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v(_vm._s(_vm.foreground2Text))])]), _vm._v(" "), (!_vm.newForeground2 && _vm.slide.foreground_image_2) ? _c('figure', {
	    staticClass: "image  slide-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.slide.foreground_image_2
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('foreground2')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "slideForeground2",
	      "url": _vm.dropzoneUploadUrl + '&type=' + _vm.foreground2Type,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadForeground2,
	      "vdropzone-removedfile": _vm.removeForeground2
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isSubslide && _vm.insertMode === 2),
	      expression: "isSubslide && insertMode === 2"
	    }],
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Foreground 1")]), _vm._v(" "), (!_vm.newForegroundVideo && _vm.slide.foreground_image_1) ? _c('figure', {
	    staticClass: "image fake-dropzone-video"
	  }, [_c('video', {
	    attrs: {
	      "width": "100%",
	      "height": "100%",
	      "controls": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": _vm.slide.foreground_image_1,
	      "type": "video/mp4"
	    }
	  }), _vm._v("\n            Your browser does not support the video tag.\n          ")]), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('foreground1')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "slideForegroundVideo",
	      "url": _vm.dropzoneUploadUrl + '&type=5',
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": ".mp4"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadForeground1,
	      "vdropzone-removedfile": _vm.removeForeground1
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Posição")]), _vm._v(" "), _c('div', {
	    staticClass: "select is-fullwidth"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.slide.order),
	      expression: "slide.order"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.slide.order = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.orderOptions), function(order) {
	    return _c('option', {
	      domProps: {
	        "value": order.id
	      }
	    }, [_vm._v(_vm._s(order.value))])
	  }))])])])], 2), _vm._v(" "), (_vm.previewReady) ? _c('div', {
	    staticClass: "content",
	    class: [_vm.showPreview ? '' : 'is-hidden'],
	    attrs: {
	      "id": "modal-preview-content"
	    }
	  }, [_c('div', {
	    staticClass: "control is-grouped"
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewLanguage),
	      expression: "previewLanguage"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.previewLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.languageList), function(language) {
	    return _c('option', {
	      domProps: {
	        "value": language.slug
	      }
	    }, [_vm._v(_vm._s(language.name))])
	  }))])]), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentDetail),
	      expression: "currentDetail"
	    }],
	    staticClass: "control"
	  }, [_c('a', {
	    staticClass: "button is-primary",
	    class: {
	      'is-outlined': _vm.showDetail
	    },
	    on: {
	      "click": function($event) {
	        _vm.showDetail = !_vm.showDetail
	      }
	    }
	  }, [_vm._v("\n          Detalhes\n        ")])])]), _vm._v(" "), _c('parallax-composite', {
	    attrs: {
	      "background1": _vm.menuBackground1 ? 'url(' + _vm.menuBackground1 + ')' : null,
	      "background2": _vm.menuBackground2 ? 'url(' + _vm.menuBackground2 + ')' : null,
	      "foreground1": _vm.slide.foreground_image_1 ? 'url(' + _vm.slide.foreground_image_1 + ')' : null,
	      "foreground2": _vm.slide.foreground_image_2 ? 'url(' + _vm.slide.foreground_image_2 + ')' : null,
	      "insertMode": _vm.insertMode,
	      "backgroundColor": _vm.menu.background_color,
	      "textboxColor": _vm.menu.textbox_color,
	      "textColor": _vm.menu.text_color,
	      "description": _vm.currentDescription,
	      "plusDetail": _vm.currentDetail,
	      "showDetail": _vm.showDetail,
	      "slide": _vm.slide.order - 1,
	      "category": _vm.slide.slide_category_id,
	      "editWidth": _vm.previewImageWidth
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "preview-text-box",
	    style: ({
	      background: this.menu.textbox_color
	    })
	  }, [_c('div', {
	    staticClass: "preview-description"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "preview-slide-name-warning"
	  }, [_c('span', {
	    staticClass: "preview-warning-text"
	  }, [_c('b', [_vm._v("Aviso:")]), _vm._v(" " + _vm._s(_vm.previewWarning))])])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', {
	    staticClass: "breadcrumb"
	  }, _vm._l((_vm.list), function(item, index) {
	    return _c('li', [(_vm.isLast(index)) ? _c('span', {
	      staticClass: "active"
	    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
	      attrs: {
	        "to": item.path
	      }
	    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "exterior-container"
	  }, [_c('div', {
	    staticClass: "title-with-selector h3-selector"
	  }, [_c('h3', {
	    staticClass: "subtitle"
	  }, [_c('b', [_vm._v(_vm._s('Slide Exterior ' + _vm.exterior.order))])]), _vm._v(" "), _c('state-selector', {
	    attrs: {
	      "selected": _vm.exterior ? parseInt(_vm.exterior.state) : null,
	      "target": _vm.exterior,
	      "update": 'exterior'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-3"
	  }, [_vm._m(0), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [(_vm.images.pt) ? _c('img', {
	    attrs: {
	      "src": _vm.images.pt
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_vm._m(1), _vm._v(" "), _c('figure', {
	    staticClass: "image is16by9 coach-image"
	  }, [(_vm.images.en) ? _c('img', {
	    attrs: {
	      "src": _vm.images.en
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_vm._m(2), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [(_vm.images.es) ? _c('img', {
	    attrs: {
	      "src": _vm.images.es
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_vm._m(3), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [(_vm.images.fr) ? _c('img', {
	    attrs: {
	      "src": _vm.images.fr
	    }
	  }) : _vm._e()])])]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('b', {
	    staticClass: "inline-lable"
	  }, [_vm._v("Posição:")]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.exterior.order == 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderExteriors(1)
	      }
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Topo")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.exterior.order == 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderExteriors(parseInt(_vm.exterior.order) - 1)
	      }
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("-1")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.exterior.order == _vm.exteriorTotal
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderExteriors(parseInt(_vm.exterior.order) + 1)
	      }
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("+1")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small",
	    class: {
	      'is-disabled': _vm.exterior.order == _vm.exteriorTotal
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorderExteriors(_vm.exteriorTotal)
	      }
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Fundo")])])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small is-primary",
	    on: {
	      "click": _vm.openExteriorEditModal
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Editar")])]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small is-danger",
	    on: {
	      "click": _vm.openExteriorDeleteModal
	    }
	  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Apagar")])]), _vm._v(" "), _c('hr')])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Imagem [PT]")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Imagem [EN]")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Imagem [ES]")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Imagem [FR]")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-up"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-up"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  })])
	}]}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isDataLoaded) ? _c('div', {
	    attrs: {
	      "id": "view-panorama-container"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid levebar-container"
	  }, [_c('nav', {
	    staticClass: "level app-levelbar"
	  }, [_c('div', {
	    staticClass: "level-left is-hidden-mobile"
	  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
	    attrs: {
	      "list": _vm.breadcrumbList
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.panorama) ? _c('panorama-container', {
	    attrs: {
	      "panoramaData": _vm.panorama
	    }
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Guardar',
	      "disableOk": true
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editLanguage),
	      expression: "editLanguage"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.editLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.languages), function(language) {
	    return _c('option', {
	      domProps: {
	        "value": language
	      }
	    }, [_vm._v(_vm._s(language.toUpperCase()))])
	  }))])]), _c('div', {
	    staticClass: "notification is-warning"
	  }, [_vm._v("Obrigatório preencher todas as línguas")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._l((_vm.languages), function(language) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (language === _vm.editLanguage),
	        expression: "language === editLanguage"
	      }],
	      staticClass: "localization columns"
	    }, [_c('div', {
	      staticClass: "column column-quill is-12"
	    }, [_c('p', {
	      staticClass: "control"
	    }, [_c('label', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s('Nome [' + language.toUpperCase() + ']'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.point.name[language]),
	        expression: "point.name[language]"
	      }],
	      staticClass: "input",
	      attrs: {
	        "type": "text",
	        "placeholder": "Nome do Ponto"
	      },
	      domProps: {
	        "value": (_vm.point.name[language])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          var $$exp = _vm.point.name,
	            $$idx = language;
	          if (!Array.isArray($$exp)) {
	            _vm.point.name[language] = $event.target.value
	          } else {
	            $$exp.splice($$idx, 1, $event.target.value)
	          }
	        }
	      }
	    })]), _vm._v(" "), _c('p', {
	      staticClass: "control"
	    }, [_c('label', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s('Descrição [' + language.toUpperCase() + ']'))]), _vm._v(" "), _c('quill', {
	      ref: 'q1' + language,
	      refInFor: true,
	      attrs: {
	        "options": _vm.quillOptions
	      }
	    })], 1)])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "nav app-navbar animated",
	    class: {
	      slideInDown: _vm.show, slideOutDown: !_vm.show
	    }
	  }, [_c('div', {
	    staticClass: "nav-left"
	  }, [_c('a', {
	    staticClass: "nav-item is-brand",
	    on: {
	      "click": function($event) {
	        _vm.goTo('/')
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(255),
	      "alt": "Museu Nacional dos Coches"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-center"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-toggle",
	    on: {
	      "click": function($event) {
	        _vm.showNavMenu = !_vm.showNavMenu
	      }
	    }
	  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
	    staticClass: "nav-right nav-menu",
	    class: {
	      'is-active': _vm.showNavMenu
	    }
	  }, [_c('a', {
	    staticClass: "nav-item",
	    on: {
	      "click": function($event) {
	        _vm.goTo('/')
	      }
	    }
	  }, [_vm._v("\n      Coches\n    ")]), _vm._v(" "), _c('a', {
	    staticClass: "nav-item",
	    on: {
	      "click": function($event) {
	        _vm.goTo('/users')
	      }
	    }
	  }, [_vm._v("\n      Utilizadores\n    ")]), _vm._v(" "), _c('tooltip', {
	    attrs: {
	      "label": "Logout",
	      "placement": "bottom"
	    }
	  }, [_c('span', {
	    staticClass: "nav-item logout-btn"
	  }, [_c('a', {
	    staticClass: "button is-primary",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.username))])])])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v("\n      Ao remover Sub-slides todo o seu "), _c('b', [_vm._v("conteúdo associado")]), _vm._v(" será também "), _c('b', [_vm._v("removido")]), _vm._v(".\n      "), _c('br'), _vm._v("Isto inclui "), _c('b', [_vm._v("Características e todos os Sub-slides")]), _vm._v(".\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Submeter',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content subslide-model",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editLanguage),
	      expression: "editLanguage"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.editLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.languageList), function(language) {
	    return _c('option', {
	      domProps: {
	        "value": language.slug
	      }
	    }, [_vm._v(_vm._s(language.name))])
	  }))])]), _vm._v(" "), _vm._l((_vm.languageList), function(language) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (language.slug === _vm.editLanguage),
	        expression: "language.slug === editLanguage"
	      }],
	      staticClass: "localization columns"
	    }, [_c('div', {
	      staticClass: "column is-half"
	    }, [_c('p', {
	      staticClass: "control"
	    }, [_c('label', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s('Texto do Botão [' + language.name + ']'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.category.local[language.slug].button),
	        expression: "category.local[language.slug].button"
	      }],
	      staticClass: "input is-expanded",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.category.local[language.slug].button)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.category.local[language.slug].button = $event.target.value
	        }
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "column is-half"
	    }, [_c('p', {
	      staticClass: "control"
	    }, [_c('label', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s('Título do Grupo [' + language.name + ']'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.category.local[language.slug].title),
	        expression: "category.local[language.slug].title"
	      }],
	      staticClass: "input is-expanded",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.category.local[language.slug].title)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.category.local[language.slug].title = $event.target.value
	        }
	      }
	    })])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor de Fundo")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.category.background_color.hex),
	      expression: "category.background_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.category.background_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.category.background_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextBackground === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('background')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextBackground))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input category-color-preview",
	    style: ({
	      backgroundColor: _vm.category.background_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor Caixa de Texto")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.category.textbox_color.hex),
	      expression: "category.textbox_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.category.textbox_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.category.textbox_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextTextbox === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('textbox')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextTextbox))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input category-color-preview",
	    style: ({
	      backgroundColor: _vm.category.textbox_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor do Texto")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.category.text_color.hex),
	      expression: "category.text_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.category.text_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.category.text_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextText === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('text')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextText))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input category-color-preview",
	    style: ({
	      backgroundColor: _vm.category.text_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('sketch-picker', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showColorPicker),
	      expression: "showColorPicker"
	    }],
	    class: 'color-picker-position-' + _vm.colorPickerPosition,
	    on: {
	      "input": _vm.onChangePickerColor
	    },
	    model: {
	      value: (_vm.pickerColor),
	      callback: function($$v) {
	        _vm.pickerColor = $$v
	      },
	      expression: "pickerColor"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Background 1 "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(*x1008px)")])]), _vm._v(" "), (!_vm.newBackground1 && _vm.category.background_image_1) ? _c('figure', {
	    staticClass: "image coach-image background-1 fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.category.background_image_1
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('background1')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "categoryBackground1",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 596,
	      "thumbnail-height": 150,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadBackground,
	      "vdropzone-removedfile": _vm.removeBackground
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Background 2 "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(*x1008px)")])]), _vm._v(" "), (!_vm.newBackground2 && _vm.category.background_image_2) ? _c('figure', {
	    staticClass: "image coach-image background-2 fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.category.background_image_2
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('background2')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "categoryBackground2",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 596,
	      "thumbnail-height": 150,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadForeground,
	      "vdropzone-removedfile": _vm.removeForeground
	    }
	  })], 1)])])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "view-exterior-container"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid levebar-container"
	  }, [_c('nav', {
	    staticClass: "level app-levelbar"
	  }, [_c('div', {
	    staticClass: "level-left is-hidden-mobile"
	  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
	    attrs: {
	      "list": _vm.breadcrumbList
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "view-exterior"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v("Lista de Slides de Exterior")]), _vm._v(" "), _c('div', {
	    staticClass: "exteriors-list-holder"
	  }, [_c('hr'), _vm._v(" "), _vm._l((_vm.exteriors), function(exterior) {
	    return _c('exterior-card', {
	      attrs: {
	        "exterior": exterior,
	        "exteriorTotal": _vm.exteriors.length
	      }
	    })
	  })], 2), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.openExteriorEditModal
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Criar")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	}]}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "view-slide-container"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid levebar-container"
	  }, [_c('nav', {
	    staticClass: "level app-levelbar"
	  }, [_c('div', {
	    staticClass: "level-left is-hidden-mobile"
	  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
	    attrs: {
	      "list": _vm.breadcrumbList
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "view-slide"
	    }
	  }, [(_vm.menu) ? _c('sub-menu-info', {
	    attrs: {
	      "menu": _vm.menu,
	      "title": "Características dos Sub-slides "
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-comp"
	  }), _vm._v(" "), _c('slide-list', {
	    attrs: {
	      "slides": _vm.slides,
	      "parent": _vm.parent_slide,
	      "menu": _vm.menu
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "view-login-container"
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.login($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid",
	    attrs: {
	      "id": "view-login"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "login-form-container"
	    }
	  }, [_c('p', {
	    staticClass: "control has-icon"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  }), _c('i', {
	    staticClass: "fa fa-envelope"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "control has-icon"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  }), _c('i', {
	    staticClass: "fa fa-lock"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "control",
	    attrs: {
	      "id": "login-btn-container"
	    }
	  }, [_c('button', {
	    staticClass: "btn-submit-login button is-success",
	    class: [_vm.btnIsLoading ? 'is-loading' : ''],
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("Login\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column",
	    attrs: {
	      "id": "logo-container"
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "logo",
	      "src": __webpack_require__(254)
	    }
	  })])
	}]}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "dropzone",
	    attrs: {
	      "action": _vm.url,
	      "id": _vm.id
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "button is-primary is-medium is-fullwidth",
	    on: {
	      "click": _vm.openNewCoachModal
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Criar")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	}]}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title
	    }
	  }, [_c('div', {
	    staticClass: "content coach-modal",
	    class: [_vm.showPreview ? 'is-hidden' : ''],
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Nome [PT]")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.name.pt),
	      expression: "coach.name.pt"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome do Coche"
	    },
	    domProps: {
	      "value": (_vm.coach.name.pt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.name.pt = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Nome [EN]")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.name.en),
	      expression: "coach.name.en"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome do Coche"
	    },
	    domProps: {
	      "value": (_vm.coach.name.en)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.name.en = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Nome [ES]")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.name.es),
	      expression: "coach.name.es"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome do Coche"
	    },
	    domProps: {
	      "value": (_vm.coach.name.es)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.name.es = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Nome [FR]")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.name.fr),
	      expression: "coach.name.fr"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome do Coche"
	    },
	    domProps: {
	      "value": (_vm.coach.name.fr)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.name.fr = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor de Fundo")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.background_color.hex),
	      expression: "coach.background_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.coach.background_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.background_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextBackground === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('background')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextBackground))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input coach-color-preview",
	    style: ({
	      backgroundColor: _vm.coach.background_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor de Titulo + Texto do Menu")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.title_color.hex),
	      expression: "coach.title_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.coach.title_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.title_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextTitle === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('title')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextTitle))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input coach-color-preview",
	    style: ({
	      backgroundColor: _vm.coach.title_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor Botões Inactivos")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.inactive_color.hex),
	      expression: "coach.inactive_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.coach.inactive_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.inactive_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextInactive === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('inactive')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextInactive))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input coach-color-preview",
	    style: ({
	      backgroundColor: _vm.coach.inactive_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor Botões Activos")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.active_color.hex),
	      expression: "coach.active_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.coach.active_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.active_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextActive === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('active')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextActive))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input coach-color-preview",
	    style: ({
	      backgroundColor: _vm.coach.active_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Cor de Separadores do Menu")]), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coach.filet_color.hex),
	      expression: "coach.filet_color.hex"
	    }],
	    staticClass: "input is-expanded",
	    attrs: {
	      "type": "text",
	      "placeholder": "Código de Cor (#HEX)",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.coach.filet_color.hex)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coach.filet_color.hex = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: [_vm.colorPickerBtnTextFilet === 'Fechar' ? 'is-outlined' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toogleColorPicker('filet')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextFilet))])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('input', {
	    staticClass: "input coach-color-preview",
	    style: ({
	      backgroundColor: _vm.coach.filet_color.hex
	    }),
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  })])]), _vm._v(" "), _c('sketch-picker', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showColorPicker),
	      expression: "showColorPicker"
	    }],
	    class: 'color-picker-position-' + _vm.colorPickerPosition,
	    on: {
	      "input": _vm.onChangePickerColor
	    },
	    model: {
	      value: (_vm.pickerColor),
	      callback: function($$v) {
	        _vm.pickerColor = $$v
	      },
	      expression: "pickerColor"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Background "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1920x1080px)")])]), _vm._v(" "), (!_vm.newBackground && _vm.coach.background_image) ? _c('figure', {
	    staticClass: "image is-16by9 coach-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coach.background_image
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('background')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "coachBackgroundDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadBackground,
	      "vdropzone-removedfile": _vm.removeBackground
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Foreground "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1920x1080px)")])]), _vm._v(" "), (!_vm.newForeground && _vm.coach.foreground_image) ? _c('figure', {
	    staticClass: "image is-16by9 coach-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coach.foreground_image
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('foreground')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "coachForegroundDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadForeground,
	      "vdropzone-removedfile": _vm.removeForeground
	    }
	  })], 1)])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "content",
	    class: [_vm.showPreview ? '' : 'is-hidden'],
	    attrs: {
	      "id": "modal-preview-content"
	    }
	  }, [_c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewLanguage),
	      expression: "previewLanguage"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.previewLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "pt"
	    }
	  }, [_vm._v("PT")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "en"
	    }
	  }, [_vm._v("EN")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "es"
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "fr"
	    }
	  }, [_vm._v("FR")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "coach-preview-image",
	    attrs: {
	      "onresize": "handleResize"
	    }
	  }, [_c('figure', {
	    staticClass: "image",
	    style: ({
	      backgroundColor: _vm.coach.background_color.hex
	    }),
	    attrs: {
	      "id": "coach-image-preview-container"
	    }
	  }, [_c('image-composite', {
	    attrs: {
	      "background": _vm.coach.background_image,
	      "foreground": _vm.coach.foreground_image,
	      "showLogo": true,
	      "logoColor": _vm.backgroundLightness
	    }
	  })], 1)]), _vm._v(" "), (_vm.previewText) ? _c('div', {
	    staticClass: "preview-coach-name",
	    style: ({
	      color: _vm.coach.title_color.hex,
	      transform: _vm.textZoom,
	      left: _vm.leftScale
	    })
	  }, [_vm._v(_vm._s(_vm.previewText))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "circle-container",
	    style: ({
	      transform: _vm.textZoom
	    })
	  }, [_c('div', {
	    staticClass: "circle circle-home",
	    style: (_vm.previewActiveStyle)
	  }, [_c('span', {
	    staticClass: "mnc mnc-MncApplicationFont_home"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "circle",
	    style: ([_vm.isSelectedLanguage('pt') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
	  }, [_c('span', {
	    staticClass: "mnc mnc-MncApplicationFont_pt"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "circle",
	    style: ([_vm.isSelectedLanguage('en') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
	  }, [_c('span', {
	    staticClass: "mnc mnc-MncApplicationFont_en"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "circle",
	    style: ([_vm.isSelectedLanguage('fr') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
	  }, [_c('span', {
	    staticClass: "mnc mnc-MncApplicationFont_fr"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "circle",
	    style: ([_vm.isSelectedLanguage('es') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
	  }, [_c('span', {
	    staticClass: "mnc mnc-MncApplicationFont_es"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "menu-container",
	    style: ({
	      transform: _vm.textZoom
	    })
	  }, [_c('div', {
	    staticClass: "filet",
	    style: ({
	      background: _vm.coach.filet_color.hex
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "menu-btn-container"
	  }, [_c('div', {
	    staticClass: "menu-btn-text",
	    style: ({
	      color: _vm.coach.title_color.hex
	    })
	  }, [_vm._v("TEXTO MENU")]), _vm._v(" "), _c('div', {
	    staticClass: "circle",
	    style: (_vm.previewInactiveStyle)
	  }, [_c('span', {
	    staticClass: "mnc mnc-MncApplicationFont_forward"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "filet",
	    style: ({
	      background: _vm.coach.filet_color.hex
	    })
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "preview-coach-name-warning"
	  }, [_c('span', {
	    staticClass: "preview-warning-text"
	  }, [_c('b', [_vm._v("Aviso:")]), _vm._v(" " + _vm._s(_vm.previewWarning))])])])])
	},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('div', {
	    staticClass: "title-with-selector h1-selector"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.menu.languages[0].pivot.name))]), _vm._v(" "), _c('state-selector', {
	    attrs: {
	      "selected": _vm.menu ? parseInt(_vm.menu.state_id) : null,
	      "target": _vm.menu,
	      "update": 'menu-slides'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.menu.background_color) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.menu.background_color
	    })
	  })])])]), _vm._v(" "), (_vm.showTextboxColor) ? _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor Caixa de Texto")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.menu.textbox_color) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.menu.textbox_color
	    })
	  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor do Texto")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n            " + _vm._s(_vm.menu.text_color) + "\n            "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.menu.text_color
	    })
	  })])])])]), _vm._v(" "), (_vm.menu.slug !== 'panorama') ? _c('div', {
	    staticClass: "columns is-multiline"
	  }, [(_vm.menu.background_path_1) ? _c('div', {
	    staticClass: "column is-12"
	  }, [_vm._m(0), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coachImagePath + _vm.menu.background_path_1
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.menu.background_path_2) ? _c('div', {
	    staticClass: "column is-12"
	  }, [_vm._m(1), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coachImagePath + _vm.menu.background_path_2
	    }
	  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.editCoachEditCategoryModal
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Editar")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background 1")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background 2")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	}]}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "parallax-comp-container"
	  }, [_c('div', {
	    staticClass: "parallax-comp transparent position-relative",
	    style: ({
	      width: _vm.imageWidth + 'px',
	      height: _vm.imageHeight + 'px',
	      background: _vm.backgroundColor
	    })
	  }, [(_vm.insertMode === 1) ? _c('div', {
	    staticClass: "imageBck",
	    style: ({
	      backgroundImage: _vm.transparent
	    })
	  }) : _vm._e(), _vm._v(" "), (_vm.insertMode === 2) ? _c('div', {
	    staticClass: "imageBck",
	    style: ({
	      background: 'black'
	    })
	  }) : _vm._e()]), _vm._v(" "), (_vm.insertMode === 1 && _vm.background1) ? _c('div', {
	    staticClass: "parallax-comp background-1 position-absolute",
	    style: ({
	      width: _vm.imageWidth + 'px',
	      height: _vm.imageHeight + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "imageBck",
	    style: ({
	      backgroundImage: _vm.background1,
	      backgroundPositionX: _vm.background1Offset + 'px'
	    })
	  })]) : _vm._e(), _vm._v(" "), (_vm.insertMode === 1 && _vm.background2) ? _c('div', {
	    staticClass: "parallax-comp background-2 position-absolute",
	    style: ({
	      width: _vm.imageWidth + 'px',
	      height: _vm.imageHeight + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "imageBck",
	    style: ({
	      backgroundImage: _vm.background2,
	      backgroundPositionX: _vm.background2Offset + 'px'
	    })
	  })]) : _vm._e(), _vm._v(" "), (_vm.insertMode === 1 && _vm.foreground1) ? _c('div', {
	    staticClass: "parallax-comp foreground-1 position-absolute",
	    style: ({
	      width: _vm.imageWidth + 'px',
	      height: _vm.imageHeight + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "imageBck",
	    style: ({
	      backgroundImage: _vm.foreground1
	    })
	  })]) : _vm._e(), _vm._v(" "), (_vm.insertMode === 1 && _vm.foreground2) ? _c('div', {
	    staticClass: "parallax-comp foreground-2 position-absolute",
	    style: ({
	      width: _vm.imageWidth + 'px',
	      height: _vm.imageHeight + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "imageBck",
	    style: ({
	      backgroundImage: _vm.foreground2,
	      backgroundPositionX: _vm.foreground2Offset + 'px'
	    })
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    staticClass: "parallax-textbox",
	    class: _vm.textboxClass,
	    style: ({
	      background: _vm.textboxColor,
	      transform: _vm.textboxZoom,
	      top: _vm.textboxPosition ? _vm.textboxPosition.top + 'px' : 0,
	      bottom: _vm.textboxPosition ? _vm.textboxPosition.bottom + 'px' : 0,
	      left: _vm.textboxPosition ? _vm.textboxPosition.left + 'px' : 0
	    })
	  }, [_c('div', {
	    staticClass: "parallax-text",
	    class: _vm.textClass,
	    style: ({
	      color: _vm.textColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.textboxText)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-color__editable-input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.val),
	      expression: "val"
	    }],
	    staticClass: "vue-color__editable-input__input",
	    domProps: {
	      "value": (_vm.val)
	    },
	    on: {
	      "keydown": _vm.handleKeyDown,
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.val = $event.target.value
	      }, _vm.update]
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "vue-color__editable-input__label"
	  }, [_vm._v(_vm._s(_vm.label))])])
	},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "quill-editor"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container is-fluid container-margin-top"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('h1', [_vm._v("Menus Associados ao Coche")]), _vm._v(" "), _vm._l((_vm.coachCategories), function(category) {
	    return (_vm.isDataLoaded) ? _c('div', [_c('div', {
	      staticClass: "title-with-selector h3-selector"
	    }, [_c('h3', {
	      staticClass: "subtitle"
	    }, [_c('b', [_vm._v(_vm._s(category.languages[0].pivot.name))])]), _vm._v(" "), _c('state-selector', {
	      attrs: {
	        "selected": category ? parseInt(category.state_id) : null,
	        "target": category,
	        "update": 'menu'
	      }
	    })], 1), _vm._v(" "), (category.slug !== 'panorama') ? _c('div', {
	      staticClass: "columns"
	    }, [_c('div', {
	      staticClass: "column is-one-quarter"
	    }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "flex-container-center"
	    }, [_vm._v("\n              " + _vm._s(category.background_color) + "\n              "), _c('div', {
	      staticClass: "color-preview",
	      style: ({
	        backgroundColor: category.background_color
	      })
	    })])])]), _vm._v(" "), (category.slug !== 'eraumavez') ? _c('div', {
	      staticClass: "column is-one-quarter"
	    }, [_c('div', [_c('b', [_vm._v("Cor Caixa de Texto")]), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "flex-container-center"
	    }, [_vm._v("\n              " + _vm._s(category.textbox_color) + "\n              "), _c('div', {
	      staticClass: "color-preview",
	      style: ({
	        backgroundColor: category.textbox_color
	      })
	    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "column is-one-quarter"
	    }, [_c('div', [_c('b', [_vm._v("Cor do Texto")]), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "flex-container-center"
	    }, [_vm._v("\n              " + _vm._s(category.text_color) + "\n              "), _c('div', {
	      staticClass: "color-preview",
	      style: ({
	        backgroundColor: category.text_color
	      })
	    })])])])]) : _vm._e(), _vm._v(" "), (category.slug !== 'panorama') ? _c('div', {
	      staticClass: "columns is-multiline"
	    }, [(category.background_path_1) ? _c('div', {
	      staticClass: "column is-12"
	    }, [_vm._m(0, true), _vm._v(" "), _c('figure', {
	      staticClass: "image coach-image"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.imagePath + category.background_path_1
	      }
	    })])]) : _vm._e(), _vm._v(" "), (category.background_path_2) ? _c('div', {
	      staticClass: "column is-12"
	    }, [_vm._m(1, true), _vm._v(" "), _c('figure', {
	      staticClass: "image coach-image"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.imagePath + category.background_path_2
	      }
	    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (category.slug === 'panorama') ? _c('div', {
	      staticClass: "columns"
	    }, [_c('div', {
	      staticClass: "column is-one-quarter"
	    })]) : _vm._e(), _vm._v(" "), (category.slug !== 'panorama') ? _c('a', {
	      staticClass: "button is-small is-info",
	      on: {
	        "click": function($event) {
	          _vm.goToSlide(category.id)
	        }
	      }
	    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Slides")])]) : _vm._e(), _vm._v(" "), (category.slug === 'panorama') ? _c('a', {
	      staticClass: "button is-small is-info",
	      on: {
	        "click": function($event) {
	          _vm.goToPanorama()
	        }
	      }
	    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v("Panorama")])]) : _vm._e(), _vm._v(" "), (category.slug === 'panorama') ? _c('a', {
	      staticClass: "button is-small is-info",
	      on: {
	        "click": function($event) {
	          _vm.goToExterior()
	        }
	      }
	    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Exterior")])]) : _vm._e(), _vm._v(" "), (category.slug !== 'panorama') ? _c('a', {
	      staticClass: "button is-small is-primary",
	      on: {
	        "click": function($event) {
	          _vm.editCoachEditCategoryModal(category)
	        }
	      }
	    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "button is-small is-danger",
	      on: {
	        "click": function($event) {
	          _vm.removeCoachDeleteCategoryModal(category)
	        }
	      }
	    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v("Apagar")])]), _vm._v(" "), _c('hr')]) : _vm._e()
	  }), _vm._v(" "), (_vm.slideCategories ? _vm.slideCategories.length : null) ? _c('div', [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Adicionar Menu ao Coche")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCategory),
	      expression: "selectedCategory"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.slideCategories), function(category) {
	    return _c('option', {
	      domProps: {
	        "value": parseInt(category.id)
	      }
	    }, [_vm._v(_vm._s(category.languages[0].pivot.name))])
	  }))]), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    class: {
	      'is-disabled': !_vm.selectedCategorySlug
	    },
	    on: {
	      "click": _vm.addCoachEditCategoryModal
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Adicionar")])])])]) : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background 1")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background 2")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	}]}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "control has-icon search-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchString),
	      expression: "searchString"
	    }],
	    staticClass: "input is-medium",
	    attrs: {
	      "type": "text",
	      "placeholder": "Procurar Utilizadores"
	    },
	    domProps: {
	      "value": (_vm.searchString)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchString = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-search"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Guardar',
	      "disableOk": true
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [(_vm.userLoggedAdmin) ? _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('div', {
	    staticClass: "swicth-container"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Administrador")]), _vm._v(" "), _c('vb-switch', {
	    attrs: {
	      "type": "primary",
	      "checked": _vm.userData && !!parseInt(_vm.userData.admin)
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Nome de utilizador")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.name),
	      expression: "user.name"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nome"
	    },
	    domProps: {
	      "value": (_vm.user.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.name = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Email",
	      "disabled": _vm.disableEmail
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Nova password")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.newPassword),
	      expression: "user.newPassword"
	    }],
	    staticClass: "input password-input",
	    class: {
	      'is-danger': _vm.passwordMissmatch
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "Nova password"
	    },
	    domProps: {
	      "value": (_vm.user.newPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.newPassword = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Repetir password")]), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.newPasswordRepeat),
	      expression: "user.newPasswordRepeat"
	    }],
	    staticClass: "input password-input",
	    class: {
	      'is-danger': _vm.passwordMissmatch
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "Repetir password"
	    },
	    domProps: {
	      "value": (_vm.user.newPasswordRepeat)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.newPasswordRepeat = $event.target.value
	      }
	    }
	  })])])])])])
	},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('div', {
	    staticClass: "title-with-selector h1-selector"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.menu ? _vm.menu.languages[0].pivot.name : null))]), _vm._v(" "), _c('state-selector', {
	    attrs: {
	      "selected": _vm.menu ? parseInt(_vm.menu.state_id) : null,
	      "target": _vm.menu,
	      "update": "menu-slides"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "columns is-multiline"
	  }, [_c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Texto do Botão [PT]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[0].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[0].pivot.popup_button) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Texto do Botão [EN]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[1].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[1].pivot.popup_button) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Texto do Botão [ES]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[2].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[2].pivot.popup_button) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Texto do Botão [FR]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[3].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[3].pivot.popup_button) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Título do Grupo [PT]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[0].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[0].pivot.name) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Título do Grupo [EN]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[1].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[1].pivot.name) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Título do Grupo [ES]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[2].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[2].pivot.name) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "column is-3"
	  }, [_c('b', [_vm._v("Título do Grupo [FR]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[3].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[3].pivot.name) ? _c('div', {
	    staticClass: "placeholder-slide-text"
	  }, [_vm._v("não definido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n              " + _vm._s(_vm.menu.background_color) + "\n              "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.menu.background_color
	    })
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor Caixa de Texto")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n              " + _vm._s(_vm.menu.textbox_color) + "\n              "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.menu.textbox_color
	    })
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-one-quarter"
	  }, [_c('div', [_c('b', [_vm._v("Cor do Texto")]), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "flex-container-center"
	  }, [_vm._v("\n              " + _vm._s(_vm.menu.text_color) + "\n              "), _c('div', {
	    staticClass: "color-preview",
	    style: ({
	      backgroundColor: _vm.menu.text_color
	    })
	  })])])])]), _vm._v(" "), (_vm.menu.slug !== 'panorama') ? _c('div', {
	    staticClass: "columns is-multiline"
	  }, [(_vm.menu.background_path_1) ? _c('div', {
	    staticClass: "column is-12"
	  }, [_vm._m(0), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coachImagePath + _vm.menu.background_path_1
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.menu.background_path_2) ? _c('div', {
	    staticClass: "column is-12"
	  }, [_vm._m(1), _vm._v(" "), _c('figure', {
	    staticClass: "image coach-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.coachImagePath + _vm.menu.background_path_2
	    }
	  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.openSlideSetEditModal
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Editar")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background 1")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Background 2")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	}]}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": _vm.transition,
	      "mode": "in-out",
	      "appear": "",
	      "appear-active-class": _vm.enterClass,
	      "enter-active-class": _vm.enterClass,
	      "leave-active-class": _vm.leaveClass
	    },
	    on: {
	      "after-leave": _vm.afterLeave
	    }
	  }, [(_vm.show) ? _c('div', {
	    class: ['modal', 'animated', _vm.show ? 'is-active' : '']
	  }, [_c('div', {
	    staticClass: "modal-background",
	    on: {
	      "click": function($event) {}
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal-card"
	  }, [_c('header', {
	    staticClass: "modal-card-head"
	  }, [_c('p', {
	    staticClass: "modal-card-title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
	    staticClass: "delete",
	    on: {
	      "click": _vm.cancel
	    }
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "modal-card-body"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('footer', {
	    staticClass: "modal-card-foot"
	  }, [_c('a', {
	    staticClass: "button card-modal-ok-btn is-primary",
	    class: {
	      'is-disabled': _vm.disableOk, 'is-loading': _vm.btnIsLoading
	    },
	    on: {
	      "click": _vm.ok
	    }
	  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), (_vm.showPreview) ? _c('a', {
	    staticClass: "button card-modal-preview-btn is-info",
	    class: {
	      'is-disabled': _vm.disablePreview
	    },
	    on: {
	      "click": _vm.preview
	    }
	  }, [_vm._v(_vm._s(_vm.previewText))]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "button card-modal-cancel-btn",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v("\n      Ao remover um menu todo o seu "), _c('b', [_vm._v("conteúdo associado")]), _vm._v(" será também "), _c('b', [_vm._v("removido")]), _vm._v(".\n      "), _c('br'), _vm._v("Isto inclui "), _c('b', [_vm._v("Cores, Imagens e Slides/Panoramas")]), _vm._v(".\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v("\n\t\tTem a certeza que pretende apagar este slide exterior?\n      ")])])])
	},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    class: [_vm.showNavBar ? 'app-main' : 'no-nav-app-main']
	  }, [_c('div', {
	    staticClass: "container is-fluid is-marginless",
	    class: [_vm.showNavBar ? 'app-content' : 'no-nav-app-content']
	  }, [_c('transition', {
	    attrs: {
	      "mode": "out-in",
	      "enter-active-class": "fadeIn",
	      "leave-active-class": "fadeOut",
	      "appear": ""
	    }
	  }, [_c('router-view', {
	    staticClass: "animated"
	  })], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "button is-primary is-medium is-fullwidth",
	    on: {
	      "click": _vm.editUser
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Criar")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	}]}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "view-users-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "view-users"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "columns users-toolbar"
	  }, [_c('div', {
	    staticClass: "column is-10"
	  }, [_c('p', {
	    staticClass: "control has-icon search-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchString),
	      expression: "searchString"
	    }],
	    staticClass: "input is-medium",
	    attrs: {
	      "type": "text",
	      "placeholder": "Procurar Utilizadores"
	    },
	    domProps: {
	      "value": (_vm.searchString)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchString = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-search"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-2"
	  }, [_c('user-new')], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "container is-fluid"
	  }, [_c('div', {
	    staticClass: "flexbox-grid"
	  }, _vm._l((_vm.users), function(user) {
	    return _c('user-card', {
	      attrs: {
	        "user": user
	      }
	    })
	  }))])])])
	},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "image-comp-container"
	  }, [(_vm.background) ? _c('div', {
	    staticClass: "image-comp-single-1 position-relative"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.background
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.foreground) ? _c('div', {
	    staticClass: "image-comp-single-2",
	    class: [_vm.background ? 'position-absolute' : 'position-relative']
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.foreground
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.showLogo) ? _c('div', {
	    staticClass: "image-comp-logo",
	    class: [_vm.background || _vm.foreground ? 'position-absolute' : 'position-relative']
	  }, [(_vm.logoColor >= 0.5) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(252)
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(253)
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "not"
	  }, [_vm._v("404, Not Found.")])
	},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "nprogress-container"
	  })
	},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "disableOk": true,
	      "showPreview": false
	    }
	  }, [_c('div', {
	    staticClass: "content exterior-content-modal",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Imagem [PT] "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1848x1008px)")])]), _vm._v(" "), (!_vm.newImagePT && _vm.exterior.images.pt.url) ? _c('figure', {
	    staticClass: "image is-16by9 coach-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.exterior.images.pt.url
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('imagePT')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "imagePTDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadPT,
	      "vdropzone-removedfile": _vm.removePT
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Imagem [EN] "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1848x1008px)")])]), _vm._v(" "), (!_vm.newImageEN && _vm.exterior.images.en.url) ? _c('figure', {
	    staticClass: "image is-16by9 coach-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.exterior.images.en.url
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('imageEN')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "imageENDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadEN,
	      "vdropzone-removedfile": _vm.removeEN
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Imagem [ES] "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1848x1008px)")])]), _vm._v(" "), (!_vm.newImageES && _vm.exterior.images.es.url) ? _c('figure', {
	    staticClass: "image is-16by9 coach-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.exterior.images.es.url
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('imageES')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "imageESDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadES,
	      "vdropzone-removedfile": _vm.removeES
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Imagem [FR] "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1848x1008px)")])]), _vm._v(" "), (!_vm.newImageFR && _vm.exterior.images.fr.url) ? _c('figure', {
	    staticClass: "image is-16by9 coach-image fake-dropzone"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.exterior.images.fr.url
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": function($event) {
	        _vm.showDropzone('imageFR')
	      }
	    }
	  }, [_vm._v("Remover")])]) : _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "imageFRDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": "image/*"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadFR,
	      "vdropzone-removedfile": _vm.removeFR
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Posição")]), _vm._v(" "), _c('div', {
	    staticClass: "select is-fullwidth"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.exterior.order),
	      expression: "exterior.order"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.exterior.order = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.orderOptions), function(order) {
	    return _c('option', {
	      domProps: {
	        "value": order.id
	      }
	    }, [_vm._v(_vm._s(order.value))])
	  }))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v("\n      Ao remover um slide todo o seu "), _c('b', [_vm._v("conteúdo associado")]), _vm._v(" será também "), _c('b', [_vm._v("removido")]), _vm._v(".\n      "), (!_vm.is_sub) ? _c('span', [_c('br'), _vm._v("Isto inclui "), _c('b', [_vm._v("Slide, Características de Sub-slides e todos os Sub-slides")]), _vm._v(".")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container is-fluid container-margin-top"
	  }, [_c('div', {
	    staticClass: "content content-padding"
	  }, [_c('h1', [_vm._v("Screensaver do Coche")]), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [(_vm.coach && _vm.coach.screensaver_path) ? _c('div', {
	    staticClass: "column is-half"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Video")]), _vm._v(" "), _c('video', {
	    attrs: {
	      "width": "100%",
	      "height": "100%",
	      "controls": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": _vm.screensaverLocation + _vm.coach.screensaver_path,
	      "type": "video/mp4"
	    }
	  }), _vm._v("\n          Your browser does not support the video tag.\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.coach && !_vm.coach.screensaver_path) ? _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.openCoachScreensaverModal
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Adicionar")])]) : _vm._e(), _vm._v(" "), (_vm.coach && _vm.coach.screensaver_path) ? _c('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": _vm.openCoachScreensaverModal
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Editar")])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  })])
	}]}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isDataLoaded) ? _c('div', {
	    attrs: {
	      "id": "view-coache-container"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid levebar-container"
	  }, [_c('nav', {
	    staticClass: "level app-levelbar"
	  }, [_c('div', {
	    staticClass: "level-left is-hidden-mobile"
	  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
	    attrs: {
	      "list": _vm.breadcrumbList
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "view-coach"
	    }
	  }, [_c('coach-info', {
	    attrs: {
	      "coach": _vm.coach
	    }
	  }), _vm._v(" "), _c('coach-screensaver', {
	    attrs: {
	      "coach": _vm.coach
	    }
	  }), _vm._v(" "), _c('coach-categories')], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('nprogress-container'), _vm._v(" "), (_vm.showNavBar) ? _c('nav-bar', {
	    attrs: {
	      "show": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('app-main')], 1)
	},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-color__c-alpha"
	  }, [_c('div', {
	    staticClass: "vue-color__c-alpha__checkboard-wrap"
	  }, [_c('checkboard')], 1), _vm._v(" "), _c('div', {
	    staticClass: "vue-color__c-alpha__gradient",
	    style: ({
	      background: _vm.gradientColor
	    })
	  }), _vm._v(" "), _c('div', {
	    ref: "container",
	    staticClass: "vue-color__c-alpha__container",
	    on: {
	      "mousedown": _vm.handleMouseDown,
	      "touchmove": _vm.handleChange,
	      "touchstart": _vm.handleChange
	    }
	  }, [_c('div', {
	    staticClass: "vue-color__c-alpha__pointer",
	    style: ({
	      left: _vm.colors.a * 100 + '%'
	    })
	  }, [_c('div', {
	    staticClass: "vue-color__c-alpha__picker"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "state-selector"
	  }, [_c('a', {
	    staticClass: "button is-small is-danger",
	    class: {
	      'is-outlined': this.selected !== 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateState(1)
	      }
	    }
	  }, [_vm._v("Rascunho")]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small is-warning",
	    class: {
	      'is-outlined': this.selected !== 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateState(2)
	      }
	    }
	  }, [_vm._v("Pendente")]), _vm._v(" "), _c('a', {
	    staticClass: "button is-small is-success",
	    class: {
	      'is-outlined': this.selected !== 3
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateState(3)
	      }
	    }
	  }, [_vm._v("Publicado")])])
	},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v("\n      Coches apagados deixarão de estar acessíveis através desta interface.\n      "), _c('br'), _vm._v("Estes poderão ser reactivados se necessário.\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v("\n\t\tTem a certeza que pretende apagar este utlizador?\n      ")])])])
	},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    class: [_vm.showPreview ? 'is-hidden' : ''],
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-12"
	  }, [_c('label', {
	    staticClass: "label"
	  }, [_vm._v("Video "), _c('span', {
	    staticClass: "font-weight-light"
	  }, [_vm._v("(1920x1080px .mp4)")])]), _vm._v(" "), (_vm.coachVideo) ? _c('figure', {
	    staticClass: "image fake-dropzone-video"
	  }, [_c('video', {
	    attrs: {
	      "width": "100%",
	      "height": "100%",
	      "controls": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": _vm.screensaverLocation + _vm.coachVideo,
	      "type": "video/mp4"
	    }
	  }), _vm._v("\n            Your browser does not support the video tag.\n          ")]), _vm._v(" "), _c('a', {
	    staticClass: "dz-remove",
	    on: {
	      "click": _vm.showDropzone
	    }
	  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (!_vm.coachVideo) ? _c('p', {
	    staticClass: "control"
	  }, [_c('dropzone', {
	    staticClass: "marginless-dropzone dz-dom",
	    attrs: {
	      "id": "coachVideoDz",
	      "url": _vm.dropzoneUploadUrl,
	      "thumbnail-width": 286,
	      "thumbnail-height": 161,
	      "acceptedFileTypes": ".mp4"
	    },
	    on: {
	      "vdropzone-success": _vm.successUploadVideo,
	      "vdropzone-removedfile": _vm.removeVideo
	    }
	  })], 1) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isDataLoaded) ? _c('div', {
	    attrs: {
	      "id": "view-slide-container"
	    }
	  }, [_c('div', {
	    staticClass: "container is-fluid levebar-container"
	  }, [_c('nav', {
	    staticClass: "level app-levelbar"
	  }, [_c('div', {
	    staticClass: "level-left is-hidden-mobile"
	  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
	    attrs: {
	      "list": _vm.breadcrumbList
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "view-slide"
	    }
	  }, [(_vm.menu) ? _c('menu-info', {
	    attrs: {
	      "menu": _vm.menu
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-comp"
	  }), _vm._v(" "), _c('slide-list', {
	    attrs: {
	      "slides": _vm.slides,
	      "menu": _vm.menu
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-color__c-checkerboard",
	    style: ({
	      background: _vm.bgStyle
	    })
	  })
	},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('card-modal', {
	    attrs: {
	      "visible": true,
	      "title": _vm.title,
	      "showPreview": false,
	      "okText": 'Confirmar',
	      "disableOk": false
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "modal-edit-content"
	    }
	  }, [_c('span', {
	    staticClass: "icon is-large modal-center-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "has-text-centered"
	  }, [_vm._v(_vm._s(_vm.warningText))])])])
	},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": _vm.transition,
	      "mode": "in-out",
	      "appear": "",
	      "appear-active-class": _vm.enterClass,
	      "enter-active-class": _vm.enterClass,
	      "leave-active-class": _vm.leaveClass
	    },
	    on: {
	      "after-leave": _vm.afterLeave
	    }
	  }, [(_vm.show) ? _c('div', {
	    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
	  }, [_c('button', {
	    staticClass: "delete touchable",
	    on: {
	      "click": function($event) {
	        _vm.close()
	      }
	    }
	  }), _vm._v(" "), (_vm.title) ? _c('div', {
	    staticClass: "title is-5"
	  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.df2279728a95ea05295f.js